import React, { useCallback, useContext, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { useForm } from "react-hook-form";

import { SearchIcon, EditQc, DeleteQc, SiteDefault, SiteSelected, InterfaceDisable, InterfaceDefault, InterfaceSelected, DevicesDisable, DevicesDefault, DevicesSelected, AddNode, SearchIconWhite, RemoveIcon, EditRowBlue, DeleteRowBlue, CheckRowBlue, CancelRowBlue, RightArrow } from '../../../../assets/images'

import Swal from "sweetalert2";
import { OverlayTrigger, Tab, Tabs } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import Modal from "react-bootstrap/Modal";
import { Mention, MentionsInput } from "react-mentions";

import { addCustomerName, getStateDetails, getInterfaceSubTypeData, deviceconfigcrud, getEmergencyContactsBysite, deleteEmergencyContactsBysite, getCategoryIdlist, getDeviceTypeOnInterfaceId,getDeviceStagedata } from "../../../../services/configurationServices";
import { SuccessToast } from "../../../../CustomHooks/SuccessToast";
import { HIDE_STUFF, HM_SELECT_SITE, MULTI_TIME_ZONE } from "../../../../config";
import CameraBulkUpload from "../Common/CameraBulkUpload";
import PanelBulkUpload from "../Common/PanelBulkUpload";
import ConfigurePanelZones from "../Common/ConfigurePanelZones";
import AssociateCameraOnSensor from "../Common/AssociateCameraOnSensor";
import AddERTForm from "../Common/AddERTForm";
import { GetmultiTimeZone } from "../../../../services/multiTimeZoneService";
import { ConvertDateToUTC } from "../../../../utils/utils";
import { ErrorToast } from "../../../../CustomHooks/ErrorToast";
import AcsBulkUpload from "../Common/AcsBulkUpload";
import EmergencyContactForm from "./EmergencyContactForm"
import SiteMap from "./SiteMap";
import AddZoneForm from "../ZoneConfig/AddZoneForm";
import { ConfigurationContext } from "../../../../Context/ConfigurationContext";
import PanelLicense from "../PanelLicense";

let tempSiteObj = {
  "SiteID": 0,
  "SiteName": '',
  "BranchID": '',
  "SiteAddress": '',
  "clientID": 0,
  "AddCustomerName": '',
  "CountryName": 0,
  "StateName": 0,
  "CityName": '',
  "SiteRegionName": '',
  "SitePincode": '',
  "SiteArea": '',
  "SiteModeID": 0
}

let interfaceObj = {
  "siteid": 0,
  "InterfaceId": 0,
  "InterfaceName": '',
  "InterfaceType": 0,
  "InterfaceSubType": 0,
  "InterfaceIP": '',
  "InterfacePort": '',
  "InterfaceUsername": '',
  "InterfacePassword": '',
  "UserId": 0,
  "EntityTypeID": 0,
  "CCTVTypeIDInterface": 0,
  "InterfaceTwoWayEnabled": '',
  "CheckInternalHooter": 0,
  "CheckExternalHooter": 0,
  "IsHooterEnabled": 0,
  "PlaybackTimeStampsToUTC": '',
  "PlaybackLongDateFormat": '',
  "LiveRTSPURL": '',
  "PlaybackRTSPURL": '',
  "CCTVType": '',
  "TimeZoneId": 0,
  "deviceTypeId": 0,
  "communicationPortInterface": '',
  "httpPortInterface":''
}

const AddSiteForm = React.forwardRef((props, ref, allRecords, setFilteredRecords) => {
  let {
    onSubmit,
    site,
    isSiteEdit,
    setIsSiteEdit,
    //getCliets,
    siteTypes,
    country,
    countryState,
    setCountryState,
    onSelectSite,
    ertLevels,
    siteERTOnClick,
    selectedERT,
    onAddERTMemberClick,
    addNewERTMemberClick,
    emeContactList,
    onDeleteERT,
    userOptions,
    onUserRoleChange,
    selectedUserRole,
    setSelectedUserRole,
    siteUserFieldsVisibility,
    filteredSites,
    cameradeviceslist,
    onDeviceSelection,
    selectedDevice,
    devicesmasterlist,
    isSubmitting,
    sites,
    OnAddIDSPanel,
    deleteZone,
    paneldeviceslist,
    OnSaveDevice,
    onSearchChange,
    setSelectedSite,
    setSelectedDevice,
    onDeleteChange,
    checkForAlertsAndDelDevice,
    getdeviceslistdata,
    interfaceTypeData,
    interfaceSubTypeData,
    setInterfaceSubTypeData,
    interfaceDataList,
    onInterfaceFormSubmit,
    onSelectInterface,
    interfaceDevice,
    setSelectedInterface,
    bulkUpload,
    setBulkUpload,
    setIsSingleOrBulkSelection,
    setBulkDevToUpload,
    selectedCamHeaders,
    OnAddBulkDevicesClick,
    setSelectedCamHeaders,
    clearImportedCamHeaders,
    deviceBulkUploadResponse,
    setImportedFileData,
    setDeviceBulkUploadResponse,
    isInterfaceEdit,
    isDeviceEdit,
    setIsInterfaceEdit,
    setIsDeviceEdit,
    getInterfaceData,
    onDeleteInterfaceChange,
    selectedHeaders,
    onPanelBulkUpload,
    setSelectedHeaders,
    clearImportedPanelHeaders,
    panelBulkUploadResponse,
    panelBulkUploadError,
    setPanelBulkUploadResponse,
    setPanelBulkUploadError,
    setFilteredSites,
    importedFileHeaders,
    setImportedFileHeaders,
    importedPanelHeaders,
    setImportedPanelHeaders,
    selectedZone,
    setselectedZone,
    associateCamSecVisibility,
    setAssociateCamSecVisibility,
    onSensorSelection,
    associatedDevices,
    onAssociate,
    selectedSensor,
    selectedItems,
    setSelectedItems,
    cctvTypeData,
    setInterfaceDataList,
    setcameradeviceslist,
    setpaneldeviceslist,
    setParentIsEncoding,
    parentIsEncoding,
    parentIsPlaybackEncoding,
    setParentIsPlaybackEncoding,
    parentIsEnablingTwoWayDevice,
    setParentIsEnablingTwoWayDevice,
    setParentIsEnablingTwoWayInterface,
    parentIsEnablingTwoWayInterface,
    setParentIsEnablingInternalHooter,
    setParentIsEnablingExternalHooter,
    setParentPanelIsEnablingHooter,
    parentIsEnablingInternalHooter,
    setParentIsEnablingPlaybackTimeStampsToUTC,
    parentIsEnablingPlaybackTimeStampsToUTC,
    parentIsEnablingPlaybackLongDateFormat,
    setParentIsEnablingPlaybackLongDateFormat,
    parentIsEnablingExternalHooter,
    parentPanelIsEnablingHooter,
    setRtspValueChanged,
    isDarkTheme,
    setUnknownBrandUrl,
    validationError,
    savebtnClick,
    setSavebtnClick,
    setInputValidationError,
    buttonDisable,
    timezone,
    setTimeZone,
    parentIsEnablingPTZ,
    setParentIsEnablingPTZ,
    parentIsEnablingUTCPlayback,
    setParentIsEnablingUTCPlayback,
    acsDevicesList,
    setAcsDevicesList,
    fasDeviceList,
    setFasDeviceList,
    rtuDeviceList,
    setRtuDeviceList,
    onSaveACS,
    selectedAcsHeaders,
    setSelectedAcsHeaders,
    clearImportedAcsHeaders,
    setClearImportedAcsHeaders,
    acsBulkUploadResponse,
    setAcsBulkUploadResponse,
    acsBulkUploadError,
    setAcsBulkUploadError,
    importedAcsHeaders,
    setImportedAcsHeaders,
    onAcsBulkUpload,
    getClientsUAPI,
    deviceTypeData,
    setDeviceTypeData,
    deviceType,
    setDeviceTypeDataForInterface,
    deviceTypeDataForInterface,
    getSites,
    mobileDisplay,
    setMobileDisplay,
    alertsChecked,
    setAlertChecked,
    healthMonitoringChecked,
    setHealthMonitoringChecked,
    camerasChecked,
    setCamerasChecked,
    videoBackupChecked,
    setVideoBackupChecked,
    panelDeviceTypeOptions,
    getDataAfterInterface,
    deviceTypeRTUFAS,
    setDeviceTypeRTUFAS
  } = { ...props };
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { isDirty, touchedFields },
  } = useForm({ defaultValue: { ...site, ...interfaceDevice, ...selectedDevice } });
  const [show, setShow] = useState(false);
  const memoizedSiteData = useMemo(() => site, [site]); // Memoize state
  const memoizedGetSites = useCallback(() => {
    getSites();
  }, [])
  const { clients } = useContext(ConfigurationContext)
  const SITES = "SITES";
  const INTERFACES = "INTERFACES";
  const DEVICES = "DEVICES";

  const PANEL = "PANEL";
  const NVRDVR = "NVRDVR";
  const ACS = "ACS";
  const RTU = "RTU";
  const FAS = "Fire Panel";
  const MOBILE = "MOBILE"
  const siteRef = React.useRef(null);
  const interfaceRef = React.useRef(null);

  //#region useState start
  const [activeTabKey, setActiveTabKey] = useState('Site_Details');
  const [activeTab, setActiveTab] = useState(SITES)
  const [disableTab, setDisableTab] = useState(true);
  const [interfaceTab, setInterfaceTab] = useState(true);
  const [interfaceType, setInterfaceType] = useState(NVRDVR);
  const [selectedBrand, setSelectedBrand] = useState('');
  const [channelNumberPlaceholder, setChannelNumberPlaceholder] = useState('Channel Number* e.g. 1');

  const [searchTextSite, setSearchTextSite] = useState('');
  const [searchTextInterface, setSearchTextInterface] = useState('');
  const [searchTextDevice, setSearchTextDevice] = useState('');
  const [isChannelNumberEdited, setIsChannelNumberEdited] = useState(false)

  // Add site form error states
  const [customerError, setCustomerError] = useState('');
  const [siteError, setSiteError] = useState('');
  const [countryError, setCountryError] = useState('');
  const [stateError, setStateError] = useState('');
  const [cityError, setCityError] = useState('');
  const [regionError, setRegionError] = useState('');
  const [pincodeError, setPincodeError] = useState('');
  const [addressError, setAddressError] = useState('');
  const [areaError, setAreaError] = useState('');
  const [branchidError, setBranchidError] = useState('');
  const [siteModeIdError, setSiteModeIdError] = useState('');
  // const [siteTypeError, setSiteTypeError] = useState('');

  // Add Interface error states
  const [interfaceError, setInterfaceError] = useState('');
  const [interfaceTypeError, setInterfaceTypeError] = useState('')
  const [interfaceSubtypeError, setInterfaceSubtypeError] = useState('')
  const [interfaceDeviceTypeError, setInterfaceDeviceTypeError] = useState('')
  const [interfaceEntitySubtypeError, setInterfaceEntitySubtypeError] = useState('')
  const [interfaceIPError, setInterfaceIPError] = useState('')
  const [interfacePortError, setInterfacePortError] = useState('')
  const [interfaceUserError, setInterfaceUserError] = useState('')
  const [interfacePasswardError, setInterfacePasswardError] = useState('')
  const [liveStreamFormatError, setLiveStreamFormatError] = useState('');
  const [playbackStreamFormatError, setPlaybackStreamFormatError] = useState('');
  const [interfaceTimeZoneError, setInterfaceTimeZoneError] = useState('')
  // Add camera form error states
  const [communicationPortError, setCommunicationPortError] = useState('');
  const [httpPortError, setHttpPotError] = useState('');
  const [channelNumberError, setChannelNumberError] = useState('');
  const [liveStreamTypeError, setLiveStreamTypeError] = useState('');
  const [playbackStreamTypeError, setPlaybackStreamTypeError] = useState('');
  const [rtspURLError, setrtspURLError] = useState('');
  const [deviceStageError, setDeviceStageError] = useState('')
  const [deviceNameError, setDeviceNameError] = useState('');
  const [identifierError, setIdentifierError] = useState("");
  const [deviceTypeError,setDeviceTypeError] = useState("");
  // const [entitySubtypeError, setEntitySubtypeError] = useState('');

  const [addCustomerError, setAddCustomerError] = useState('');

  const [displayTwoWay, setDisplayTwoWay] = useState(false);
  const [displayCamera, setDisplayCamera] = useState(false);
  const [enableHooter, setEnableHooter] = useState(false);
  const [disabledEntity, setDisabledEntity] = useState(false);
  const [displayEntity, setDisplayEntity] = useState(false);

  const [displayLivePlaybackfield, setDisplayLivePlaybackfield] = useState(false);

  const [rtspValue, setRtspValue] = useState("");
  const [playbackValue, setPlaybackValue] = useState("");
  const [rtspValueEntered, setRtspValueEntered] = useState("");
  const [playbackValueEntered, setPlaybackValueEntered] = useState("");
  const [isAlreadyRetail, setIsAlreadyRetail] = useState(false);
  const [editAssociate, setEditAssociate] = useState(false);
  const [acsList, setAcsList] = useState([]);
  const [acsMasterList, setAcsMasterList] = useState([]);
  const [cameraCount, setCameraCount] = useState(0);
  const [cameraSelectAll, setCameraSelectAll] = useState(false);
  const [cameraSearch, setCameraSearch] = useState("");
  const [cctvMasterList, setCCTVMasterList] = useState([]);
  const [cctvList, setCCTVList] = useState([]);
  //#endregion

// # region Start For Emergency Contact States

 const [emergencyContact, setAllEmergencyContact] = useState([]); 
 const [categoryIdList, setCategoryIdList] = useState([]);
 const [mainEmergencyContact, setMainEmergencyContact] = useState([]);
 const [mainCategoryIdList, setMainCatagoryIdList] = useState([]);
 const [nameSearch, setNameSearch] = useState('');
 const [emailSearch, setEmailSearch] = useState('');
 const [contactSearch, SetContactSearch] = useState('');
 const [categorySearch, setCategorySearch] = useState('');
 const [contactLevelOptions, setContactLevelOptions] = useState([]);
 const [contaclLevelSearch, setContactLevelSearch] = useState('');
 const [noRecordsFound, setNoRecordsFound] = useState(false);


 const [zoneForm, setZoneForm] = useState(false);
 //const [mobileDisplay,setMobileDisaplay] = useState(false);
 const [deviceStage,setDeviceStage]= useState([]);
  
  //#region useEffect start
useEffect(() =>{
  getCategoryId()
  setCategorySearch("");
  setContactLevelSearch("");
  setAllEmergencyContact(mainEmergencyContact);
},[mainEmergencyContact]);



  useEffect(() => {
    if (savebtnClick) {
      let templst = validationError.split(",");
      for (let i = 0; i < templst.length; i++) {
        if (templst[i].includes("customer-")) {
          setCustomerError(templst[i].replace("customer-", ""));
          continue
        }

        if (templst[i].includes("site-")) {
          setSiteError(templst[i].replace("site-", ""));
          continue
        }

        if (templst[i].includes("country-")) {
          setCountryError(templst[i].replace("country-", ""));
          continue
        }

        if (templst[i].includes("state-")) {
          setStateError(templst[i].replace("state-", ""));
          continue
        }

        if (templst[i].includes("city-")) {
          setCityError(templst[i].replace("city-", ""));
          continue
        }

        if (templst[i].includes("region-")) {
          setRegionError(templst[i].replace("region-", ""));
          continue
        }

        if (templst[i].includes("pincode-")) {
          setPincodeError(templst[i].replace("pincode-", ""));
          continue
        }

        if (templst[i].includes("address-")) {
          setAddressError(templst[i].replace("address-", ""));
          continue
        }

        if (templst[i].includes("area-")) {
          setAreaError(templst[i].replace("area-", ""));
          continue
        }

        if (templst[i].includes("branchid-")) {
          setBranchidError(templst[i].replace("branchid-", ""));
          continue
        }

        if (templst[i].includes("siteModeId-")) {
          setSiteModeIdError(templst[i].replace("siteModeId-", ""));
          continue
        }
      }
      setSavebtnClick(false)
    }
  }, [savebtnClick]);
  useEffect(() => {
    if (savebtnClick) {
      let templst = validationError.split(",");
      for (let i = 0; i < templst.length; i++) {
        if (templst[i].includes("interface-")) {
          setInterfaceError(templst[i].replace("interface-", ""));
          continue
        }

        if (templst[i].includes("interface type-")) {
          setInterfaceTypeError(templst[i].replace("interface type-", ""));
          continue
        }

        if (templst[i].includes("interface sub type-")) {
          setInterfaceSubtypeError(templst[i].replace("interface sub type-", ""));
          continue
        }
        if (templst[i].includes("interface timezone-")) {
          setInterfaceTimeZoneError(templst[i].replace("interface timezone-", ""));
          continue
        }

        if (templst[i].includes("interface devicetype-")) {
          setInterfaceDeviceTypeError(templst[i].replace("interface devicetype-", ""));
          continue
        }

        if (templst[i].includes("interface entity subtype-")) {
          setInterfaceEntitySubtypeError(templst[i].replace("interface entity subtype-", ""));
          continue
        }

        if (templst[i].includes("interface IP-")) {
          setInterfaceIPError(templst[i].replace("interface IP-", ""));
          continue
        }

        if (templst[i].includes("interface port-")) {
          setInterfacePortError(templst[i].replace("interface port-", ""));
          continue
        }
        if (templst[i].includes("communication port-")) {
          setCommunicationPortError(templst[i].replace("communication port-", ""));
          continue
        }

        if (templst[i].includes("http port-")) {
          setHttpPotError(templst[i].replace("http port-", ""));
          continue
        }

        if (templst[i].includes("interface username-")) {
          setInterfaceUserError(templst[i].replace("interface username-", ""));
          continue
        }

        if (templst[i].includes("interface password-")) {
          setInterfacePasswardError(templst[i].replace("interface password-", ""));
          continue
        }

        if (templst[i].includes("interface livestream format-")) {
          setLiveStreamFormatError(templst[i].replace("interface livestream format-", ""));
          continue
        }

        if (templst[i].includes("interface playbackstream format-")) {
          setPlaybackStreamFormatError(templst[i].replace("interface playbackstream format-", ""));
          continue
        }
      }
      setSavebtnClick(false)
    }
  }, [savebtnClick]);

  useEffect(() => {
    if (savebtnClick) {
      let templst = validationError.split(",");
      for (let i = 0; i < templst.length; i++) {
        if (templst[i].includes("communication port-")) {
          setCommunicationPortError(templst[i].replace("communication port-", ""));
          continue
        }

        if (templst[i].includes("http port-")) {
          setHttpPotError(templst[i].replace("http port-", ""));
          continue
        }

        if (templst[i].includes("channel number-")) {
          setChannelNumberError(templst[i].replace("channel number-", ""));
          continue
        }

        if (templst[i].includes("live stream type-")) {
          setLiveStreamTypeError(templst[i].replace("live stream type-", ""));
          continue
        }

        if (templst[i].includes("playback stream type-")) {
          setPlaybackStreamTypeError(templst[i].replace("playback stream type-", ""));
          continue
        }

        if (templst[i].includes("rtsp URL-")) {
          setrtspURLError(templst[i].replace("rtsp URL-", ""));
          continue
        }

        if (templst[i].includes("device stageid-")) {
          setDeviceStageError(templst[i].replace("device stageid-", ""));
          continue
        }

        if (templst[i].includes("device name-")) {
          setDeviceNameError(templst[i].replace("device name-", ""));
          continue
        }

        if (templst[i].includes("identifier name-")) {
          setIdentifierError(templst[i].replace("identifier name-", ""));
          continue;
        }
        if (templst[i].includes("device type-")) {
          setDeviceTypeError(templst[i].replace("device type-", ""));
          continue;
        }
      }
      setSavebtnClick(false)
    }
  }, [savebtnClick]);

  useEffect(() => {
    //for getting Country in dropdown
    let tempCountryDetails = country?.filter(item => {
      return item.countrymasterid == site.CountryId
    })
    if (tempCountryDetails?.length > 0) {
      setValue("CountryName", tempCountryDetails[0].countryname);
    } else {
      setValue("CountryName", site.CountryName);
    }
    //for getting state in dropdown
    let tempCountryStateDetails = countryState?.filter(item => {
      return item.statemasterid == site.StateId
    })
    if (tempCountryStateDetails?.length > 0) {
      setValue("StateName", tempCountryStateDetails[0].statename);
    } else {
      setValue("StateName", site.StateName);
    }
    setValue("clientID", site.clientID);
    setValue("SiteName", site.SiteName);
    setValue("BranchID", site.BranchID);
    setValue("SiteAddress", site.SiteAddress);
    setValue("CityName", site.City);
    setValue("SiteRegionName", site.Region);
    setValue("SitePincode", site.pincode);
    setValue("SiteAddress", site.Address);
    setValue("SiteArea", site.Area);
    setValue("SiteModeID", site.SiteModeID)

    if (site.SiteModeID == 2) {
      setIsAlreadyRetail(true);
    } else {
      setIsAlreadyRetail(false);
    }

  }, [site]);

  useEffect(() => {
    let tempCountryStateDetails = countryState?.filter(item => {
      return item.statemasterid == site.StateId
    })
    if (tempCountryStateDetails?.length > 0) {
      setValue("StateName", tempCountryStateDetails[0].statename);
    } else {
      setValue("StateName", site.StateName);
    }
  }, [countryState])


  useEffect(() => {
    console.log("FRESHDB", selectedDevice)
    console.log("deviceObj", interfaceDevice)
    if (selectedDevice && selectedDevice != null) {
      let tempCameraBrandId = interfaceSubTypeData?.filter(item => {
        return item.InterfacesubtypeId == interfaceDevice.InterfacesubtypeId
      })
      let cameraBrandName = "";
      if (tempCameraBrandId != undefined) {
        cameraBrandName = tempCameraBrandId[0]?.Interfacesubtypename
      } else {
        cameraBrandName = "";
      }

      setValue("SiteID", selectedDevice.SiteId || selectedDevice.SiteID)
      setValue("cameraName", selectedDevice.Name)
      setValue("privateIPAddress", selectedDevice.CameraIp || selectedDevice.privateIPAddress || selectedDevice.InterfaceIP)
      setValue("communicationPort", selectedDevice.Communicationport)
      setValue("httpPort", selectedDevice.InternetProtocolPort)
      setValue("userName", selectedDevice.userName || selectedDevice.CamUser || selectedDevice.UserName)
      setValue("password", selectedDevice.password || selectedDevice.CamPassword || selectedDevice.Password)
      setValue("port", selectedDevice.port || selectedDevice.CameraPort || selectedDevice.InterfacePort)
      // if (selectedDevice.ParentDeviceID == null){
      //   setValue("channelNumber", 0)
      // }else{
      //   setValue("channelNumber", selectedDevice.ChannelNo)
      // }
      setValue("channelNumber", selectedDevice.ChannelNo)
      console.log("ISSUESTAGE", selectedDevice)
      console.log("ISSUESTAGE", selectedDevice.deviceStageTypeId)
      console.log("ISSUESTAGE", selectedDevice.DeviceStageId)
      setValue("deviceStageTypeId",selectedDevice?.deviceStageTypeId ?? selectedDevice.DeviceStageId)
      //New
      let liveSubType;
      let playbackSubType;
      //let tempDeviceType = deviceType.find((item) => item.DeviceTypeID == selectedDevice.cameraDeviceId);
      let tempDeviceType
      if(cameradeviceslist != null){
        tempDeviceType = deviceType?.find((item) => item.DeviceTypeID == cameradeviceslist[0]?.DeviceTypeID);
      }
      //let tempDeviceType = deviceType.find((item) => item.DeviceTypeID == interafaceDevice.EntityTypeID);
      
      if (cameraBrandName == "Hikvision" || cameraBrandName == "Hikvision-Hybrid") {
        liveSubType = selectedDevice.SubTypeLive == "01" ? "Main" : selectedDevice.SubTypeLive == "02" ? "Sub" : selectedDevice.SubTypeLive == "03" ? "Ter" : ""
        setValue("liveStreamTypeNumber", liveSubType)
        playbackSubType = selectedDevice.SubTypePlayback == "01" ? "Main" : selectedDevice.SubTypePlayback == "02" ? "Sub" : selectedDevice.SubTypePlayback == "03" ? "Ter" : ""
        setValue("playbackStreamTypeNumber", playbackSubType)
      }else if (cameraBrandName == "TP-Link"){
        liveSubType = selectedDevice.SubTypeLive == "1" ? "Main" : selectedDevice.SubTypeLive == "2" ? "Sub" : selectedDevice.SubTypeLive == '3' ? "Ter" : ""
        setValue("liveStreamTypeNumber", liveSubType)
        playbackSubType = selectedDevice.SubTypePlayback == "1" ? "Main" : selectedDevice.SubTypePlayback == "2" ? "Sub" : selectedDevice.SubTypePlayback == "3" ? "Ter" : ""
        setValue("playbackStreamTypeNumber", playbackSubType)
      }
        
      else {
        if (cameraBrandName == "UnV" && tempDeviceType?.DeviceType == "Camera") {
          liveSubType = selectedDevice.SubTypeLive == "1" ? "Main" : selectedDevice.SubTypeLive == "2" ? "Sub" : selectedDevice.SubTypeLive == '3' ? "Ter" : ""
          setValue("liveStreamTypeNumber", liveSubType)
          playbackSubType = selectedDevice.SubTypePlayback == "1" ? "Main" : selectedDevice.SubTypePlayback == "2" ? "Sub" : selectedDevice.SubTypePlayback == "3" ? "Ter" : ""
          setValue("playbackStreamTypeNumber", playbackSubType)
        } else {
          liveSubType = selectedDevice.SubTypeLive == "0" ? "Main" : selectedDevice.SubTypeLive == "1" ? "Sub" : selectedDevice.SubTypeLive == '2' ? "Ter" : ""
          setValue("liveStreamTypeNumber", liveSubType)
          playbackSubType = selectedDevice.SubTypePlayback == "0" ? "Main" : selectedDevice.SubTypePlayback == "1" ? "Sub" : selectedDevice.SubTypePlayback == "2" ? "Ter" : ""
          setValue("playbackStreamTypeNumber", playbackSubType)
        }
      }

      setValue("rTSPURL", selectedDevice.RTSPCameraUrl && selectedDevice.RTSPCameraUrl.replace("%40", "@"))
      setValue("location", selectedDevice.Location)
      setValue("ParentCameraID", selectedDevice.ParentDeviceID)
      setValue("CameraBrandId", interfaceDevice.InterfacesubtypeId)
      setValue("CCTVTypeID", selectedDevice.CCTVTypeID)
      setValue("cameraDeviceId", selectedDevice?.DeviceTypeID || selectedDevice?.cameraDeviceId)
      // setValue("TimeZoneIdDevice", selectedDevice.TimeZoneID)
      setValue("TimeZoneIdDevice", selectedDevice.TimeZoneIdDevice)
      setValue("identifierName", selectedDevice.identifierName || selectedDevice.ExternalId)
      
      setValue("acsDeviceType", selectedDevice.acsDeviceType ?? selectedDevice?.DeviceTypeID)
      // setValue("fasDeviceType", fasDeviceList.fasDeviceType || selectedDevice?.DeviceTypeID)
      // setValue("rtuDeviceType", rtuDeviceList.rtuDeviceType || selectedDevice?.DeviceTypeID)

      if (selectedDevice.IsTranscodingEnabled == "1") {
        setValue("isTranscoded", 1);
        setParentIsEncoding(true);
      } else {
        setValue("isTranscoded", 0);
        setParentIsEncoding(false);
      }

      if (selectedDevice.IsPlayBackTranscodingEnabled == "1") {
        setValue("isPlaybackTranscoded", 1);
        setParentIsPlaybackEncoding(true);
      } else {
        setValue("isPlaybackTranscoded", 0);
        setParentIsPlaybackEncoding(false);
      }

      if (selectedDevice.isTwoWayEnabled == "1") {
        setValue("isTwoWayEnabledDevice", 1);
        setParentIsEnablingTwoWayDevice(true);
      } else {
        setValue("isTwoWayEnabledDevice", 0);
        setParentIsEnablingTwoWayDevice(false);
      }

      if (selectedDevice.IsPtz == "1") {
        setValue("isPTZ", 1);
        setParentIsEnablingPTZ(true)
      } else {
        setValue("isPTZ", 0);
        setParentIsEnablingPTZ(false);
      }

      if (selectedDevice.ISPlaybackUTC == "1") {
        setValue("isPlaybackUTC", 1);
        setParentIsEnablingUTCPlayback(true);
      } else {
        setValue("isPlaybackUTC", 0);
        setParentIsEnablingUTCPlayback(false);
      }

      // setValue("isTranscoded", selectedDevice.isTranscoded);
    }
    handleRefClick();
  }, [selectedDevice]);

  useEffect(() => {
    let acsidentifire = 0
    console.log("SelectedDeviceAKSHATA123",selectedDevice)
    console.log("interfaceTyoe")
    if (interfaceDevice?.Interfacetypename == "ACS" ){
      let acsControllerId = deviceType.find((item) => item.DeviceType == "ACS Controller");
      let acsReaderId = deviceType.find((item) => item.DeviceType == "ACS Reader");
      if (selectedDevice?.ParentCameraID == 0){
        acsidentifire = acsReaderId?.DeviceTypeID
      }else if (selectedDevice?.ParentDeviceID != null){
        acsidentifire = acsReaderId?.DeviceTypeID
      }else{
        acsidentifire = acsControllerId?.DeviceTypeID
      }
      // acsidentifire = selectedDevice?.ParentCameraID != 0 || selectedDevice?.ParentDeviceID == null ? acsControllerId?.DeviceTypeID : acsReaderId?.DeviceTypeID
  }else if(interfaceDevice?.Interfacetypename == "Fire Panel"){
    let tempDeviceTypeFRS = deviceType.find((item) => item.DeviceType == "Fire Panel"|| item.DeviceType == "FRS") 
    //acsidentifire = tempDeviceTypeFRS?.DeviceTypeID
    acsidentifire = deviceTypeRTUFAS
  }else if (interfaceDevice?.Interfacetypename == "RTU"){
    let tempDeviceTypeRTU = deviceType.find((item) => item.DeviceType == "RTU") 
    //acsidentifire = tempDeviceTypeRTU?.DeviceTypeID
    acsidentifire = deviceTypeRTUFAS
  }
    console.log("acsDevicesList",acsidentifire)
     console.log("STEPPER",acsidentifire )
    setValue("acsDeviceType",acsidentifire )
  }, [acsDevicesList])

  useEffect(() => {
    if (watch("CameraBrandId") && watch("privateIPAddress") && watch("userName") && watch("password") && watch("port") && watch("channelNumber") && watch("liveStreamTypeNumber")) {

      var channelState;
      let liveStreamType = 0;

      setIsChannelNumberEdited(prevState => {
        channelState = prevState;
        return prevState;
      });

      let tempCameraBrandId = interfaceSubTypeData?.filter(item => {
        return item.InterfacesubtypeId == getValues("CameraBrandId")
      })
      let cameraBrandName = tempCameraBrandId[0].Interfacesubtypename
      if (cameraBrandName == "Hikvision" || cameraBrandName == "Hikvision-Hybrid") {
        // liveStreamType = getValues("liveStreamTypeNumber") == "Main" ? 1 : 2
        liveStreamType = getValues("liveStreamTypeNumber") == "Main" ? "01" : getValues("liveStreamTypeNumber") == "Sub" ? "02" : "03"
      } else if(cameraBrandName == "TP-Link"){
        liveStreamType = getValues("liveStreamTypeNumber") == "Main" ? "1" : getValues("liveStreamTypeNumber") == "Sub" ? "2" : "3"
      }
      else {
        // liveStreamType = getValues("liveStreamTypeNumber") == "Main" ? 0 : 1
        liveStreamType = getValues("liveStreamTypeNumber") == "Main" ? "0" : getValues("liveStreamTypeNumber") == "Sub" ? "1" : "2"
      }

      let temp = "";
      if (cameraBrandName == "Hikvision") {
        temp =
          "rtsp://" +
          getValues("userName") +
          ":" +
          getValues("password") +
          "@" +
          getValues("privateIPAddress") +
          ":" +
          getValues("port") +
          "/Streaming/Channels/" +
          getValues("channelNumber") +
          liveStreamType;
      } else if (cameraBrandName == "CP Plus" || cameraBrandName == "Dahua") {
        temp =
          "rtsp://" +
          getValues("userName") +
          ":" +
          getValues("password") +
          "@" +
          getValues("privateIPAddress") +
          ":" +
          getValues("port") +
          "/cam/realmonitor?channel=" +
          getValues("channelNumber") +
          "&subtype=" + liveStreamType; //+getValues("channelNumber")
      } else if (cameraBrandName == "Sparsh") {
        temp =
          "rtsp://" +
          getValues("userName") +
          ":" +
          getValues("password") +
          "@" +
          getValues("privateIPAddress") +
          ":" +
          getValues("port") +
          "/avstream/channel=" +
          getValues("channelNumber") +
          "/stream=" + liveStreamType + ".sdp";
      } else if (cameraBrandName == "DLink") {
        //=> rtsp://admin:Admin@123@122.170.105.219:554/avstream/channel=1/stream=0.sdp
        temp =
          "rtsp://" +
          getValues("userName") +
          ":" +
          getValues("password") +
          "@" +
          getValues("privateIPAddress") +
          ":" +
          getValues("port") +
          "/avstream/channel=" +
          getValues("channelNumber") +
          "/stream=" + liveStreamType + ".sdp";
        // => rtsp://admin:Admin@@12k@102.168.0.1:7001/avstream/channel=1/stream=0.sdp
      } else if (cameraBrandName == "UnV") {
       
        let tempDeviceType = deviceType.find((item) => item.DeviceTypeID == cameradeviceslist[0].DeviceTypeID);
        if (tempDeviceType?.DeviceType == "Camera") {
          liveStreamType = getValues("liveStreamTypeNumber") == "Main" ? "1" : getValues("liveStreamTypeNumber") == "Sub" ? "2" : "3"
          temp =
            "rtsp://" +
            getValues("userName") +
            ":" +
            getValues("password") +
            "@" +
            getValues("privateIPAddress") +
            ":" +
            getValues("port") +
            "/media/video" +
            liveStreamType;
          // getValues("channelNumber");
        } else {
          temp =
            "rtsp://" +
            getValues("userName") +
            ":" +
            getValues("password") +
            "@" +
            getValues("privateIPAddress") +
            ":" +
            getValues("port") +
            "/unicast/c" +
            getValues("channelNumber") +
            "/s" + liveStreamType + "/live";
        }
      } else if (cameraBrandName == "Unknown") {
        // "rtsp://[Username]:[Password]@[IpAddress]:[Port]/Streaming/channels/[ChannelNo]"
        let link = interfaceDevice.LiveRTSPURL
        temp = link
        

        const replacements = {
          "[Username]": getValues("userName"),
          "[Password]": getValues("password").replaceAll("@", "%40"),
          "[IpAddress]": getValues("privateIPAddress"),
          "[Port]": getValues("port"),
          "[ChannelNo]": getValues("channelNumber"),
          "[LiveStreamType]": liveStreamType
        };

        for (const [placeholder, value] of Object.entries(replacements)) {
          temp = temp?.split(placeholder).join(value);
        }
        setUnknownBrandUrl(temp)

      } else if (cameraBrandName == "Raysharp") {
        // =>rtsp://admin:admin123.@73.14.118.111:3311/rtsp/streaming?channel=01&subtype=0 ---new
        //rtsp://admin:admin123.@73.14.118.111:3311/rtsp/streaming?channel=01&subtype=1 --new
        temp =
          "rtsp://" +
          getValues("userName") +
          ":" +
          getValues("password") +
          "@" +
          getValues("privateIPAddress") +
          ":" +
          getValues("port") +
          "/rtsp/streaming?channel=" +
          getValues("channelNumber") +
          "&subtype=" + liveStreamType;



        //  => "rtsp://192.168.1.100:554/rtsp/streaming?channel=1&subtype=0&token=123"---old 
        // temp =
        //   "rtsp://" +
        //   getValues("userName") +
        //   ":" +
        //   getValues("password") +
        //   "@" +
        //   getValues("privateIPAddress") +
        //   ":" +
        //   getValues("port") +
        //   "/rtsp/streaming?channel=" +
        //   getValues("channelNumber") +
        //   "&subtype=" + liveStreamType + "&token=123";
      } else if (cameraBrandName == "Hikvision-Hybrid") {
        temp =
          "rtsp://" +
          getValues("userName") +
          ":" +
          getValues("password") +
          "@" +
          getValues("privateIPAddress") +
          ":" +
          getValues("port") +
          "/Streaming/Channels/" +
          getValues("channelNumber") +
          liveStreamType;

      } else if (cameraBrandName == "TvT") {
        //=> rtsp://admin:Admin@123456@223.235.16.143:554/?chID=1&streamType=sub&linkType=tcp
        temp =
          "rtsp://" +
          getValues("userName") +
          ":" +
          getValues("password") +
          "@" +
          getValues("privateIPAddress") +
          ":" +
          getValues("port") +
          "/?chID=" +
          getValues("channelNumber") +
          "&streamType=" + getValues("liveStreamTypeNumber").toLowerCase() + "&linkType=tcp";

      } else if (cameraBrandName == "TP-Link") {
        //rtsp://admin:Soratan@05@157.20.26.21:554/stream1 – Main Stream
        // rtsp://admin:Soratan@05@157.20.26.21:554/stream2  - Sub Stream
        temp =
          "rtsp://" +
          getValues("userName") +
          ":" +
          getValues("password") +
          "@" +
          getValues("privateIPAddress") +
          ":" +
          getValues("port") +
          "/stream" + liveStreamType;
      }else if (cameraBrandName == "Ambicam" || cameraBrandName == "TrueView") {
      //rtsp://admin:Soratan@05@157.20.26.21:554//ch0_1.264 – Main Stream
      // rtsp://admin:Soratan@05@157.20.26.21:554//ch0_1.264 - Sub Stream
        temp =
          "rtsp://" +
          getValues("userName") +
          ":" +
          getValues("password") +
          "@" +
          getValues("privateIPAddress") +
          ":" +
          getValues("port") +
          "/ch0_" + 
          getValues("channelNumber") +
          ".264";
      }

      if (selectedDevice.RTSPURL === undefined) {
        //add condition
        setValue("rTSPURL", temp?.replace(/%40/g, "@").replace(/%38/g, "&").replace(/%26/g, "&"))
        setrtspURLError('')
      } else if (selectedDevice.RTSPURL !== temp) {
        setValue("rTSPURL", temp?.replace(/%40/g, "@").replace(/%38/g, "&").replace(/%26/g, "&"))
        setrtspURLError('')
      } else {
        setValue("rTSPURL", temp?.replace(/%40/g, "@").replace(/%38/g, "&").replace(/%26/g, "&"))
        setrtspURLError('')
      }
    } else {
      // setValue("rTSPURL", "")
    }
  }, [watch("CameraBrandId"), watch("privateIPAddress"), watch("userName"), watch("password"), watch("port"), watch("channelNumber"), watch("liveStreamTypeNumber"), isChannelNumberEdited]);

  useEffect(() => {
    if (site.SiteID != 0) {
      setInterfaceTab(false);
    } else {
      setInterfaceTab(true);
    }
  }, [site])

  useEffect(() => {
    if (interfaceDevice.InterfaceId != 0 && site.SiteID != 0) {
      setDisableTab(false);
    } else {
      setDisableTab(true);
    }
  }, [interfaceDevice, site])

  useEffect(() => {
    if (selectedDevice && selectedDevice != null) {
      if (selectedDevice.DeviceTypeID == 3 || selectedDevice.DeviceTypeID == 4 || selectedDevice.DeviceTypeID == 5) {
        //let arr = devicesmasterlist.panelTypeMasterList.filter(item => item.panelName == interfaceDevice.Interfacesubtypename);
        let arr = interfaceSubTypeData?.filter(
          (item) => item.Interfacesubtypename == interfaceDevice.Interfacesubtypename
        );
        let temp = arr[0].InterfacesubtypeId;
        setValue("PanelMasterId", temp)
      } else {
        setValue("PanelMasterId", selectedDevice.panelMasterId || selectedDevice.PanelMasterId || selectedDevice.cameraBrandId)
      }
      // setValue("PanelMasterId", selectedDevice.panelMasterId || selectedDevice.PanelMasterId || selectedDevice.cameraBrandId)
      setValue("SiteID", selectedDevice.SiteId || selectedDevice.SiteID)
      setValue("privateIPAddress", selectedDevice.CameraIp || selectedDevice.privateIPAddress || selectedDevice.InterfaceIP)
      setValue("communicationPort", selectedDevice.Communicationport || selectedDevice.communicationPort)
      setValue("httpPort", selectedDevice.InternetProtocolPort || selectedDevice.httpPort)
      // setValue("cameraName", selectedDevice.CameraName || selectedDevice.cameraName) 
      setValue("CCTVTypeID", selectedDevice.CCTVTypeID);
      setValue("TimeZoneIdDevice", selectedDevice.TimeZoneIdDevice || selectedDevice.TimeZoneID)
      setValue("cameraDeviceId", selectedDevice?.DeviceTypeID || selectedDevice?.cameraDeviceId)
      getDeviceStage();
      if (interfaceType === NVRDVR) {
        setValue("cameraName", selectedDevice.Name || selectedDevice.CameraName)
      } else {
        setValue("cameraName", selectedDevice.CameraName || selectedDevice.cameraName || selectedDevice.Name)
      }
    }
  }, [selectedDevice]);
 
  useEffect(() => {
    getDeviceTypeByInterfaceId(interfaceDevice?.InterfacetypeId)
    setValue("InterfaceName", interfaceDevice.InterfaceName);
    //setValue("InterfaceType", "CCTV");Interfacetypename
   if(interfaceDevice?.Interfacetypename == "Mobile" || interfaceDevice.InterfacetypeId == "Mobile" || interfaceDevice.InterfaceType == "Mobile"){
    setMobileDisplay(true)
   }else{
    setMobileDisplay(false)
   }
    setValue("InterfaceType", interfaceDevice.Interfacetypename || interfaceDevice.InterfacetypeId || interfaceDevice.InterfaceType);
    setValue("InterfaceSubType", interfaceDevice.Interfacesubtypename || interfaceDevice.InterfacesubtypeId || interfaceDevice.InterfaceSubType);
    setValue("EntityTypeID", interfaceDevice.EntityTypeID || interfaceDevice.InterfaceType);
    setValue("deviceTypeId", interfaceDevice.EntityTypeID || interfaceDevice.InterfaceType);
    setValue("InterfaceIP", interfaceDevice.InterfaceIP);
    setValue("TimeZoneId", interfaceDevice.TimeZoneID || interfaceDevice.TimeZoneId);
    setValue("InterfacePort", interfaceDevice.InterfacePort);
    setValue("communicationPortInterface", interfaceDevice.Communicationport || interfaceDevice.communicationPortInterface || interfaceDevice.communicationPort)
    setValue("httpPortInterface", interfaceDevice.InternetProtocolPort || interfaceDevice.httpPortInterface || interfaceDevice.httpPort)
    setValue("InterfaceUsername", interfaceDevice.UserName);
    setValue("InterfacePassword", interfaceDevice.Password);
    setValue("LiveRTSPURL", interfaceDevice.LiveRTSPURL);
    setRtspValueEntered(interfaceDevice.LiveRTSPURL)
    setRtspValue(interfaceDevice.LiveRTSPURL == null ? "" : interfaceDevice.LiveRTSPURL)
    setValue("PlaybackRTSPURL", interfaceDevice.PlaybackRTSPURL);
    setPlaybackValue(interfaceDevice.PlaybackRTSPURL == null ? "" : interfaceDevice.PlaybackRTSPURL)
    setPlaybackValueEntered(interfaceDevice.PlaybackRTSPURL)
    setValue("", interfaceDevice.InterfaceId);
    setValue("CCTVTypeIDInterface", interfaceDevice.CCTVTypeIDInterface);
    setValue("CCTVType", interfaceDevice.CCTVType);
    if (interfaceDevice.isTwoWayEnabled || interfaceDevice.IsTwoWayEnabled == "1") {
      setValue("InterfaceTwoWayEnabled", 1)
      setParentIsEnablingTwoWayInterface(true);
    } else {
      setValue("InterfaceTwoWayEnabled", 0)
      setParentIsEnablingTwoWayInterface(false);
    }

    if (interfaceDevice.CheckPlaybackUTCTime == "1" || interfaceDevice.CheckPlaybackUTCTime == true) {
      setValue("PlaybackTimeStampsToUTC", 1)
      setParentIsEnablingPlaybackTimeStampsToUTC(true);
    } else {
      setValue("PlaybackTimeStampsToUTC", 0)
      setParentIsEnablingPlaybackTimeStampsToUTC(false);
    }

    if (interfaceDevice.CheckPlaybackLongTime == "1" || interfaceDevice.CheckPlaybackLongTime == true) {
      setValue("PlaybackLongDateFormat", 1)
      setParentIsEnablingPlaybackLongDateFormat(true);
    } else {
      setValue("PlaybackLongDateFormat", 0)
      setParentIsEnablingPlaybackLongDateFormat(false);
    }

    if (interfaceDevice.CheckInternalHooter == true || interfaceDevice.CheckInternalHooter == "1") {
      setValue("CheckInternalHooter", 1)
      setParentIsEnablingInternalHooter(true);
    } else {
      setValue("CheckInternalHooter", 0)
      setParentIsEnablingInternalHooter(false);
    }

    if (interfaceDevice.CheckExternalHooter == true || interfaceDevice.CheckExternalHooter == "1" ) {
      setValue("CheckExternalHooter", 1)
      setParentIsEnablingExternalHooter(true);
    } else {
      setValue("CheckExternalHooter", 0)
      setParentIsEnablingExternalHooter(false);
    }

    if (interfaceDevice.isHooterEnabled == true || interfaceDevice.IsHooterEnabled == true || interfaceDevice.IsHooterEnabled == "1") {
      setValue("IsHooterEnabled", 1)
      setParentPanelIsEnablingHooter(true);
    } else {
      setValue("IsHooterEnabled", 0)
      setParentPanelIsEnablingHooter(false);
    }


    if (interfaceDevice.InterfaceId == 0) {
      setEnableHooter(false)
      setDisplayCamera(false)
      setDisplayLivePlaybackfield(false)
      setDisabledEntity(false)
    }
    else {
      setDisabledEntity(true)
    }
    if (interfaceDevice.InterfaceType == 0 || interfaceDevice.Interfacetypename == "CCTV") {
      setInterfaceType(NVRDVR);
      setBulkUpload(false);
    } else if (interfaceDevice.Interfacetypename == "Alarm Panel") {
      setInterfaceType(PANEL);
      setBulkUpload(false);
    } else if (interfaceDevice.Interfacetypename == "ACS"){
      setInterfaceType(ACS);
      setBulkUpload(false);
    } else if ((interfaceDevice.Interfacetypename == "Fire Panel")) {
      setInterfaceType(FAS)
      setBulkUpload(false)
    } else if ((interfaceDevice.Interfacetypename == "RTU")){
      setInterfaceType(RTU)
      setBulkUpload(false)
    } 
    else if ((interfaceDevice.Interfacetypename == "Mobile")){
      setInterfaceType(MOBILE)
      setBulkUpload(false)
    }

    // let tempDeviceType
      // if(cameradeviceslist != null){
      //   tempDeviceType = deviceType?.find((item) => item.DeviceTypeID == cameradeviceslist[0]?.DeviceTypeID);
      // }
    let tempDeviceType = deviceType.find((item) => item.DeviceTypeID == interfaceDevice.EntityTypeID);
    if (interfaceDevice.CCTVType == "Camera" || tempDeviceType?.DeviceType == "Camera") {
      if (interfaceDevice.Interfacesubtypename == "Unknown") {
        setDisplayCamera(false)
        setEnableHooter(false)
      } else {
        setDisplayCamera(true)
        setEnableHooter(false)
      }
    } else if (interfaceDevice.Interfacetypename == "Alarm Panel") {
      setDisplayCamera(false)
      setEnableHooter(true)
    }
    else if (interfaceDevice.Interfacetypename == "ACS") {
      setDisplayCamera(false)
      setEnableHooter(false)
    } else if (interfaceDevice.Interfacetypename == "Fire Panel") {
      setDisplayCamera(false)
      setEnableHooter(false)
    } else if (interfaceDevice.Interfacetypename == "RTU") {
      setDisplayCamera(false)
      setEnableHooter(false)
    }
    else if (interfaceDevice.Interfacesubtypename == "Unknown") {
      setDisplayCamera(false)
      setEnableHooter(false)
    }
    else {
      setDisplayCamera(false)
      setEnableHooter(true)
    }

    if (interfaceDevice.Interfacetypename == "CCTV") {
      if (interfaceDevice.Interfacesubtypename == "Unknown") {
        setDisplayTwoWay(false);
        setDisplayEntity(true);
      } else {
        setDisplayTwoWay(true);
        setDisplayEntity(true);
      }
    } else {
      setDisplayTwoWay(false);
      setDisplayEntity(false);
    }

  }, [interfaceDevice])

  useEffect(() => {
    setValue("InterfaceSubType", interfaceDevice.Interfacesubtypename || interfaceDevice.InterfacesubtypeId || interfaceDevice.InterfaceSubType);
    // this is for demo/unknown
    if (interfaceDevice.Interfacesubtypename == "Unknown") {
      setDisplayLivePlaybackfield(true);
    } else {
      setDisplayLivePlaybackfield(false);
    }

  }, [interfaceSubTypeData])

  useEffect(() => {
    setValue("deviceTypeId", interfaceDevice.EntityTypeID || interfaceDevice.InterfaceType);
  }, [deviceTypeData])

  useEffect(() => {
    setValue("EntitySubtype", interfaceDevice.EntitySubtype || interfaceDevice.InterfaceType);
  }, [cctvTypeData])

  useEffect(() => {
    if (watch('InterfaceType') == "Alarm Panel") {
      setInterfaceType(PANEL);
      setBulkUpload(false);
    } else if (watch('InterfaceType') == "ACS") {
      setInterfaceType(ACS);
      setBulkUpload(false);
    } else if (watch('InterfaceType') == "Fire Panel") {
      setInterfaceType(FAS)
      setBulkUpload(false)
    } else if (watch('InterfaceType') == "RTU") {
      setInterfaceType(RTU)
      setBulkUpload(false)
    } 
    else if (watch('InterfaceType') == "Mobile") {
      setInterfaceType(MOBILE)
      setBulkUpload(false)
    }
    else {
      setInterfaceType(NVRDVR);
      setBulkUpload(false);
    }
  }, [watch('InterfaceType')])
  //#endregion 

  const handleRefClick = () => {
    if (activeTab !== SITES) {
      setTimeout(() => {
        siteRef?.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
      }, 100)
    }
  }

  const getAssociateACSList = (devicedt) => {
    // let obj = {
    //   "action": "getAssociatedCamerasACSList",
    //   "deviceId": devicedt.ParentCameraID,
    //   "userUniqueId": localStorage.getItem('UserID'),
    //   "clientId": devicedt.clientId,
    //   "branchId": devicedt.BranchID
    // }
    var obj = {
      action: "getAssociatedCamerasList",
      deviceId: devicedt.DeviceId,
      userUniqueId: localStorage.getItem('UserID'),
      clientId: devicedt.clientId,
      siteId: devicedt.SiteId
    };
    deviceconfigcrud(obj)
      .then((res) => {
        if (res.status == "Ok"  || res && res.Status === "success") {
          let isAllSelected = true;
          let custTemp = res.Data.map((item, index) => {
            let obj;
            if (item.isSelected == false) {
              isAllSelected = false;
              obj = {
                ...item,
                isChecked: false
              }
            } else {
              obj = {
                ...item,
                isChecked: true
              }
            }
            return obj;
          })
          setAcsList(custTemp);
          setAcsMasterList(custTemp);
          setCameraCount(custTemp.length);
          if (isAllSelected) {
            setCameraSelectAll(true)
          } else {
            setCameraSelectAll(false)
          }
        }
      })
  }


  const searchCameraHandler = (e, type) => {
    let searchText = e.target.value;
    if (type == "Camera") {
      setCameraSearch(searchText);
      let arr = acsMasterList.filter((item) => item.cameraName.toLowerCase().includes(searchText.toLowerCase()));
      let isChecked = true;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].isChecked == true) {
          continue;
        } else {
          isChecked = false;
          break;
        }
      }
      setCameraSelectAll(isChecked);
      setAcsList(arr);
      setCameraCount(arr.length);
    }
  }
  const searchCCTVCameraHandler = (e, type) => {
    let searchText = e.target.value;
    if (type == "Camera") {
      setCameraSearch(searchText);
      let arr = cctvMasterList.filter((item) => item.cameraName.toLowerCase().includes(searchText.toLowerCase()));
      let isChecked = true;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].isChecked == true) {
          continue;
        } else {
          isChecked = false;
          break;
        }
      }
      setCameraSelectAll(isChecked);
      setCCTVList(arr);
      setCameraCount(arr.length);
    }
  }

  const cctvCheckHandler = (e, id) => {
    let arr = cctvList.map((item) => {
      let obj;
      if (item.deviceId == id) {
        obj = {
          ...item,
          isChecked: !item.isChecked
        }
      } else {
        obj = {
          ...item
        }
      }
      return obj;
    })

    let masterCustomer = cctvMasterList.map((item) => {
      let obj;
      if (item.deviceId == id) {
        obj = {
          ...item,
          isChecked: !item.isChecked
        }
      } else {
        obj = {
          ...item
        }
      }
      return obj;
    })

    let customerArr = arr.filter((item) => item.isChecked).map((i) => i.deviceId);
    let clientIds = customerArr.join(',');
    // if (customerArr.length != 0) {
    //   GetPanelFilterData("customer", clientIds).then((resp) => {
    //     if (resp.Status == "success") {
    //       siteIsChecked(resp.Data.LstSite);
    //       setSiteSelectAll(false);
    //     }
    //   })
    // }
    // else {
    //   GetPanelFilterData("all", "").then((resp) => {
    //     if (resp.Status == "success") {
    //       siteIsChecked(resp.Data.LstSite);
    //       setSiteSelectAll(false);
    //     }
    //   })
    // }
    setCCTVMasterList(masterCustomer);
    setCCTVList(arr);

  }
  
  const getAssociateCCTVList = (devicedt) => {
    // let obj = {
    //   "action": "getAssociatedCamerasACSList",
    //   "deviceId": devicedt.ParentCameraID,
    //   "userUniqueId": localStorage.getItem('UserID'),
    //   "clientId": devicedt.clientId,
    //   "branchId": devicedt.BranchID
    // }
    var obj = {
      action: "getAssociatedCamerasList",
      deviceId: devicedt.DeviceId,
      userUniqueId: localStorage.getItem('UserID'),
      clientId: devicedt.clientId,
      siteId: devicedt.SiteId
    };
    deviceconfigcrud(obj)
      .then((res) => {
        if (res.status == "Ok"  || res && res.Status === "success") {
          let isAllSelected = true;
          let custTemp = res.Data.map((item, index) => {
            let obj;
            if (item.isSelected == false) {
              isAllSelected = false;
              obj = {
                ...item,
                isChecked: false
              }
            } else {
              obj = {
                ...item,
                isChecked: true
              }
            }
            return obj;
          })
          setCCTVList(custTemp);
          setCCTVMasterList(custTemp);
          setCameraCount(custTemp.length);
          if (isAllSelected) {
            setCameraSelectAll(true)
          } else {
            setCameraSelectAll(false)
          }
        }
      })
  }
  const associatetCCTV = (selectedDevice) => {
    var createdtime = ConvertDateToUTC(new Date())
    let userid = localStorage.getItem('UserID')
    let selectedItems = cctvMasterList.filter(j => j.isChecked).map((i) => i.deviceId);
    if(selectedItems.length > 4){
      ErrorToast(`Maximum only 4 cameras can be associated, you have associated ${selectedItems.length} cameras`)
        return;
    }
    // var obj = {
    //   "action": "associateCamerasToACS",
    //   "associatedCameraIds": selectedItems,
    //   "deviceId": selectedDevice.ParentCameraID,
    //   "createdBy": userid,
    //   "createdOn": createdtime,
    //   "userUniqueId": null,
    // }
    var obj = {
      action: "associateCamerasToSensor",
      associatedCameraIds: selectedItems,
      deviceId: selectedDevice.DeviceId,
      createdBy: userid,
      createdOn: createdtime,
      userUniqueId: null,
    };
    deviceconfigcrud(obj).then((resp) => {
      if (resp && resp.status === "Ok" || resp && resp.Status === "success") {
        SuccessToast(resp.Message)
        setEditAssociate(false);
      }
      else {
       // setEditAssociate(true);
        ErrorToast('Error occurred while associating the device!')
      }
    })
  }
  const handleCameraSelectAll = () => {
    const tempArr = acsList.map((item, index) => {
      let obj = {
        ...item,
        isChecked: !cameraSelectAll
      }
      return obj;
    })

    let customerOne = acsMasterList.map((item) => {
      let objcustomer;
      if (cameraSelectAll) {
        if (!item.cameraName.toLowerCase().includes(cameraSearch.toLowerCase())) {
          objcustomer = {
            ...item
          }
        } else {
          objcustomer = {
            ...item,
            isChecked: false
          }
        }
      } else {
        if (!item.cameraName.toLowerCase().includes(cameraSearch.toLowerCase())) {
          objcustomer = {
            ...item,
          }
        } else {
          objcustomer = {
            ...item,
            isChecked: true
          }
        }
      }
      return objcustomer;
    })

    setCameraSelectAll(!cameraSelectAll);
    setAcsList(tempArr);
    setAcsMasterList(customerOne);
    let customerArr = customerOne.filter((item) => item.isChecked).map((i) => i.deviceId);
    let clientIds = customerArr.join(',');
    // if (customerArr.length != 0) {
    //   GetPanelFilterData("customer", clientIds).then((resp) => {
    //     if (resp.Status == "success") {
    //       siteIsChecked(resp.Data.LstSite);
    //       setSiteSelectAll(false);
    //     }
    //   })
    // }

  };

  const customerCheckHandler = (e, id) => {
    let arr = acsList.map((item) => {
      let obj;
      if (item.deviceId == id) {
        obj = {
          ...item,
          isChecked: !item.isChecked
        }
      } else {
        obj = {
          ...item
        }
      }
      return obj;
    })

    let masterCustomer = acsMasterList.map((item) => {
      let obj;
      if (item.deviceId == id) {
        obj = {
          ...item,
          isChecked: !item.isChecked
        }
      } else {
        obj = {
          ...item
        }
      }
      return obj;
    })

    let customerArr = arr.filter((item) => item.isChecked).map((i) => i.deviceId);
    let clientIds = customerArr.join(',');
    // if (customerArr.length != 0) {
    //   GetPanelFilterData("customer", clientIds).then((resp) => {
    //     if (resp.Status == "success") {
    //       siteIsChecked(resp.Data.LstSite);
    //       setSiteSelectAll(false);
    //     }
    //   })
    // }
    // else {
    //   GetPanelFilterData("all", "").then((resp) => {
    //     if (resp.Status == "success") {
    //       siteIsChecked(resp.Data.LstSite);
    //       setSiteSelectAll(false);
    //     }
    //   })
    // }
    setAcsMasterList(masterCustomer);
    setAcsList(arr);

  }

  const associatetoACS = (selectedDevice) => {
    var createdtime = ConvertDateToUTC(new Date())
    let userid = localStorage.getItem('UserID')
    let selectedItems = acsMasterList.filter(j => j.isChecked).map((i) => i.deviceId);
    if(selectedItems.length > 4){
      ErrorToast(`Maximum only 4 cameras can be associated, you have associated ${selectedItems.length} cameras`)
        return;
    }
    // var obj = {
    //   "action": "associateCamerasToACS",
    //   "associatedCameraIds": selectedItems,
    //   "deviceId": selectedDevice.ParentCameraID,
    //   "createdBy": userid,
    //   "createdOn": createdtime,
    //   "userUniqueId": null,
    // }
    var obj = {
      action: "associateCamerasToSensor",
      associatedCameraIds: selectedItems,
      deviceId: selectedDevice.DeviceId,
      createdBy: userid,
      createdOn: createdtime,
      userUniqueId: null,
    };
    deviceconfigcrud(obj).then((resp) => {
      if (resp && resp.status === "Ok" || resp && resp.Status === "success") {
        SuccessToast(resp.Message)
        setEditAssociate(false);
      }
      else {
       // setEditAssociate(true);
        //console.log("respAssociate",resp)
        ErrorToast('Error occurred while associating the device!')
      }
    })
  }

  const cancelACSAssociation = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to cancel the changes made?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#027aaa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!'
    }).then((result) => {
      if(result.isConfirmed){
        setCameraSearch("")
        setEditAssociate(false);
        getAssociateACSList(selectedDevice)
      }
    })
  }
  const cancelCCTVAssociation = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to cancel the changes made?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#027aaa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!'
    }).then((result) => {
      if(result.isConfirmed){
        setCameraSearch("")
        setEditAssociate(false);
        getAssociateCCTVList(selectedDevice)
      }
    })
  }

  const handleInterfaceRefClick = () => {
    if (activeTab !== INTERFACES) {
      setTimeout(() => {
        interfaceRef?.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
      }, 100)
    }
  }

  const resetSite = () => {
    setSelectedSite(tempSiteObj);
    setSelectedInterface(interfaceObj);
    setIsSiteEdit(true);
    setActiveTabKey("Site_Details")
  }

  const clearSiteFields = () => {
    setCustomerError('');
    setSiteError('');
    setCountryError('');
    setStateError('');
    setCityError('');
    setRegionError('');
    setPincodeError('');
    setAddressError('');
    setAreaError('');
    setBranchidError('');
    setSiteModeIdError('')
    // setSiteTypeError('');
    setInputValidationError('');
  }

  const clearInterfaceFields = () => {
    setInterfaceError('');
    setInterfaceTypeError('');
    setInterfaceSubtypeError('');
    setInterfaceEntitySubtypeError('');
    setInterfaceDeviceTypeError('')
    setInterfaceIPError('');
    setInterfacePortError('');
    setInterfaceUserError('');
    setInterfacePasswardError('');
    setLiveStreamFormatError('');
    setPlaybackStreamFormatError('');
    setInterfaceTimeZoneError('');
  }

  const clearCameraFields = () => {
    setCommunicationPortError('');
    setChannelNumberError('');
    setLiveStreamTypeError('')
    setPlaybackStreamTypeError('')
    setrtspURLError('');
    setDeviceNameError('');
    setHttpPotError('')
    setIdentifierError('');
    setDeviceTypeError('');
    setDeviceStageError('')
  }

  const handleBulkUploadClick = (e) => {
    setBulkUpload(true);
    setBulkDevToUpload([]);
    setIsSingleOrBulkSelection("bulk_upload");
  };

  const handleSingleUploadClick = () => {
    setBulkUpload(false);
    setIsSingleOrBulkSelection("single_device");
  };

  useImperativeHandle(ref, () => ({
    isDataChanged() {
      return (
        getValues("SiteName") != site.SiteName ||
        getValues("BranchID") != site.BranchID ||
        getValues("SiteAddress") != site.SiteAddress ||
        getValues("clientID") != site.clientID ||
        getValues("CityName", site.City) ||
        getValues("SiteRegionName", site.Region) ||
        getValues("SitePincode", site.pincode) ||
        getValues("SiteAddress", site.Address) ||
        getValues("SiteArea", site.Area) ||
        getValues("CountryName", site.CountryName) ||
        getValues("StateName", site.StateName) ||
        getValues("SiteModeID", site.SiteModeID)
      );
    },
  }));

  function isDataChanged() {
    return (
      getValues("SiteName") != site.SiteName ||
      getValues("BranchID") != site.BranchID ||
      getValues("SiteAddress") != site.SiteAddress ||
      getValues("clientID") != site.clientID ||
      getValues("CityName", site.City) ||
      getValues("SiteRegionName", site.Region) ||
      getValues("SitePincode", site.pincode) ||
      getValues("SiteAddress", site.Address) ||
      getValues("SiteArea", site.Area) ||
      getValues("CountryName", site.CountryName) ||
      getValues("StateName", site.StateName) ||
      getValues("SiteModeID", site.SiteModeID)
    );
  }

  const onCancel = (e) => {
    e.stopPropagation();
    if (isDataChanged()) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to cancel the changes made?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#027aaa",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Leave!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          onSelectSite(site.SiteID, true);
          setValue("SiteName", site.SiteName);
          setValue("BranchID", site.BranchID);
          setValue("SiteAddress", site.SiteAddress);
          setValue("clientID", site.clientID);
          setIsSiteEdit(false);
          // setSelectedUserRole([])
          setValue("CityName", site.City);
          setValue("SiteRegionName", site.Region);
          setValue("SitePincode", site.pincode);
          setValue("SiteAddress", site.Address);
          setValue("SiteArea", site.Area);
          setValue("SiteModeID", site.SiteModeID);
          // setValue("CountryName", site.CountryName);
          let tempCountryDetails = country?.filter(item => {
            return item.CountryMasterId == site.CountryId
          })
          if (tempCountryDetails?.length > 0) {
            setValue("CountryName", tempCountryDetails[0].CountryName);

          } else {
            setValue("CountryName", site.CountryName);
          }

          let tempCountryStateDetails = countryState?.filter(item => {
            return item.StateID == site.StateId
          })
          if (tempCountryStateDetails?.length > 0) {
            setValue("StateName", tempCountryStateDetails[0].StateName);
          } else {
            setValue("StateName", site.StateName);
          }
          clearSiteFields();
        }
      });
    } else {
      setIsSiteEdit(false);
    }
  };

  function isDataChangedInterface() {
    return (
      getValues("InterfaceName") != interfaceDevice.InterfaceName ||
      getValues("InterfaceType") != interfaceDevice.Interfacetypename ||
      getValues("InterfaceSubType") != interfaceDevice.Interfacesubtypename ||
      getValues("InterfaceIP") != interfaceDevice.InterfaceIP ||
      getValues("TimeZoneId") != interfaceDevice.TimeZoneId ||
      getValues("InterfacePort", interfaceDevice.InterfacePort) ||
      getValues("communicationPortInterface") != interfaceDevice.Communicationport||
      getValues("httpPortInterface") != interfaceDevice.InternetProtocolPort ||
      getValues("InterfaceUsername", interfaceDevice.UserName) ||
      getValues("InterfacePassword", interfaceDevice.Password) ||
      getValues("InterfaceTwoWayEnabled", interfaceDevice.IsTwoWayEnabled) ||
      getValues("CheckInternalHooter", interfaceDevice.CheckInternalHooter) ||
      getValues("CheckExternalHooter", interfaceDevice.CheckExternalHooter) ||
      getValues("IsHooterEnabled", interfaceDevice.IsHooterEnabled) ||
      getValues("PlaybackTimeStampsToUTC", interfaceDevice.CheckPlaybackUTCTime) ||
      getValues("PlaybackLongDateFormat", interfaceDevice.CheckPlaybackLongTime) ||
      getValues("EntityTypeID ", interfaceDevice.EntityTypeID) ||
      getValues("LiveRTSPURL", interfaceDevice.LiveRTSPURL) ||
      getValues("PlaybackRTSPURL", interfaceDevice.PlaybackRTSPURL) ||
      getValues("CCTVType", interfaceDevice.CCTVType)

    );
  }
  const onCancelInterface = (e) => {
    e.stopPropagation();
    if (isDataChangedInterface()) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to cancel the change made?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#027aaa",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Leave!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          // setValue("SiteID", interfaceDevice.SiteID)
          setValue("InterfaceName", interfaceDevice.InterfaceName)
          setValue("InterfaceType", interfaceDevice.Interfacetypename)
          setValue("InterfaceSubType", interfaceDevice.Interfacesubtypename)
          setValue("InterfaceIP", interfaceDevice.InterfaceIP)
          setValue("TimeZoneId", interfaceDevice.TimeZoneID || interfaceDevice.TimeZoneId)
          setValue("InterfacePort", interfaceDevice.InterfacePort)
          setValue("communicationPortInterface", interfaceDevice.Communicationport || interfaceDevice.communicationPortInterface || interfaceDevice.communicationPort)
          setValue("httpPortInterface",interfaceDevice.InternetProtocolPort || interfaceDevice.httpPortInterface || interfaceDevice.httpPort)
          setValue("InterfaceUsername", interfaceDevice.UserName)
          setValue("InterfacePassword", interfaceDevice.Password)
          setValue("LiveRTSPURL", interfaceDevice.LiveRTSPURL)
          setRtspValue(interfaceDevice.LiveRTSPURL)
          setValue("PlaybackRTSPURL", interfaceDevice.PlaybackRTSPURL)
          setPlaybackValue(interfaceDevice.PlaybackRTSPURL)
          setValue("EntityTypeID", interfaceDevice.EntityTypeID)
          setValue("deviceTypeId", interfaceDevice.EntityTypeID)
          setValue("CCTVType", interfaceDevice.CCTVType)
          setIsInterfaceEdit(false);
          clearInterfaceFields();
          if (interfaceDevice.isTwoWayEnabled || interfaceDevice.IsTwoWayEnabled == "1") {
            setValue("InterfaceTwoWayEnabled", 1);
            setParentIsEnablingTwoWayInterface(true);
          } else {
            setValue("InterfaceTwoWayEnabled", 0);
            setParentIsEnablingTwoWayInterface(false);
          }

          if (interfaceDevice.CheckPlaybackUTCTime || interfaceDevice.CheckPlaybackUTCTime == "1") {
            setValue("PlaybackTimeStampsToUTC", 1);
            setParentIsEnablingPlaybackTimeStampsToUTC(true);
          } else {
            setValue("PlaybackTimeStampsToUTC", 0);
            setParentIsEnablingPlaybackTimeStampsToUTC(false);
          }

          if (interfaceDevice.CheckPlaybackLongTime || interfaceDevice.CheckPlaybackLongTime == "1") {
            setValue("PlaybackLongDateFormat", 1);
            setParentIsEnablingPlaybackLongDateFormat(true);
          } else {
            setValue("PlaybackLongDateFormat", 0);
            setParentIsEnablingPlaybackLongDateFormat(false);
          }



          // else {
          // }
          if (interfaceDevice.CheckInternalHooter == true || interfaceDevice.CheckInternalHooter == "1") {
            setValue("CheckInternalHooter", 1);
            setParentIsEnablingInternalHooter(true);
          } else {
            setValue("CheckInternalHooter", 0);
            setParentIsEnablingInternalHooter(false);
          }

          if (interfaceDevice.CheckExternalHooter == true || interfaceDevice.CheckExternalHooter == "1") {
            setValue("CheckExternalHooter", 1);
            setParentIsEnablingExternalHooter(true);
          } else {
            setValue("CheckExternalHooter", 0);
            setParentIsEnablingExternalHooter(false);
          }

          if (interfaceDevice.isHooterEnabled == true || interfaceDevice.IsHooterEnabled == "1") {
            setValue("IsHooterEnabled", 1);
            setParentPanelIsEnablingHooter(true);
          } else {
            setValue("IsHooterEnabled", 0);
            setParentPanelIsEnablingHooter(false);
          }
        }
        else {
          setIsInterfaceEdit(true);
        }
      })
    }
  }

  function isDataChangedDevice() {
    return (
      getValues("SiteID") != selectedDevice.SiteID ||
      getValues("cameraName") != selectedDevice.CameraName ||
      getValues("privateIPAddress") != selectedDevice.privateIPAddress ||
      getValues("communicationPort") != selectedDevice.communicationPort ||
      getValues("httpPort") != selectedDevice.httpPort ||
      getValues("userName") != selectedDevice.userName ||
      getValues("userName") != selectedDevice.camUserName ||
      getValues("password") != selectedDevice.password ||
      getValues("password") != selectedDevice.camPassword ||
      getValues("port") != selectedDevice.port ||
      getValues("port") != selectedDevice.camPort ||
      getValues("channelNumber") != selectedDevice.channelNum ||
      // getValues("playbackChannelNumber") != selectedDevice.playbackChannelNum ||
      getValues("liveStreamTypeNumber") != selectedDevice.SubTypeLive ||
      getValues("playbackStreamTypeNumber") != selectedDevice.SubTypePlayback ||
      getValues("rTSPURL") != selectedDevice.RTSPURL ||
      getValues("location") != selectedDevice.Location ||
      getValues("ParentCameraID") != selectedDevice.ParentCameraID ||
      getValues("CameraBrandId") != selectedDevice.cameraBrandId ||

      getValues("CCTVTypeID") != selectedDevice.CCTVTypeID ||
      getValues("TimeZoneIdDevice") != selectedDevice.TimeZoneIdDevice
    );
  }

  const onCancelDevice = (e) => {
    e.stopPropagation();
    if (isDataChangedDevice()) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to cancel the change made?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#027aaa",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Leave!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setValue("SiteID", selectedDevice.SiteId || selectedDevice.SiteID)
          setValue("cameraName", selectedDevice.Name)
          setValue("cameraDeviceId", selectedDevice?.DeviceTypeID || selectedDevice?.cameraDeviceId)
          setValue("privateIPAddress", selectedDevice.CameraIp || selectedDevice.privateIPAddress || selectedDevice.InterfaceIP)
          setValue("communicationPort", selectedDevice.Communicationport || selectedDevice.communicationPort)
          setValue("httpPort", selectedDevice.InternetProtocolPort || selectedDevice.httpPort)
          setValue("userName", selectedDevice.userName || selectedDevice.CamUser)
          setValue("password", selectedDevice.password || selectedDevice.CamPassword)
          setValue("port", selectedDevice.port || selectedDevice.CameraPort || selectedDevice.InterfacePort)
          setValue("channelNumber", selectedDevice.ChannelNo)
          // setValue("playbackChannelNumber", selectedDevice.playbackChannelNum)

          let tempCameraBrandId = interfaceSubTypeData?.filter(item => {
            return item.InterfacesubtypeId == interfaceDevice.InterfacesubtypeId
          })
          let cameraBrandName = "";
          if (tempCameraBrandId != undefined) {
            cameraBrandName = tempCameraBrandId[0]?.Interfacesubtypename
          } else {
            cameraBrandName = "";
          }
          //New
          if (cameraBrandName == "Hikvision" || cameraBrandName == "Hikvision-Hybrid") {
            let liveSubType = selectedDevice.SubTypeLive == "01" ? "Main" : selectedDevice.SubTypeLive == "02" ? "Sub" : selectedDevice.SubTypeLive == "03" ? "Ter" : ""
            setValue("liveStreamTypeNumber", liveSubType)
            let playbackSubType = selectedDevice.SubTypePlayback == "01" ? "Main" : selectedDevice.SubTypePlayback == "02" ? "Sub" : selectedDevice.SubTypePlayback == "03" ? "Ter" : ""
            setValue("playbackStreamTypeNumber", playbackSubType)
          } else {
            let liveSubType = selectedDevice.SubTypeLive == "0" ? "Main" : selectedDevice.SubTypeLive == "1" ? "Sub" : selectedDevice.SubTypeLive == '2' ? "Ter" : ""
            setValue("liveStreamTypeNumber", liveSubType)
            let playbackSubType = selectedDevice.SubTypePlayback == "0" ? "Main" : selectedDevice.SubTypePlayback == "1" ? "Sub" : selectedDevice.SubTypePlayback == "2" ? "Ter" : ""
            setValue("playbackStreamTypeNumber", playbackSubType)
          }


          setValue("rTSPURL", selectedDevice.RTSPCameraUrl && selectedDevice.RTSPCameraUrl.replace("%40", "@"))
          setValue("location", selectedDevice.Location)
          setValue("ParentCameraID", selectedDevice.ParentCameraID)
          setValue("CameraBrandId", interfaceDevice.InterfacesubtypeId)
          setValue("CCTVTypeID", selectedDevice.CCTVTypeID)
          setValue("TimeZoneIdDevice", selectedDevice.TimeZoneIdDevice || selectedDevice.TimeZoneID)
          setValue("identifierName", selectedDevice.identifierName || selectedDevice.ExternalId)

          if (selectedDevice.IsTranscodingEnabled == "1") {
            setValue("isTranscoded", 1);
            setParentIsEncoding(true);
          } else {
            setValue("isTranscoded", 0);
            setParentIsEncoding(false);
          }
    
          if (selectedDevice.IsPlayBackTranscodingEnabled == "1") {
            setValue("isPlaybackTranscoded", 1);
            setParentIsPlaybackEncoding(true);
          } else {
            setValue("isPlaybackTranscoded", 0);
            setParentIsPlaybackEncoding(false);
          }
    
          if (selectedDevice.isTwoWayEnabled == "1") {
            setValue("isTwoWayEnabledDevice", 1);
            setParentIsEnablingTwoWayDevice(true);
          } else {
            setValue("isTwoWayEnabledDevice", 0);
            setParentIsEnablingTwoWayDevice(false);
          }
    
          if (selectedDevice.IsPtz == "1") {
            setValue("isPTZ", 1);
            setParentIsEnablingPTZ(true)
          } else {
            setValue("isPTZ", 0);
            setParentIsEnablingPTZ(false);
          }
    
          if (selectedDevice.ISPlaybackUTC == "1") {
            setValue("isPlaybackUTC", 1);
            setParentIsEnablingUTCPlayback(true);
          } else {
            setValue("isPlaybackUTC", 0);
            setParentIsEnablingUTCPlayback(false);
          }
          
          setIsDeviceEdit(false);
          clearCameraFields();
        } else {
          setIsDeviceEdit(true);
        }
      })
    }
  }

  const pointerEvent = !isSiteEdit ? "none" : "auto"
  const cursor = !isSiteEdit ? "auto" : ""

  const addCustomer = (e) => {
    let user = JSON.parse(localStorage.getItem('user'))
    if (getValues('AddCustomerName') === '') {
      setAddCustomerError('Please Enter a valid Customer Name!')
      return
    }
    try {
      // let addCustomerObj = {
      //   "ClientName": getValues('AddCustomerName')
      // }
      let addCustomerObj = {
        "ClientName": getValues('AddCustomerName'),
        "OrganizationMasterID": user.OrganizationMasterID.toString(),
        "UpdatedateTime": ""
      }
      addCustomerName(addCustomerObj)
        .then((resp) => {
          if (resp != undefined) {
            if (resp.Status == "success") {
              SuccessToast("New customer name added!")
              let loggedInUser = JSON.parse(localStorage.getItem('user'))
              getClientsUAPI(loggedInUser.Id)
              setValue('AddCustomerName', '')
              setShow(false)
            }
          }
        })
    } catch (error) {
      console.error(error)
    }
  }

  const handleCountryChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedCountryValue = selectedOption.value;
    const selectedCountryValueId = selectedOption.getAttribute('id');
    try {
      getStateDetails(selectedCountryValueId).then((resp) => {
        if (resp != undefined) {
          if (resp.Status == "success") {
            setCountryState(resp.Data)
          } else {
            setCountryState([])
          }
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  const interfaceSubTypeHandler = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedInterfaceType = selectedOption.value;
    const selectedInterfaceTypeId = selectedOption.getAttribute('id');
    try {
      let obj ={
        "type": "interfacesubtypemaster",
        "parameters": {
            "InterfacetypeId": selectedInterfaceTypeId
        }
    }
      getInterfaceSubTypeData(obj).then((resp) => {
        if (resp != undefined) {
          if (resp.Status == "success") {
            let CCTV = interfaceTypeData?.find((item) =>item.Interfacetypename == "CCTV")
            let ACS = interfaceTypeData?.find((item) =>item.Interfacetypename == "ACS")
            let RTU = interfaceTypeData?.find((item) =>item.Interfacetypename == "RTU")
            let FirePanel = interfaceTypeData?.find((item) =>item.Interfacetypename == "Fire Panel")
            let Mobile = interfaceTypeData?.find((item) =>item.Interfacetypename == "Mobile")
            setInterfaceSubTypeData(resp.Data)
            if (selectedInterfaceTypeId == CCTV?.InterfacetypeId) {
              setInterfaceType(NVRDVR)
              setDisplayTwoWay(true)
              // setDisplayHooter(false)
              setEnableHooter(false)
              setValue("CCTVTypeIDInterface", 0);
              setDisplayEntity(true)
            }
            else if (selectedInterfaceTypeId == ACS?.InterfacetypeId) {
              setInterfaceType(ACS);
              setDisplayTwoWay(false)
              setDisplayCamera(false)
              setEnableHooter(false);
              setDisplayEntity(false);
            }
            else if (selectedInterfaceTypeId == FirePanel?.InterfacetypeId) {
              setInterfaceType(FAS);
              setDisplayTwoWay(false)
              setDisplayCamera(false)
              setEnableHooter(false);
              setDisplayEntity(false);
            }
            else if (selectedInterfaceTypeId == RTU?.InterfacetypeId){
              setInterfaceType(RTU);
              setDisplayTwoWay(false)
              setDisplayCamera(false)
              setEnableHooter(false);
              setDisplayEntity(false);
            }
            else if (selectedInterfaceTypeId == Mobile?.InterfacetypeId){
              setInterfaceType(MOBILE);
              setDisplayTwoWay(false)
              setDisplayCamera(false)
              setEnableHooter(false);
              setDisplayEntity(false);
            }
            else {
              setInterfaceType(PANEL)
              setDisplayTwoWay(false)
              setDisplayCamera(false)
              //setDisplayHooter(true)
              setEnableHooter(true)
              setDisplayEntity(false);
            }
          } else {
            setInterfaceSubTypeData(null)
          }
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  const interfaceForDeviceTypeHandler = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedInterfaceTypeId = selectedOption.getAttribute('id');
    getDeviceTypeByInterfaceId(selectedInterfaceTypeId)
  }
  const getDeviceTypeByInterfaceId = (id) => {

    getDeviceTypeOnInterfaceId(id)
      .then((res) => {

        if (res.Status == "success") {
        let deviceType = interfaceTypeData.find((item) =>
            item.InterfacetypeId == id
        )
        if (deviceType?.Interfacetypename == "Alarm Panel"){
          setDeviceTypeData(res.Data)
          let arr = res.Data?.filter(
            (item) => item.DeviceType == "IDS Panel"
          );
          setDeviceTypeDataForInterface(arr)
        }
        else if(deviceType?.Interfacetypename == "ACS") {
            setDeviceTypeData(res.Data)
            let arr = res.Data?.filter(
              (item) => item.DeviceType == "ACS Controller"
            );
            setDeviceTypeDataForInterface(arr)
          } else if (deviceType?.Interfacetypename == "Fire Panel") {
            let arrFRSDevice = res.Data?.filter(
              (item) => item.DeviceType != "Fire Panel" 
            );
            setDeviceTypeData(arrFRSDevice)
            let arrFRS = res.Data?.filter(
              (item) => item.DeviceType == "Fire Panel" 
            );
            setDeviceTypeDataForInterface(arrFRS)
           
          } else if (deviceType?.Interfacetypename == "RTU") {
            let arrRTUDevice = res.Data?.filter(
              (item) => item.DeviceType != "RTU" 
            );
            setDeviceTypeData(arrRTUDevice)
            let arrRTU = res.Data?.filter(
              (item) => item.DeviceType == "RTU"
            );
            setDeviceTypeDataForInterface(arrRTU)
          }
          else {
            setDeviceTypeData(res.Data)
            setDeviceTypeDataForInterface(res.Data)
          }
        } else {
          setDeviceTypeData([])
          setDeviceTypeDataForInterface([])
        }
      }).catch(err => console.log(err))
  }
 
  const getDeviceStage =()=>{
    getDeviceStagedata()
    .then((res) => {
      if(res.Status == "success"){
        setDeviceStage(res.Data)
      }else{
        setDeviceStage([])
      }
    }).catch(err => console.log(err))
  }
  
  const handleOptionChange = (option) => {
    setSelectedBrand(option);
    // Determine the placeholder for the next input based on the selected option
    if (+option === 1) {
      setChannelNumberPlaceholder("Channel Number* e.g. 101");
    } else if (+option === 2) {
      setChannelNumberPlaceholder("Channel Number* e.g. 1");
    } else {
      setChannelNumberPlaceholder("Channel Number* e.g. 1");
    }
  };

  const onNumberOnlyChange = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp("[0-9]").test(keyValue);
    if (!isValid) {
      event.preventDefault();
      return;
    }
  };

  const onSpecialChangeOnly = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp("^[A-Za-z0-9.\\-_ ]*$").test(keyValue);
    if (!isValid) {
      event.preventDefault();
      return;
    }
  }

  const onNumberOnlyChange2 = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp("[0-9.]").test(keyValue);
    if (!isValid) {
      event.preventDefault();
      return;
    }
  };

  const changeTab = (e, type) => {
    switch (type) {
      case SITES:
        setSearchTextSite('');
        break;

      case INTERFACES:
        setSearchTextInterface('');
        break;

      case DEVICES:
        setSearchTextDevice('');
        break;
    }
    setActiveTab(type)
  }

  const timeInterfaceZoneHandler = (e) => {

    try {
      GetmultiTimeZone().then((resp) => {
        if (resp != undefined) {
          if (resp.Status == "success") {
            setTimeZone(resp.Data)

          } else {
            setTimeZone(null)
          }
        }
      })
    } catch (error) {
      console.error(error)
    }
  }
  const RTSP = [
    {
      id: "Username",
      display: "[Username]",
    },
    {
      id: "Password",
      display: "[Password]",
    },
    {
      id: "IpAddress",
      display: "[IpAddress]",
    },
    {
      id: "Port",
      display: "[Port]",
    },
    {
      id: "ChannelNo",
      display: "[ChannelNo]",
    },
    {
      id: "LiveStreamType",
      display: "[LiveStreamType]",
    },
  ];

  const PLAYBACK = [
    {
      id: "Username",
      display: "[Username]",
    },
    {
      id: "Password",
      display: "[Password]",
    },
    {
      id: "IpAddress",
      display: "[IpAddress]",
    },
    {
      id: "Port",
      display: "[Port]",
    },
    {
      id: "ChannelNo",
      display: "[ChannelNo]",
    },
    {
      id: "PlaybackStreamType",
      display: "[PlaybackStreamType]",
    },
    /*   {
        id: "StartDate",
        display: "[StartDate]",
      },
      {
        id: "EndDate",
        display: "[EndDate]",
      },
      {
        id: "DateFormat",
        display: "[DateFormat]",
      }, */
    {
      id: "DateDD",
      display: "[DD]",
    },
    {
      id: "DateMM",
      display: "[MM]",
    },
    {
      id: "DateYY",
      display: "[YY]",
    },
    {
      id: "DateYYYY",
      display: "[YYYY]",
    },
    {
      id: "HoursHH",
      display: "[hh]",
    },
    {
      id: "MinutesMM",
      display: "[mm]",
    },
    {
      id: "SecondsSS",
      display: "[ss]",
    },
  ];

const getEmergencyContact = (SiteID) => {
  try {
    getEmergencyContactsBysite(SiteID).then((resp) => {
      if (resp != undefined) {
        if(resp.Status == "success" && resp.Data != null){
          let arr = resp.Data;
          let obj =  {
            "EmergencyContactID": 0,
            "SiteID": SiteID,
            "ContactName": "",
            "Phone": "",
            "SMS": null,
            "Email": null,
            "WhatsApp": null,
            "CreatedOn": "",
            "CreatedBy": null,
            "ModifiedOn": "",
            "ModifiedBy": null,
            "EmailID": "",
            "IsCall": null,
            "InApp": null,
            "SubscriptionArn": null,
            "UserID": null,
            "ContactLevel": 0,
            "Designation": "",
            "IsERT": null,
            "IsCustomerSPOC": null,
            "OrganizationMasterID": 0,
            "CategoryID": 0,
            "UpdatedateTime": ""
        }
          arr.push(obj)
          setAllEmergencyContact(arr) 
          setMainEmergencyContact(arr)
      

        }
        else if(resp.Status == "success" && resp.Data == null){          
          let arr = [];
          let obj =  {
            "EmergencyContactID": 0,
            "SiteID": SiteID,
            "ContactName": "",
            "Phone": "",
            "SMS": null,
            "Email": null,
            "WhatsApp": null,
            "CreatedOn": "",
            "CreatedBy": null,
            "ModifiedOn": "",
            "ModifiedBy": null,
            "EmailID": "",
            "IsCall": null,
            "InApp": null,
            "SubscriptionArn": null,
            "UserID": null,
            "ContactLevel": 0,
            "Designation": "",
            "IsERT": null,
            "IsCustomerSPOC": null,
            "OrganizationMasterID": 0,
            "CategoryID": null,
            "UpdatedateTime": ""
        }
          arr.push(obj)
          setAllEmergencyContact(arr)
          setMainEmergencyContact(arr)
        }
      }
    })
  } catch (error) {
    console.error(error)
  }
}

  const getCategoryId = () => {
    try {
      let obj = {
        "type": "ContactCategory_Master",
        "parameters": {
          "UserId": localStorage.getItem('UserID')
        }
      }
      getCategoryIdlist(obj).then((resp) => {
        if (resp != undefined) {
          if (resp.Status == "success") {
            let arr = resp.Data
            if (arr == null) {
              setCategoryIdList([])
              setMainCatagoryIdList([])
            } else {
              setCategoryIdList(arr)
              setMainCatagoryIdList(arr)
            }
          } else {
            setCategoryIdList([])
            setMainCatagoryIdList([])
          }
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  const searchNameList = (e) => {
    setNameSearch(e.target.value);
    let tempArr = mainEmergencyContact.filter(x => x.ContactName.toLowerCase().includes(e.target.value.toLowerCase()))
    setAllEmergencyContact(tempArr)
    // setNoRecordsFound(tempArr.length === 0);

  }

  const searchEmailList = (e) => {
    setEmailSearch(e.target.value);
    let tempArr = mainEmergencyContact.filter(x => x.EmailID.toLowerCase().includes(e.target.value.toLowerCase()))
    setAllEmergencyContact(tempArr)
    // setNoRecordsFound(tempArr.length === 0);

  }

  const searchContactList = (e) => {
    SetContactSearch(e.target.value);
    let tempArr = mainEmergencyContact.filter(x => x.Phone.toLowerCase().includes(e.target.value.toLowerCase()))
    setAllEmergencyContact(tempArr)
    // setNoRecordsFound(tempArr.length === 0);
  }

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setCategorySearch(selectedCategory);
    
    if (selectedCategory === "") {
      setContactLevelSearch("");
      setAllEmergencyContact(mainEmergencyContact); 
      setContactLevelOptions([]);
    } else {
      const filteredContacts = mainEmergencyContact.filter(contact => contact.CategoryID.toString() === selectedCategory);
      setAllEmergencyContact(filteredContacts); 
      // setNoRecordsFound(filteredContacts.length === 0);
    }
    const selectedCategoryforLevel = categoryIdList?.find(cat => cat.CategoryID === parseInt(selectedCategory));
    if (selectedCategoryforLevel) {
      const levelLimit = selectedCategoryforLevel.LevelLimit;
      const newContactLevelOptions = Array.from({ length: levelLimit }, (_, index) => index + 1);

      setContactLevelOptions(newContactLevelOptions);
      setContactLevelSearch(newContactLevelOptions[0]); 
    }
  };

  const handleContactLevelChange = async (e) => {
    const newContactLevel = e.target.value;
    setContactLevelSearch(newContactLevel);

    // If newContactLevel is empty, show all contacts for the selected category
    if (newContactLevel === "" && categorySearch !== "") {
        // Filter contacts by category only
        const filteredContactsByCategory = mainEmergencyContact.filter(contact =>
            contact.CategoryID.toString() === categorySearch
        );
        setAllEmergencyContact(filteredContactsByCategory);
        // setNoRecordsFound(filteredContactsByCategory.length === 0);
    } else if (newContactLevel !== "") {
        // If newContactLevel is not empty, filter by both category and level
        const filteredContactsByLevel = mainEmergencyContact.filter(contact =>
            contact.CategoryID.toString() === categorySearch && contact.ContactLevel === parseInt(newContactLevel)
        );
        setAllEmergencyContact(filteredContactsByLevel);
        // setNoRecordsFound(filteredContactsByLevel.length === 0);
    } else if (categorySearch === "" ) {
        // If both category and level are empty, show all contacts
        setAllEmergencyContact(mainEmergencyContact);
    }
  }
// Regex for Search Filters
  const nameRegex = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp("^[A-Za-z0-9.\\-_ ]*$").test(keyValue);
    if (!isValid) {
        event.preventDefault();
        return;
    }
  };

  const numberRegex = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp("[0-9]").test(keyValue);
    if (!isValid || event.target.value.length >= 10) {
        event.preventDefault();
        return;
    } 
  };

  const emailRegex = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    const isValid = /[a-zA-Z0-9._%+-@]/.test(keyValue);

    if (!isValid) {
      event.preventDefault();
    }
  };

  
  const handleZone = () =>{
    setZoneForm(true);
  }


  // Refresh

  return (
    <>
      
        <div className="">
          <div className="">
            <ul className="progressbar">
              <li className="active" >
                <div className={`${activeTab === SITES ? "stepperIconContainer progressactive" : "stepperIconContainer"}`}
                  onClick={(e) => {
                    setFilteredSites(sites)
                    
                    changeTab(e, SITES)
                    setInterfaceDataList(null)
                    setcameradeviceslist(null)
                    setpaneldeviceslist(null)
                    setAcsDevicesList(null)
                    setRtuDeviceList(null)
                    setFasDeviceList(null)
                    let tempdeviceObj = {
                      "ParentCameraID": 0,
                      "cameraName": '',
                      "privateIPAddress": '',
                      "SiteID": 0,
                      "userName": '',
                      "password": '',
                      "port": '',
                      "channelNumber": '',
                      "liveStreamTypeNumber": '',
                      "playbackStreamTypeNumber": '',
                      "rTSPURL": '',
                      "location": '',
                      "PanelMasterId": 0,
                      "CameraBrandId": 0,
                      "communicationPort": '',
                      "httpPort": '',
                      "isTranscoded": '',
                      "isPlaybackTranscoded": '',
                      "isTwoWayEnabledDevice": '',
                      "interfaceId": '',
                      "CCTVTypeID": 0,
                      "TimeZoneIdDevice": 0,
                      "isPTZ": "",
                      "isPlaybackUTC": "",
                      "identifierName": "",
                      "cameraDeviceId": 0,
                      "deviceStageTypeId":0
                    }
                    setSelectedDevice(tempdeviceObj);
                    setVideoBackupChecked(false);
                    setAlertChecked(false);
                    setHealthMonitoringChecked(false);
                    setCamerasChecked(false);
                    handleRefClick();
                    let interfaceObjTemp = {
                      "siteid": 0,
                      "InterfaceId": 0,
                      "InterfaceName": '',
                      "InterfaceType": 0,
                      "InterfaceSubType": 0,
                      "InterfaceIP": '',
                      "InterfacePort": '',
                      "InterfaceUsername": '',
                      "InterfacePassword": '',
                      "UserId": 0,
                      "EntityTypeID": 0,
                      "CCTVTypeIDInterface": 0,
                      "InterfaceTwoWayEnabled": '',
                      "CheckInternalHooter": 0,
                      "CheckExternalHooter": 0,
                      "IsHooterEnabled": 0,
                      "PlaybackTimeStampsToUTC": '',
                      "PlaybackLongDateFormat": '',
                      "LiveRTSPURL": '',
                      "PlaybackRTSPURL": '',
                      "CCTVType": '',
                      "TimeZoneId": 0,
                      "deviceTypeId": 0,
                      "communicationPortInterface": '',
                      "httpPortInterface":''
                    }
                    setSelectedInterface(interfaceObjTemp);
                    clearInterfaceFields();
                  }}>
                  <img src={activeTab === SITES ? SiteSelected : SiteDefault} alt="Sites" />
                </div>
                <span className="stepperText">
                  Site <span style={{ color: "#8f8e8e", fontSize: "12px" }}>({filteredSites?.length})</span>
                </span>
              </li>
              <li className="active" >
                <div
                  className={`${activeTab === SITES && interfaceTab ? "stepperIconContainer progressdisable" : activeTab === INTERFACES ? "stepperIconContainer progressactive" : "stepperIconContainer"}`}
                  onClick={(e) => {
                    if (interfaceTab) {
                      return
                    } else {
                      getInterfaceData()
                      changeTab(e, INTERFACES)
                      if (interfaceDevice.InterfaceId == 0) {
                        setIsInterfaceEdit(true)
                      } else {
                        setIsInterfaceEdit(false)
                      }
                      setcameradeviceslist(null)
                      setpaneldeviceslist(null)
                      setAcsDevicesList(null)
                      setRtuDeviceList(null)
                      setFasDeviceList(null)
                      let tempdeviceObj = {
                        "ParentCameraID": 0,
                        "cameraName": '',
                        "privateIPAddress": '',
                        "SiteID": 0,
                        "userName": '',
                        "password": '',
                        "port": '',
                        "channelNumber": '',
                        "liveStreamTypeNumber": '',
                        "playbackStreamTypeNumber": '',
                        "rTSPURL": '',
                        "location": '',
                        "PanelMasterId": 0,
                        "CameraBrandId": 0,
                        "communicationPort": '',
                        "httpPort": '',
                        "isTranscoded": '',
                        "isPlaybackTranscoded": '',
                        "isTwoWayEnabledDevice": '',
                        "interfaceId": '',
                        "CCTVTypeID": 0,
                        "TimeZoneIdDevice": 0,
                        "isPTZ": "",
                        "isPlaybackUTC": "",
                        "identifierName": "",
                        "cameraDeviceId": 0,
                        "deviceStageTypeId":0
                      }
                      setSelectedDevice(tempdeviceObj);
                      setVideoBackupChecked(false);
                      setAlertChecked(false);
                      setHealthMonitoringChecked(false);
                      setCamerasChecked(false);
                      setAssociateCamSecVisibility(false)
                      handleInterfaceRefClick();
                      clearCameraFields();
                      clearSiteFields();
                    }
                  }}>
                  <img
                    src={activeTab === SITES && interfaceTab ? InterfaceDisable : activeTab === INTERFACES ? InterfaceSelected : InterfaceDefault}
                    alt="interface icon"
                    width={18} />
                </div>
                <span className={`${interfaceTab ? "StepperTextDisable" : "stepperText"}`}>
                  Interface {interfaceDataList && interfaceDataList?.length > 0 && <span style={{ color: "#8f8e8e", fontSize: "12px" }}>({interfaceDataList?.length})</span>}
                </span>

              </li>

              <li className="active">
                <div className={`${disableTab ? "stepperIconContainer progressdisable" : activeTab === DEVICES ? "stepperIconContainer progressactive" : "stepperIconContainer"}`} onClick={(e) => {

                  if (disableTab) {
                    return
                  } else {
                    if (selectedDevice.ParentCameraID != 0) {
                      return;
                    }
                    changeTab(e, DEVICES)
                    let temp = 0, otherTemp = 0;
                    if (interfaceDevice?.Interfacetypename == "CCTV") {
                      //if (true) {
                      //let arr = interfaceSubTypeData.filter(item => item.Interfacesubtypename == interfaceDevice.Interfacesubtypename);
                      temp = interfaceDevice.InterfacesubtypeId;
                      let tempDeviceId = deviceType.find((item) => item.DeviceType == "Camera")
                      let deviceObject = {
                        "ParentCameraID": 0,
                        "cameraName": interfaceDevice.InterfaceName,
                        "privateIPAddress": interfaceDevice.InterfaceIP,
                        "SiteID": interfaceDevice.SiteId || interfaceDevice.siteid,
                        "userName": interfaceDevice.UserName,
                        "password": interfaceDevice.Password,
                        "port": interfaceDevice.InterfacePort,
                        "channelNumber": '',
                        "liveStreamTypeNumber": '',
                        "playbackStreamTypeNumber": '',
                        "rTSPURL": '',
                        "location": '',
                        "PanelMasterId": otherTemp,
                        "CameraBrandId": temp,
                        "communicationPort": interfaceDevice.Communicationport || interfaceDevice.communicationPortInterface,
                        "httpPort": interfaceDevice.InternetProtocolPort || interfaceDevice.httpPortInterface,
                        "isTranscoded": 0,
                        "isPlaybackTranscoded": 0,
                        "isTwoWayEnabledDevice": 0,
                        "CCTVTypeID": interfaceDevice.EntityTypeID,
                        "TimeZoneIdDevice": interfaceDevice.TimeZoneId || interfaceDevice.TimeZoneID || 1,
                        "isPTZ": "" || 0,
                        "isPlaybackUTC": "",
                        "identifierName": "",
                        "cameraDeviceId": tempDeviceId?.DeviceTypeID || 6,
                        "deviceStageTypeId":0
                      }
                      setSelectedDevice(deviceObject);
                      setVideoBackupChecked(false);
                      setAlertChecked(false);
                      setHealthMonitoringChecked(false);
                      setCamerasChecked(false);
                      setAssociateCamSecVisibility(false)
                      setIsDeviceEdit(true)
                      getdeviceslistdata()
                    }
                    // else if(interfaceDevice.InterfacetypeId == 2){
                      
                    // }
                    else if (interfaceDevice?.Interfacetypename == "ACS" || interfaceDevice?.Interfacetypename == "Fire Panel" || interfaceDevice?.Interfacetypename == "RTU") {
                      //let arr = devicesmasterlist.panelTypeMasterList.filter(item => item.panelName == interfaceDevice.Interfacesubtypename);
                      //temp = arr[0].panelMasterID;
                      console.log("STEPPER", acsDevicesList)
                      let arr = interfaceSubTypeData?.filter(
                        (item) => item.Interfacesubtypename == interfaceDevice.Interfacesubtypename
                      );
                      temp = arr[0].InterfacesubtypeId;
                      let identifier = 0 
                      if (interfaceDevice?.Interfacetypename == "ACS"){
                          let acsControllerId = deviceType.find((item) => item.DeviceType == "ACS Controller");
                          let acsReaderId = deviceType.find((item) => item.DeviceType == "ACS Reader");                  
                          identifier = acsDevicesList == null ? acsControllerId?.DeviceTypeID : acsReaderId?.DeviceTypeID
                      }else if(interfaceDevice?.Interfacetypename == "Fire Panel"){
                        let tempDeviceTypeFRS = deviceType.find((item) => item.DeviceType == "Fire Panel"|| item.DeviceType == "FRS") 
                          //identifier = tempDeviceTypeFRS?.DeviceTypeID
                          identifier = 0
                      }else if (interfaceDevice?.Interfacetypename == "RTU"){
                        let tempDeviceTypeRTU = deviceType.find((item) => item.DeviceType == "RTU") 
                         // identifier = tempDeviceTypeRTU?.DeviceTypeID
                         identifier = 0
                      }
                      let tempDeviceId = deviceType.find((item) => item.DeviceType == "Camera")
                      let deviceObject = {
                        "ParentCameraID": 0,
                        "cameraName": "",
                        "privateIPAddress": interfaceDevice.InterfaceIP,
                        "SiteID": interfaceDevice.SiteId || interfaceDevice.siteid,
                        "userName": interfaceDevice.UserName,
                        "password": interfaceDevice.Password,
                        "port": interfaceDevice.InterfacePort,
                        "channelNumber": '',
                        "liveStreamTypeNumber": '',
                        "playbackStreamTypeNumber": '',
                        "rTSPURL": '',
                        "location": '',
                        "PanelMasterId": temp,
                        "CameraBrandId": temp,
                        "communicationPort": '',
                        "httpPort": '',
                        "isTranscoded": 0,
                        "isPlaybackTranscoded": 0,
                        "isTwoWayEnabledDevice": 0,
                        "CCTVTypeID": 0,
                        "TimeZoneIdDevice": interfaceDevice.TimeZoneID || 1,
                        "isPTZ": "" || 0,
                        "isPlaybackUTC": "",
                        "identifierName": "",
                        "cameraDeviceId": tempDeviceId?.DeviceTypeID || 6,
                        "acsDeviceType": identifier,
                        "deviceStageTypeId":0
                       // "acsDeviceType": acsDevicesList == null ? 10 : 11,
                        // "fasDeviceType": fasDeviceList == null ?  : ,
                        // "rtuDeviceType": rtuDeviceList == null ?  : ,
                      }
                      setSelectedDevice(deviceObject);
                      setVideoBackupChecked(false);
                      setAlertChecked(false);
                      setHealthMonitoringChecked(false);
                      setCamerasChecked(false);
                      setAssociateCamSecVisibility(false)
                      setIsDeviceEdit(true)
                      getdeviceslistdata()
                    }
                    else {
                      // let arr = devicesmasterlist.panelTypeMasterList.filter(item => item.panelName == interfaceDevice.Interfacesubtypename);
                      // otherTemp = arr[0].panelMasterID

                      let arr = interfaceSubTypeData?.filter(
                        (item) => item.Interfacesubtypename == interfaceDevice.Interfacesubtypename
                      );
                      otherTemp = arr[0].InterfacesubtypeId;                  
                      let tempDeviceId = deviceType.find((item) => item.DeviceType == "Camera")
                      let acsControllerId = deviceType.find((item) => item.DeviceType == "ACS Controller");
                      let acsReaderId = deviceType.find((item) => item.DeviceType == "ACS Reader");
                      let deviceObject = {
                        "ParentCameraID": 0,
                        "cameraName": mobileDisplay ? "" : interfaceDevice.InterfaceName,
                        "privateIPAddress": interfaceDevice.InterfaceIP,
                        "SiteID": interfaceDevice.SiteId || interfaceDevice.siteid,
                        "userName": interfaceDevice.UserName,
                        "password": interfaceDevice.Password,
                        "port": interfaceDevice.InterfacePort,
                        "channelNumber": '',
                        "liveStreamTypeNumber": '',
                        "playbackStreamTypeNumber": '',
                        "rTSPURL": '',
                        "location": '',
                        "PanelMasterId": otherTemp,
                        "CameraBrandId": otherTemp,
                        "communicationPort": '',
                        "httpPort": '',
                        "isTranscoded": 0,
                        "isPlaybackTranscoded": 0,
                        "isTwoWayEnabledDevice": 0,
                        "CCTVTypeID": 0,
                        "TimeZoneIdDevice": interfaceDevice.TimeZoneID || 1,
                        "isPTZ": "" || 0,
                        "isPlaybackUTC": "",
                        "identifierName": "",
                        "cameraDeviceId": tempDeviceId?.DeviceTypeID || 6,
                        "acsDeviceType": acsDevicesList == null ? acsControllerId.DeviceTypeID : acsReaderId.DeviceTypeID,
                        "deviceStageTypeId":0
                      }
                      setSelectedDevice(deviceObject);
                      setVideoBackupChecked(false);
                      setAlertChecked(false);
                      setHealthMonitoringChecked(false);
                      setCamerasChecked(false);
                      getdeviceslistdata()
                      setIsDeviceEdit(true)
                    }
                  }

                }}>
                  <img src={disableTab ? DevicesDisable : activeTab === DEVICES ? DevicesSelected : DevicesDefault} alt="device icon" width={17} />
                </div>

                <span className={`${disableTab ? "StepperTextDisable" : "stepperText"}`}>
                  Devices {interfaceType && (cameradeviceslist?.length > 0 || paneldeviceslist?.length > 0 || acsDevicesList?.length > 0 || fasDeviceList?.length > 0 || rtuDeviceList?.length > 0) &&
                    !disableTab &&
                    <span style={{ color: "#8f8e8e", fontSize: "12px" }}>
                      ({interfaceType === NVRDVR ? cameradeviceslist?.length : interfaceType === ACS ? acsDevicesList?.length : interfaceType === FAS ? fasDeviceList?.length : interfaceType === RTU ? rtuDeviceList?.length : paneldeviceslist?.length})</span>}
                </span>
              </li>
            </ul>
          </div>

          <div className="">
            {
              activeTab == SITES ?
              <>
                {zoneForm ? (
                  <AddZoneForm setZoneForm={setZoneForm} zoneForm={zoneForm} site={site} country={country} countryState={countryState} resetSite={resetSite} />
                  ) : (
                  <div className="SiteMainContainer SiteHeightDiv">
                    <div className="SiteMainHeightDiv">
                      <div className="SiteLeftContainer AutoHgtSiteScrollbar">
                        <div className="m-2 HeaderSiteList">
                          <input
                            id="Search_txt_site"
                            className="SearchViewInput1"
                            type="text"
                            onChange={(e) => {
                              setSearchTextSite(e.target.value)
                              onSearchChange(e.target.value, "Site List")
                            }
                            }
                            //autoFocus
                            placeholder="Search Site"
                            value={searchTextSite}
                          />
                            {
                              isDarkTheme ?
                                <img
                                  className="EyeIcon"
                                  src={SearchIcon}
                                  alt="search icon"
                                /> :
                                <img
                                  className="EyeIcon"
                                  src={SearchIconWhite}
                                  alt="search icon" height="15"
                                />
                            }
                        </div>
                        <div className="StepperSiteList" id="siteListDiv" >
                          {
                            filteredSites && (
                              filteredSites?.length > 0 ?
                                filteredSites.filter(i => i.ParentID == null).map((item) => {
                                  return (
                                    <div
                                      ref={item.SiteID == site?.SiteID ? siteRef : null}
                                      className={site?.SiteID == item.SiteID ? "OneList SelectedList p-0 pr-1" : "OneList p-0 pr-1"}
                                      key={item.SiteID}
                                    >
                                      <div className="ListSiteWithZone"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onSelectSite(item.SiteID, true);
                                        setActiveTabKey("Site_Details")
                                        getEmergencyContact(item.SiteID);
                                        setInterfaceDataList(null)
                                        clearSiteFields()
                                      }}>
                                        <p className="ListofText">
                                          {item.SiteName}
                                          <span className="SiteNameText"> - {item.BranchID}</span>
                                        </p>
                                      </div>
                                      <button className="addCustomer" style={{ marginLeft: "10px" }} onClick={
                                        () => {
                                          onSelectSite(item.SiteID, true);
                                          handleZone()
                                        }
                                        }>
                                        <span className="ViewUpdate">
                                          <img src={RightArrow} alt="add plus icon" />
                                        </span>
                                      </button>
                                    </div>
                                  );
                                }) : <div className="no-data-found"><p>No Site Found</p></div>
                            )
                          }
                          {!filteredSites && (
                            <div className="no-data-found">No Sites Available</div>
                          )}
                        </div>

                      </div>
                      <div className="SiteRightContainer">
                        {/* <h1 className="MainHeaderName">Site Details</h1> */}
                        <Tabs
                            defaultActiveKey="Site_Details"
                            id="uncontrolled-tab-example"
                            className="AlertTemplateTab"
                            onSelect={(e) => {
                              setActiveTabKey(e)
                              setCategorySearch("");
                              setContactLevelSearch("");
                              setNameSearch("");
                              SetContactSearch("");
                              setEmailSearch("");
                              setAllEmergencyContact(mainEmergencyContact);
                              
                            }}
                            activeKey={activeTabKey}
                        >
                            <Tab eventKey="Site_Details" title="Site Details">
                              <div>
                              <div className="siteformContainer">
                          <div>
                            <form onSubmit={handleSubmit((e) => onSubmit(e, site.SiteID, site))}>
                              <div className="site-form" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <div className="inputMainContainer w40dot75rem">
                                  <div style={{ display: "flex" }}>
                                    <div className="inputTypeLabelContainer" style={{ width: "95%" }}>
                                      <label className='formFieldLabels'>Select Customer</label>
                                      <select
                                        required
                                        disabled={!isSiteEdit}
                                        {...register("clientID")}
                                        className="inputType ArrowSelectClass"
                                        defaultValue={site?.ClientId}
                                        onChange={(e) => {
                                          setValue("clientID", e.target.value);
                                          setCustomerError('')
                                        }}
                                      >
                                        <option key="0" disabled={false} value="0">Select Customer*</option>
                                        {clients &&
                                          clients.map((val) => (
                                            <option value={val.ClientId} key={val.ClientName}>
                                              {val.ClientName}
                                            </option>
                                          ))}
                                      </select>
                                      {/* </div> */}
                                    </div>
                                    <OverlayTrigger
                                      placement='bottom'
                                      overlay={
                                        <Tooltip>
                                          Add Customer
                                        </Tooltip>
                                      }
                                    >
                                      <button className="addCustomer" style={{ marginLeft: "10px" }} onClick={(e) => {
                                        e.preventDefault()
                                        setShow(!show)
                                      }}>
                                        <span className="ViewUpdate">
                                          <img src={AddNode} alt="add plus icon" />
                                        </span>
                                      </button>
                                    </OverlayTrigger>
                                  </div>
                                  <p className="Error_P" style={{ float: "left" }}><span>{customerError}</span></p>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Site Name</label>
                                    <input
                                      {...register("SiteName")}
                                      className="inputType"
                                      disabled={!isSiteEdit}
                                      placeholder="Site Name*"
                                      onKeyPress={(e) => {
                                        onSpecialChangeOnly(e);
                                        setSiteError('')
                                      }}
                                      onChange={() => { setSiteError('') }}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span>{siteError}</span></p>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Select Country</label>
                                    <select
                                      {...register("CountryName")}
                                      disabled={!isSiteEdit}
                                      className="inputType ArrowSelectClass"
                                      onChange={(e) => {
                                        handleCountryChange(e)
                                        setCountryError('')
                                      }}
                                    >
                                      <option key="0" disabled={false} value="0" id="0">Select Country*</option>
                                      {country &&
                                        country.map((val) => (
                                          <option value={val.countryname} key={val.countrymasterid} id={val.countrymasterid}>
                                            {val.countryname}
                                          </option>
                                        ))}
                                    </select>
                                    <p className="Error_P" style={{ float: "left" }}><span> {countryError} </span></p>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Select State</label>
                                    <select
                                      {...register("StateName")}
                                      disabled={!isSiteEdit}
                                      className="inputType ArrowSelectClass"
                                      onChange={() => {
                                        setStateError('')
                                      }}
                                    >
                                      <option key="0" disabled={false} value="0">Select State*</option>
                                      {countryState &&
                                        countryState.map((val) => (
                                          <option value={val.statename} key={val.statemasterid}>
                                            {val.statename}
                                          </option>
                                        ))}
                                    </select>
                                    <p className="Error_P" style={{ float: "left" }}><span> {stateError} </span></p>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>City</label>
                                    <input
                                      {...register("CityName")}
                                      className="inputType"
                                      disabled={!isSiteEdit}
                                      placeholder="City*"
                                      onKeyPress={(e) => {
                                        onSpecialChangeOnly(e);
                                        setCityError('')
                                      }}
                                      onChange={() => setCityError("")}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span> {cityError} </span></p>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Region</label>
                                    <input
                                      {...register("SiteRegionName")}
                                      className="inputType"
                                      disabled={!isSiteEdit}
                                      placeholder="Region*"
                                      onKeyPress={(e) => {
                                        onSpecialChangeOnly(e);
                                        setRegionError('')
                                      }}
                                      onChange={() => { setRegionError('') }}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span> {regionError} </span></p>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Pin Code</label>
                                    <input
                                      {...register("SitePincode")}
                                      className="inputType"
                                      disabled={!isSiteEdit}
                                      onKeyPress={(e) => {
                                        onNumberOnlyChange(e);
                                        setPincodeError('')
                                      }}
                                      onChange={() => { setPincodeError('') }}
                                      placeholder="Pin Code*"
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span> {pincodeError} </span></p>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Address</label>
                                    <input
                                      maxLength={100}
                                      {...register("SiteAddress")}
                                      className="inputType"
                                      disabled={!isSiteEdit}
                                      placeholder="Address*"
                                      onChange={() => setAddressError('')}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span> {addressError} </span></p>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Area</label>
                                    <input
                                      {...register("SiteArea")}
                                      className="inputType"
                                      disabled={!isSiteEdit}
                                      placeholder="Area*"
                                      onKeyPress={(e) => {
                                        onSpecialChangeOnly(e);
                                        setAreaError('')
                                      }}
                                      onChange={() => { setAreaError('') }}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span> {areaError} </span></p>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Branch ID</label>
                                    <input
                                      maxLength={50}
                                      {...register("BranchID")}
                                      className="inputType"
                                      disabled={!isSiteEdit}
                                      placeholder="Branch ID*"
                                      onKeyPress={(e) => {
                                        onSpecialChangeOnly(e);
                                        setBranchidError('')
                                      }}
                                      onChange={() => { setBranchidError('') }}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span> {branchidError} </span></p>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Select Site Type</label>
                                    <select
                                      {...register("SiteModeID")}
                                      disabled={!isSiteEdit || isAlreadyRetail}
                                      className="inputType ArrowSelectClass"
                                      defaultValue={site.SiteModeID}
                                      onChange={(e) => { setValue("SiteModeID", e.target.value);setSiteModeIdError('') }}
                                      >
                                      <option key="0" disabled={false} value={0} id="0"> Site Type</option>
                                      {siteTypes &&
                                        siteTypes.map((val) => (
                                          <option value={val.SiteModeID} key={val.SiteModeID}>
                                            {val.SiteMode}
                                          </option>
                                        ))}
                                    </select>
                                    <p className="Error_P" style={{ float: "left" }}><span> {siteModeIdError} </span></p>
                                  </div>
                                </div>

                                <div className="BulkText" hidden>
                                  <div className="SentenceText">

                                  </div>

                                  <div className="ButtonText">
                                    <button
                                      className="AlertViewButton"
                                      style={{ visibility: "collapse" }}
                                    >
                                      <p>Upload CSV</p>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div>
                            {/* {site.SiteID != 0 && (
                              <div className="">
                                <h1 className="MainHeaderName mb-0">Add User to Site</h1>
                                <div className="ManageSiteDiv">
                                  <div className="DevicesHeader">
                                    <p className="mb-0" style={{ width: "40%" }}>
                                      Users
                                      <br />
                                    </p>
                                    <p className="mb-0">
                                      Configure Users to Site
                                      <br />
                                    </p>
                                  </div>

                                  <div className="site-group">
                                    <div className="site-group-list"
                                    >
                                      {emeContactList &&
                                        emeContactList.map((item) => {
                                          return (
                                            <div
                                              id={item.EmergencyContactID}
                                              key={item.EmergencyContactID}
                                              className={`cameraList user-list-item ${selectedERT &&
                                                item.EmergencyContactID ==
                                                selectedERT?.EmergencyContactID &&
                                                "selected-user"
                                                }`}
                                              onClick={(e) => {
                                                if (isSiteEdit)
                                                  siteERTOnClick(item)
                                              }}
                                            >
                                              {item &&
                                                item.IsCustomerSPOC == true &&
                                                item.IsERT == false ? (
                                                <p className="mb-0">{item.ContactName} - SPOC</p>
                                              ) : (
                                                <p className="mb-0">
                                                  {item.ContactName} - {item.ContactLevel}
                                                </p>
                                              )}

                                              <div style={{ float: "right", pointerEvents: pointerEvent, cursor: cursor }}>
                                                <img
                                                  height={12}
                                                  width={12}
                                                  onClick={() => siteERTOnClick(item)}
                                                  src={EditQc}
                                                  className="m-1"
                                                  alt="edit icon"
                                                ></img>
                                                <img
                                                  height={12}
                                                  width={12}
                                                  src={DeleteQc}
                                                  className="m-1"
                                                  title="Delete"
                                                  onClick={(e) => onDeleteERT(site.SiteID, item)}
                                                  alt="delete icon"
                                                />
                                              </div>
                                            </div>
                                          );
                                        })}
                                    </div>
                                    <div style={{ margin: "10px", textAlign: "end" }}>
                                      <div className="AddMore" style={{ float: "left" }}>
                                        <a
                                          disabled={!isSiteEdit}
                                          className="UserAddPlus mt-1"
                                          onClick={() => addNewERTMemberClick()}
                                        >
                                          Add New Member +
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <AddERTForm
                                    onSubmit={onAddERTMemberClick}
                                    ertLevels={ertLevels}
                                    site={site}
                                    selectedERT={selectedERT}
                                    userOptions={userOptions}
                                    onUserRoleChange={onUserRoleChange}
                                    selectedUserRole={selectedUserRole}
                                    setSelectedUserRole={setSelectedUserRole}
                                    siteUserFieldsVisibility={siteUserFieldsVisibility}
                                    isSiteEdit={isSiteEdit}
                                  />
                                </div>
                              </div>
                            )} */}
                          </div>

                        </div>
                        <div style={{ textAlign: "center" }}>
                          {
                            site.SiteID != 0 &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }}
                                onClick={() => {
                                  setSelectedSite(tempSiteObj);
                                  setSelectedInterface(interfaceObj);
                                  setIsSiteEdit(true);
                                }}
                              >
                                <span className="ViewUpdate">Add New</span>
                              </button>
                            )
                          }
                          {
                            site.SiteID != 0 && !isSiteEdit &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }}
                                onClick={() => setIsSiteEdit(true)}
                              >
                                <span className="ViewUpdate">Edit</span>
                              </button>
                            )
                          }
                          {
                            site.SiteID == 0 &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }}
                                onClick={handleSubmit((e) => onSubmit(e, site.SiteID, site))}
                                disabled={buttonDisable}
                              >
                                <span className="ViewUpdate">Save</span>
                              </button>
                            )
                          }
                          {
                            site.SiteID != 0 && isSiteEdit &&
                            (
                              <>
                                <button className="DataAccessEdit" style={{ width: "100px" }}
                                  onClick={handleSubmit((e) => onSubmit(e, site.SiteID, site))}
                                  disabled={buttonDisable}
                                >
                                  <span className="ViewUpdate">Save</span>
                                </button>
                                <button className="DataAccessEdit" style={{ width: "100px" }} onClick={(e) => onCancel(e)} >
                                  <span className="ViewUpdate">Cancel</span>
                                </button>
                              </>
                            )
                          }
                          {
                            site.SiteID != 0 && !isSiteEdit &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }}
                                onClick={(e) => onDeleteChange(e, site.SiteID, site.SiteName)}
                                disabled={buttonDisable}
                              >
                                <span className="ViewUpdate">Delete</span>
                              </button>
                            )
                          }
                        </div>
                              </div>
                            </Tab>
                            <Tab eventKey="Site_Map" title="Map" disabled={site.SiteID == 0} className="SiteMapContainerDiv" style={{height:"100%"}}>
                                <SiteMap selectedZone={memoizedSiteData} getSites={memoizedGetSites} />
                            </Tab>
                            <Tab eventKey="Emergency_Contact" disabled={site.SiteID == 0} title="Emergency Contact">
                              <table className="table table-text-ext table-fixed report-table healthmonitoringTable" id="alert-activity-report">
                                  <thead className="ReportTableHeader ReportTableHeadReport">
                                      <tr>
                                          <th>
                                              <p>Name</p>
                                              <div className="SearchTextDiv StatusSearchText">
                                                  <input
                                                      className="SearchViewInput"
                                                      type="search"
                                                      value={nameSearch}
                                                      placeholder="Search"
                                                      onChange={(e) => searchNameList(e)}
                                                      onKeyPress={nameRegex}
                                                      style={{width:"88%"}} />
                                                  {
                                                      isDarkTheme ?
                                                          <img className="EyeIcon" alt="Search-icon" src={SearchIcon} /> :
                                                          <img className="EyeIcon" alt="Search-icon" src={SearchIconWhite} height="15"/>
                                                  }
                                              </div>
                                          </th>
                                          <th>
                                              <p>Email</p>
                                              <div className="SearchTextDiv StatusSearchText">
                                                  <input
                                                      className="SearchViewInput"
                                                      type="search"
                                                      value={emailSearch}
                                                      placeholder="Search" style={{width:"88%"}}
                                                      onChange={(e) => searchEmailList(e)}
                                                      onKeyPress={emailRegex}
                                                      
                                                  />
                                                  {
                                                      isDarkTheme ?
                                                          <img className="EyeIcon" alt="Search-icon" src={SearchIcon} /> :
                                                          <img className="EyeIcon" alt="Search-icon" src={SearchIconWhite} height="15"/>
                                                  }
                                              </div>
                                          </th>
                                          <th>
                                              <p>Mobile No.</p>
                                              <div className="SearchTextDiv StatusSearchText">
                                                  <input
                                                      className="SearchViewInput"
                                                      type="search"
                                                      value={contactSearch}
                                                      placeholder="Search" style={{width:"88%"}}
                                                      onChange={(e) => searchContactList(e)}
                                                      onKeyPress={numberRegex}
                                                  />
                                                  {
                                                      isDarkTheme ?
                                                          <img className="EyeIcon" alt="Search-icon" src={SearchIcon} /> :
                                                          <img className="EyeIcon" alt="Search-icon" src={SearchIconWhite} height="15"/>
                                                  }
                                              </div>
                                          </th>
                                          <th>
                                              <p>Category</p>
                                              <div className="SearchTextDiv StatusSearchText">
                                                  
                                                  <select required  className="ArrowSelect HMTableSelect"
                                                    value={categorySearch} // Bind to selectedCategoryId
                                                    onChange={handleCategoryChange}
                                                  
                                                    >
                                                  <option key="0" disabled={false} value="">
                                                          - Select -
                                                      </option>
                                                      
                                                      {mainCategoryIdList &&
                                                        mainCategoryIdList.map((item) => (
                                                          <option value={item.CategoryID} key={item.CategoryID}>
                                                            {item.CategoryName}</option>
                                                        ))}
                                                  </select>
                                                
                                              </div>
                                          </th>
                                          <th>
                                              <p>Level</p>
                                              {categorySearch !== "" && (
                                      <div className="SearchTextDiv StatusSearchText">
                                                  <select required  className="ArrowSelect HMTableSelect"
                                                    value={contaclLevelSearch}
                                                    onChange={handleContactLevelChange}
                                                    >
                                                      <option key="0" disabled={false} value="">
                                                          - Select -
                                                      </option>
                                                      
                                                      {contactLevelOptions.map((level) => (
                                                      <option value={level} key={level}>
                                                                    {level}
                                                      </option>
                                                      ))}

                                                  </select>
                                              </div>
                                              )}
                                  </th>
                                          {/* <th style={{width:"135px"}}>
                                              <p>Pause Notification</p>
                                          </th> */}
                                          <th style={{width:"100px"}}></th>
                                      </tr>
                                  </thead>
                                  <tbody style={{height:"calc(100vh - 430px)"}}>
                                      {emergencyContact.length == 0 ? (
                                      <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>
                                          <p>No records found</p>
                                        </td>
                                      </tr>
                                      ) : (
                                          emergencyContact.map((item) => (
                                              <EmergencyContactForm
                                                  key={item.EmergencyContactID}
                                                  item={item}
                                                  getEmergencyContact={getEmergencyContact}
                                                  categoryIdList={categoryIdList}
                                                  masterData={emergencyContact}
                                      />
                                            ))
                                        )}
                                    {/* <tr>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <input className="inputType"
                                              placeholder="Ex. Kumar Khan"
                                              style={{fontSize:"14px"}}
                                              
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <input className="inputType"
                                              placeholder="Ex. kkhan@rmail.com"
                                              style={{fontSize:"14px"}}
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <input className="inputType"
                                              placeholder="Ex. 9898989898"
                                              style={{fontSize:"14px"}}
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <input className="inputType"
                                              placeholder="Ex. Development"
                                              style={{fontSize:"14px"}}
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <select className="inputType ArrowSelectClass">
                                              <option key="0" value="0" id="0">Select</option>                                           
                                            </select>
                                          </div>
                                      </td>  
                                      <td style={{width:"135px"}}>
                                        <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"35px"}}>
                                          <input type="checkbox"/>
                                        </div>
                                      </td>
                                      <td style={{width:"100px"}}>
                                        <div style={{display:"flex", justifyContent:"space-between", height:"35px"}}>
                                          <button style={{background:"transparent"}}>
                                              <img className="EyeIcon" alt="Search-icon" src={CheckRowBlue} /> 
                                          </button>
                                          <button style={{background:"transparent"}}>
                                              <img className="EyeIcon" alt="Search-icon" src={CancelRowBlue} /> 
                                          </button>
                                        </div>
                                      </td>                              
                                    </tr>
                                    <tr>
                                      <td>
                                          <div className="inputTypeLabelContainer removeBorder">
                                            <input className="inputType" readOnly 
                                            value="kamal Khan"
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer removeBorder">
                                            <input className="inputType" readOnly
                                              value="kkhan@rmail.com"
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer removeBorder">
                                            <input className="inputType" readOnly
                                              value="9898989898"
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer removeBorder">
                                            <input className="inputType" readOnly
                                              value="Development"
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer removeBorder">
                                            <p>01</p>
                                          </div>
                                      </td>  
                                      <td style={{width:"135px"}}>
                                        <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"35px"}}>
                                          <input type="checkbox"/>
                                        </div>
                                      </td>
                                      <td style={{width:"100px"}}>
                                        <div style={{display:"flex", justifyContent:"space-between", height:"35px"}}>
                                          <button style={{background:"transparent"}}>
                                              <img className="EyeIcon" alt="Search-icon" src={EditRowBlue} /> 
                                          </button>
                                          <button style={{background:"transparent"}}>
                                              <img className="EyeIcon" alt="Search-icon" src={DeleteRowBlue} /> 
                                          </button>
                                        </div>
                                      </td>                              
                                    </tr>
                                    <tr>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <input className="inputType"
                                              value="Kumar Khan"
                                              style={{fontSize:"14px"}}
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <input className="inputType"
                                              value="kkhan@rmail.com"
                                              style={{fontSize:"14px"}}
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <input className="inputType"
                                              value="9898989898"
                                              style={{fontSize:"14px"}}
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <input className="inputType"
                                              value="Development"
                                              style={{fontSize:"14px"}}
                                            />
                                          </div>
                                      </td>
                                      <td>
                                          <div className="inputTypeLabelContainer">
                                            <select className="inputType ArrowSelectClass">
                                              <option key="0" value="0" id="0">One</option>
                                              <option key="0" value="0" id="0">Two</option> 
                                              <option key="0" value="0" id="0">Three</option> 
                                              <option key="0" value="0" id="0">Four</option>                                            
                                            </select>
                                          </div>
                                      </td>  
                                      <td style={{width:"135px"}}>
                                        <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"35px"}}>
                                          <input type="checkbox"/>
                                        </div>
                                      </td>
                                      <td style={{width:"100px"}}>
                                        <div style={{display:"flex", justifyContent:"space-between", height:"35px"}}>
                                          <button style={{background:"transparent"}}>
                                              <img className="EyeIcon" alt="Search-icon" src={CheckRowBlue} /> 
                                          </button>
                                          <button style={{background:"transparent"}}>
                                              <img className="EyeIcon" alt="Search-icon" src={CancelRowBlue} /> 
                                          </button>
                                        </div>
                                      </td>                              
                                    </tr> */}
                                  </tbody>
                              </table>
                              {/* <div>
                                  <div style={{ textAlign: "center" , marginTop:"15px"}}>
                                    <button type="submit" className="DataAccessEdit" style={{ width: "100px" }} >
                                            <span className="ViewUpdate">Save</span>
                                    </button>
                                    <button className="DataAccessEdit" style={{ width: "100px" }}>
                                        <span className="ViewUpdate">Edit</span>
                                    </button>
                                    <button className="DataAccessEdit" style={{ width: "100px" }} >
                                        <span className="ViewUpdate">Cancel</span>
                                    </button>
                                    </div>
                              </div> */}
                            </Tab>
                        </Tabs>
                      </div>
                    </div>
                  </div>
                )}
                </>
                : activeTab == INTERFACES ?
                  <div className="SiteMainContainer">
                    <div className="SiteLeftContainer">
                      <div className="m-2 HeaderSiteList">
                        <input
                          id="Search_txt_interface"
                          className="SearchViewInput1"
                          type="text"
                          onChange={(e) => {
                            setSearchTextInterface(e.target.value)
                            onSearchChange(e.target.value, 'interface')
                          }
                          }
                          placeholder="Search Interface"
                          //autoFocus
                          value={searchTextInterface}
                        />
                          {
                            isDarkTheme ?
                              <img
                                className="EyeIcon"
                                src={SearchIcon}
                                alt="search icon"
                              /> :
                              <img
                                className="EyeIcon"
                                src={SearchIconWhite}
                                alt="search icon" height="15"
                              />
                          }
                      </div>

                      <div className="StepperSiteList" id="interfaceListDiv">
                        {
                          interfaceDataList && (
                            interfaceDataList?.length > 0 ?
                              interfaceDataList.map((interfaceparam) => {
                                return (
                                  <div
                                    ref={interfaceDevice.InterfaceId == interfaceparam.InterfaceId ? interfaceRef : null}
                                    className={interfaceDevice.InterfaceId == interfaceparam.InterfaceId ? "OneList SelectedList" : "OneList"}
                                    key={interfaceparam.InterfaceId}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onSelectInterface(interfaceparam.InterfaceId, true);
                                      clearInterfaceFields();
                                    }}
                                  >
                                    <p className="ListofText">
                                      {interfaceparam.InterfaceName}
                                      {<span className="SiteNameText"> - {interfaceparam.Interfacetypename}
                                      </span>}
                                    </p>
                                    <div>
                                    </div>
                                  </div>
                                );
                              }) : <div className="no-data-found"><p>No Interface Found</p></div>
                          )
                        }
                        {!interfaceDataList && (
                          <div className="no-data-found">No Interface Available</div>
                        )}
                      </div>
                    </div>
                    <div className="SiteRightContainer">
                      <h1 className="MainHeaderName">Interface Details</h1>
                      <div className="siteformContainer">
                        <form onSubmit={handleSubmit((e) => onInterfaceFormSubmit(e, interfaceDevice.InterfaceId, rtspValueEntered, playbackValueEntered))}>
                          <div
                            className="site-form"
                            style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                          >

                            <div className="inputMainContainer w40dot75rem">
                              <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface Name</label>
                                <input
                                  {...register("InterfaceName")}
                                  className="inputType"
                                  disabled={!isInterfaceEdit}
                                  placeholder="Enter Interface Name*"
                                  onKeyPress={(e) => {
                                    onSpecialChangeOnly(e)
                                    setInterfaceError('')
                                  }}
                                  onChange={() => { setInterfaceError('') }}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {interfaceError} </span></p>
                              </div>
                            </div>

                            <div className="inputMainContainer w40dot75rem mt35">
                              <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface Type</label>
                                <select
                                  {...register("InterfaceType")}
                                  disabled={interfaceDevice.InterfaceId != 0 ? true : false}
                                  className="inputType ArrowSelectClass"
                                  onChange={(e) => {
                                    if(e.target.value == "Mobile"){
                                      setMobileDisplay(true)
                                    }else{
                                      setMobileDisplay(false)
                                    }
                                    interfaceSubTypeHandler(e)
                                    interfaceForDeviceTypeHandler(e)
                                    setInterfaceTypeError('')
                                    setValue("EntityTypeID", 0)
                                    setValue("CheckExternalHooter", 0);
                                    setValue("CheckInternalHooter", 0);
                                    setValue("IsHooterEnabled", 0);
                                    setValue("InterfaceTwoWayEnabled", 0)
                                  }}
                                >
                                  <option key="0" disabled={false} value="0" id="0">Select Interface Type*</option>
                                  {interfaceTypeData &&
                                    interfaceTypeData.map((val) => (
                                      <option
                                        value={val.Interfacetypename} key={val.InterfacetypeId}
                                        id={val.InterfacetypeId}>
                                        {val.Interfacetypename}
                                      </option>
                                    ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> {interfaceTypeError} </span></p>
                              </div>
                            </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                          <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>Interface Sub-Type</label>
                            <select
                              {...register("InterfaceSubType")}
                              disabled={interfaceDevice.InterfaceId != 0 ? true : false}
                              className="inputType ArrowSelectClass"
                              onChange={(e) => {
                                setValue("EntityTypeID", 0)
                                setInterfaceSubtypeError('')
                                if (e.target.value == "Unknown") {
                                  setDisplayLivePlaybackfield(true)
                                  setEnableHooter(false)
                                  setDisplayTwoWay(false)
                                  setDisplayCamera(false)
                                } else if (getValues("InterfaceType") == "Alarm Panel") {
                                  setDisplayTwoWay(false);
                                  setEnableHooter(true);
                                  setDisplayLivePlaybackfield(false);
                                }
                                else if (getValues("InterfaceType") == "ACS" || getValues("InterfaceType") == "RTU" || getValues("InterfaceType") == "Fire Panel") {
                                  setDisplayLivePlaybackfield(false)
                                  setEnableHooter(false)
                                  setDisplayTwoWay(false)
                                  setDisplayCamera(false)
                                }
                                else {
                                  setDisplayLivePlaybackfield(false)
                                  setEnableHooter(false)
                                  setDisplayTwoWay(true)
                                  setDisplayCamera(false);
                                  setValue("IsHooterEnabled", 0);
                                  setValue("InterfaceTwoWayEnabled", 0)

                                    }
                                  }}
                                >
                                  <option key="0" disabled={false} value="0" id="0">Select Interface Sub Type*</option>
                                  {interfaceSubTypeData &&
                                    interfaceSubTypeData.map((val) => (
                                      <option
                                        value={val.Interfacesubtypename}
                                        key={val.InterfacesubtypeId}
                                        id={val.InterfacesubtypeId}
                                      >
                                        {val.Interfacesubtypename}
                                      </option>
                                    ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> {interfaceSubtypeError} </span></p>
                              </div>
                            </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                          <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>Device Type</label>
                            <select
                              {...register("deviceTypeId")}
                              disabled={interfaceDevice.InterfaceId != 0 ? true : false}
                              defaultValue={interfaceDevice.deviceTypeId}
                              className="inputType ArrowSelectClass"
                              placeholder="Device Type*"
                              onChange={(e) => {
                                setInterfaceDeviceTypeError('')
                                if (getValues("InterfaceSubType") == "Unknown") {
                                  setDisplayCamera(false)
                                  setEnableHooter(false)
                                  setParentPanelIsEnablingHooter(false)
                                  setParentIsEnablingInternalHooter(false)
                                  setParentIsEnablingExternalHooter(false);
                                } else {
                                  if (e.target.selectedOptions[0].text == "Camera") {
                                    setDisplayCamera(true)
                                    setEnableHooter(false)
                                    setParentPanelIsEnablingHooter(false);
                                  }else if(e.target.selectedOptions[0].text.includes("ACS") || e.target.selectedOptions[0].text.includes("RTU") || e.target.selectedOptions[0].text.includes("Fire Panel")){
                                    setDisplayCamera(false)
                                    setEnableHooter(false)
                                    setParentIsEnablingInternalHooter(false)
                                    setParentIsEnablingExternalHooter(false)
                                    setValue("CheckExternalHooter", 0);
                                    setValue("CheckInternalHooter", 0);
                                    setValue("IsHooterEnabled", 0);
                                    setValue("InterfaceTwoWayEnabled", 0)
                                  } 
                                  else {
                                    setDisplayCamera(false)
                                    setEnableHooter(true)
                                    setParentIsEnablingInternalHooter(false)
                                    setParentIsEnablingExternalHooter(false)
                                    setValue("CheckExternalHooter", 0);
                                    setValue("CheckInternalHooter", 0);
                                    setValue("IsHooterEnabled", 0);
                                    setValue("InterfaceTwoWayEnabled", 0)
                                  }
                                }
                                setValue("deviceTypeId", e.target.value)
                              }}
                            >
                              <option key="0" disabled={false} value="0" id="0">Select Device Type*</option>
                              {deviceTypeDataForInterface &&
                                deviceTypeDataForInterface.map((val) => (
                                  <option
                                    value={val.DeviceTypeID} key={val.DeviceTypeID}
                                    id={val.DeviceTypeID}>
                                    {val.DeviceType}
                                  </option>
                                ))}
                            </select>
                            <p className="Error_P" style={{ float: "left" }}><span> {interfaceDeviceTypeError} </span></p>
                          </div>
                        </div>

                            {
                              false
                                ?
                                <>
                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Entity Subtype</label>
                                      <select
                                        {...register("EntityTypeID")}
                                        className="inputType ArrowSelectClass"
                                        placeholder="Entity Subtype*"
                                        disabled={disabledEntity}
                                        defaultValue={interfaceDevice.EntityTypeID}
                                        onChange={(e) => {
                                          setValue("CCTVType", e.target.selectedOptions[0].text)
                                          setInterfaceEntitySubtypeError()
                                          if (getValues("InterfaceSubType") == "Unknown") {
                                            setDisplayCamera(false)
                                            setEnableHooter(false)
                                            setParentPanelIsEnablingHooter(false)
                                            setParentIsEnablingInternalHooter(false)
                                            setParentIsEnablingExternalHooter(false);
                                          } else {
                                            if (e.target.selectedOptions[0].text == "Camera") {
                                              setDisplayCamera(true)
                                              setEnableHooter(false)
                                              setParentPanelIsEnablingHooter(false);
                                            } else {
                                              setDisplayCamera(false)
                                              setEnableHooter(true)
                                              setParentIsEnablingInternalHooter(false)
                                              setParentIsEnablingExternalHooter(false)
                                              setValue("CheckExternalHooter", 0);
                                              setValue("CheckInternalHooter", 0);
                                              setValue("IsHooterEnabled", 0);
                                              setValue("InterfaceTwoWayEnabled", 0)
                                            }
                                          }

                                          setValue("CCTVTypeIDInterface", e.target.value)
                                        }
                                        }
                                      >
                                        <option key="0" disabled={false} value="0" id="0">Entity Subtype*</option>
                                        {cctvTypeData && cctvTypeData.map((entity) => (
                                          <option value={entity.EntityTypeID} name={entity.EntityTypeID} key={entity.CCTVTypeID}>
                                            {entity.EntityType}
                                          </option>
                                        ))}
                                      </select>
                                      <p className="Error_P" style={{ float: "left" }}><span> {interfaceEntitySubtypeError} </span></p>
                                    </div>
                                  </div>
                                </>
                                : null
                            }
                            {
                              !mobileDisplay
                              ?
                              <>
                              <div className="inputMainContainer w40dot75rem mt35">
                              <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface IP</label>
                                <input
                                  {...register("InterfaceIP")}
                                  className="inputType"
                                  disabled={!isInterfaceEdit}
                                  placeholder="Enter Interface IP*"
                                  onKeyPress={(e) => {
                                    onNumberOnlyChange2(e);
                                    setInterfaceIPError('')
                                  }}
                                  onChange={() => setInterfaceIPError('')}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {interfaceIPError} </span></p>
                              </div>
                            </div>

                            <div className="inputMainContainer w40dot75rem mt35">
                              <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface Port</label>
                                <input
                                  {...register("InterfacePort")}
                                  className="inputType"
                                  disabled={!isInterfaceEdit}
                                  placeholder="Enter Interface Port*"
                                  onKeyPress={(e) => {
                                    onNumberOnlyChange(e);
                                    setInterfacePortError('')
                                  }}
                                  onChange={() => setInterfacePortError('')}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {interfacePortError} </span></p>
                              </div>
                            </div>
                              {
                                displayEntity
                                ?
                                <>
                                <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                              <label className='formFieldLabels'>Communication Port</label>
                              <input
                                {...register("communicationPortInterface")}
                                className="inputType"
                                disabled={!isInterfaceEdit}
                                placeholder="Enter Communication Port* e.g. 8080"
                                onKeyPress={(e) => {
                                  onNumberOnlyChange(e);
                                  setCommunicationPortError('')
                                }}
                                onChange={() => setCommunicationPortError('')}
                                defaultValue={interfaceDevice.communicationPortInterface}
                              />
                              <p className="Error_P" style={{ float: "left" }}><span> {communicationPortError} </span></p>
                            </div>
                          </div>
                          <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>HTTP Port</label>
                                        <input
                                          {...register("httpPortInterface")}
                                          className="inputType"
                                          disabled={!isInterfaceEdit}
                                          placeholder="Enter HTTP Port* e.g. 443"
                                          onKeyPress={(e) => {
                                            onNumberOnlyChange(e);
                                            setHttpPotError('')
                                          }}
                                          onChange={() => setHttpPotError('')}
                                          defaultValue={interfaceDevice.httpPortInterface}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}><span> {httpPortError} </span></p>
                                      </div>
                          </div>
                                </>
                                :
                                null
                              }
                          
                            <div className="inputMainContainer w40dot75rem mt35">
                              <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface Username</label>
                                <input
                                  {...register("InterfaceUsername")}
                                  className="inputType"
                                  disabled={!isInterfaceEdit}
                                  placeholder="Enter Interface Username*"
                                  onChange={() => setInterfaceUserError('')}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {interfaceUserError} </span></p>
                              </div>
                            </div>

                            <div className="inputMainContainer w40dot75rem mt35">
                              <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface Password</label>
                                <input
                                  {...register("InterfacePassword")}
                                  className="inputType"
                                  disabled={!isInterfaceEdit}
                                  placeholder="Enter Interface Password*"
                                  onChange={() => setInterfacePasswardError('')}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {interfacePasswardError} </span></p>
                              </div>
                            </div>

                              </>
                              :
                              null
                            }
                            
                            {
                              MULTI_TIME_ZONE ?

                                <div className="inputMainContainer w40dot75rem mt35">
                                  <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Timezone</label>
                                    <select
                                      {...register("TimeZoneId")}
                                      disabled={!isInterfaceEdit}
                                      className="inputType ArrowSelectClass"
                                      onChange={(e) => {
                                        setValue("TimeZoneId", e.target.value)
                                        setInterfaceTimeZoneError('')
                                      }}
                                    >
                                      <option key="0" disabled={false} value="0" id="0">Select timezone*</option>
                                      {timezone &&
                                        timezone.map((val) => (
                                          <option
                                            value={val.TimeZoneId} key={val.TimeZoneId}
                                            id={val.Abbreviation}>
                                            {val.Abbreviation} (UTC{val.Shift.slice(0, -3)}) {val.Fullname}
                                          </option>
                                        ))}
                                    </select>
                                    <p className="Error_P" style={{ float: "left" }}><span> {interfaceTimeZoneError} </span></p>
                                  </div>
                                </div>
                                :
                                null
                            }

                            {
                              !HIDE_STUFF
                                ?

                                displayLivePlaybackfield ?
                                  <>
                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Live Stream Format</label>
                                        <MentionsInput
                                          {...register("LiveRTSPURL")}
                                          disabled={!isInterfaceEdit}
                                          placeholder="Enter live stream URL format"
                                          className="inputType long-value-input"
                                          style={{ marginLeft: "18px" }}
                                          singleLine
                                          value={rtspValue}
                                          onChange={(e, newValue, newPlainTextValue) => {
                                            setRtspValue(e.target.value)
                                            setRtspValueEntered(newPlainTextValue)
                                            setLiveStreamFormatError('')
                                          }}
                                        >
                                          <Mention
                                            data={RTSP}
                                            markup="{__display__}"
                                            trigger={/(@([^@]*))$/}
                                          // displayTransform={(value) => {
                                          //   if(value == "username" || value == "ip")
                                          //   {
                                          //     return `${value}:`
                                          //   }else if(value == "password"){
                                          //     return `${value}@`
                                          //   }else{
                                          //     return `${value}`                                        
                                          //   }
                                          // }}
                                          />
                                        </MentionsInput>
                                        <p className="Error_P" style={{ float: "left" }}><span>{liveStreamFormatError}</span></p>
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Playback Stream Format</label>
                                        <MentionsInput
                                          {...register("PlaybackRTSPURL")}
                                          disabled={!isInterfaceEdit}
                                          placeholder="Enter playback URL format"
                                          className="inputType long-value-input"
                                          style={{ marginLeft: "18px" }}
                                          singleLine
                                          value={playbackValue}
                                          onChange={(e, newValue, newPlainTextValue) => {
                                            setPlaybackValue(e.target.value)
                                            setPlaybackValueEntered(newPlainTextValue)
                                            setPlaybackStreamFormatError('')
                                          }}
                                        >
                                          <Mention
                                            data={PLAYBACK}
                                            markup="{__display__}"
                                            trigger={/(@([^@]*))$/}
                                            style={{ border: "0px impotant" }}
                                          />
                                        </MentionsInput>
                                        <p className="Error_P" style={{ float: "left" }}><span>{playbackStreamFormatError}</span></p>
                                      </div>
                                    </div>
                                    {/* </div> */}

                                    {/* <div className="SiteTextBox SiteNameText"> */}
                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>UTC Conversion</label>
                                        <div className="onlyforEnableCheckbox">
                                          <input
                                            className="checkbox_custom"
                                            type="checkbox"
                                            disabled={!isInterfaceEdit}
                                            {...register("PlaybackTimeStampsToUTC")}
                                            onChange={(e) => {
                                              setValue("PlaybackTimeStampsToUTC", Number(e.target.checked))
                                              setParentIsEnablingPlaybackTimeStampsToUTC(e.target.checked);
                                            }}
                                            defaultValue={Number(interfaceDevice.CheckPlaybackUTCTime)}
                                          />
                                          <label className="mb-0"
                                            onClick={() => {
                                              if (!isInterfaceEdit) {
                                                return;
                                              }
                                              getValues("PlaybackTimeStampsToUTC")
                                              if (parentIsEnablingPlaybackTimeStampsToUTC) {
                                                setValue("PlaybackTimeStampsToUTC", 0)
                                                setParentIsEnablingPlaybackTimeStampsToUTC(false);
                                              } else {
                                                setValue("PlaybackTimeStampsToUTC", 1)
                                                setParentIsEnablingPlaybackTimeStampsToUTC(true);
                                              }
                                            }}
                                          >
                                            Playback Timestamps to UTC
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    {/* </div> */}

                                    <div className="SiteTextBox SiteNameText" style={{ display: "none", height: "55px" }}>
                                      <div className="onlyforEnableCheckbox">
                                        <input
                                          className="checkbox_custom"
                                          type="checkbox"
                                          disabled={!isInterfaceEdit}
                                          {...register("PlaybackLongDateFormat")}
                                          onChange={(e) => {
                                            setValue("PlaybackLongDateFormat", Number(e.target.checked))
                                            setParentIsEnablingPlaybackLongDateFormat(e.target.checked);
                                          }}
                                          defaultValue={Number(interfaceDevice.CheckPlaybackLongTime)}
                                        />
                                        <label className="mb-0"
                                          onClick={(e) => {
                                            if (!isInterfaceEdit) {
                                              return;
                                            }
                                            getValues("PlaybackLongDateFormat")
                                            if (parentIsEnablingPlaybackLongDateFormat) {
                                              setValue("PlaybackLongDateFormat", 0)
                                              setParentIsEnablingPlaybackLongDateFormat(false);
                                            } else {
                                              setValue("PlaybackLongDateFormat", 1)
                                              setParentIsEnablingPlaybackLongDateFormat(true);
                                            }
                                          }}
                                        >
                                          Playback Long Date Format
                                        </label>
                                      </div>
                                    </div>

                                  </>
                                  : null

                                : null
                            }



                            {
                              displayTwoWay && !mobileDisplay
                                ?
                                <>
                                  <div className="inputMainContainer w40dot75rem mt30">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Two Way Communication</label>
                                      <div
                                        className="onlyforEnableCheckbox"
                                      >
                                        <input
                                          className="checkbox_custom"
                                          type="checkbox"
                                          disabled={!isInterfaceEdit}
                                          {...register("InterfaceTwoWayEnabled")}
                                          onChange={(e) => {
                                            setValue("InterfaceTwoWayEnabled", Number(e.target.checked))
                                            if (Number(e.target.checked)) {
                                              setParentIsEnablingTwoWayInterface(true);
                                            } else {
                                              setParentIsEnablingTwoWayInterface(false);
                                            }
                                          }}
                                          defaultValue={Number(interfaceDevice.IsTwoWayEnabled)}
                                        />
                                        <label className="mb-0"
                                          onClick={() => {
                                            if (!isInterfaceEdit) {
                                              return;
                                            }
                                            getValues("InterfaceTwoWayEnabled")
                                            if (parentIsEnablingTwoWayInterface) {
                                              setValue("InterfaceTwoWayEnabled", 0)
                                              setParentIsEnablingTwoWayInterface(false);
                                            } else {
                                              setValue("InterfaceTwoWayEnabled", 1)
                                              setParentIsEnablingTwoWayInterface(true);
                                            }
                                          }}
                                        >
                                          Two Way Communication Available
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </>
                                : null
                            }

                            {
                              !HIDE_STUFF
                                ?
                                displayCamera
                                  ?
                                  <div className="inputMainContainer w40dot75rem">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Enable Hooter Types</label>
                                      <div className='mt-1 signTypeCheckboxLabels'>
                                        <div className="SiteTextBox SiteNameText mt-0">
                                          <div className="onlyforEnableCheckbox ml-0">
                                            <input
                                              className="checkbox_custom"
                                              type="checkbox"
                                              disabled={!isInterfaceEdit}
                                              {...register("CheckInternalHooter")}
                                              //Internal hooter
                                              onChange={(e) => {
                                                setValue("CheckInternalHooter", Number(e.target.checked))
                                                setParentIsEnablingInternalHooter(e.target.checked);
                                                if (e.target.checked) {
                                                  setValue("CheckExternalHooter", 0);
                                                  setParentIsEnablingExternalHooter(false);
                                                }
                                              }}

                                              defaultValue={Number(interfaceDevice.CheckInternalHooter)}
                                            />
                                            <label className="mb-0"
                                              onClick={() => {
                                                if (!isInterfaceEdit) {
                                                  return;
                                                }
                                                getValues("CheckInternalHooter")
                                                if (parentIsEnablingInternalHooter) {
                                                  setValue("CheckInternalHooter", 0)
                                                  setParentIsEnablingInternalHooter(false);
                                                } else {
                                                  setValue("CheckInternalHooter", 1)
                                                  setParentIsEnablingInternalHooter(true);
                                                  setValue("CheckExternalHooter", 0);
                                                  setParentIsEnablingExternalHooter(false);
                                                }
                                              }}
                                            >
                                              Enable Internal Hooter
                                            </label>
                                          </div>
                                        </div>
                                        <div className="SiteTextBox SiteNameText mt-0">
                                          <div className="onlyforEnableCheckbox ml-0">
                                            <input
                                              className="checkbox_custom"
                                              type="checkbox"
                                              disabled={!isInterfaceEdit}
                                              {...register("CheckExternalHooter")}
                                              // External hooter
                                              onChange={(e) => {
                                                setValue("CheckExternalHooter", Number(e.target.checked))
                                                setParentIsEnablingExternalHooter(e.target.checked);
                                                if (e.target.checked) {
                                                  setValue("CheckInternalHooter", 0);
                                                  setParentIsEnablingInternalHooter(false);
                                                }
                                              }}

                                              defaultValue={Number(interfaceDevice.CheckExternalHooter)}
                                            />
                                            <label className="mb-0"
                                              onClick={() => {
                                                if (!isInterfaceEdit) {
                                                  return;
                                                }
                                                getValues("CheckExternalHooter")
                                                if (parentIsEnablingExternalHooter) {
                                                  setValue("CheckExternalHooter", 0)
                                                  setParentIsEnablingExternalHooter(false);
                                                } else {
                                                  setValue("CheckExternalHooter", 1)
                                                  setParentIsEnablingExternalHooter(true);
                                                  setValue("CheckInternalHooter", 0);
                                                  setParentIsEnablingInternalHooter(false);
                                                }

                                              }}
                                            >
                                              Enable External Hooter
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  :
                                  null
                                :
                                null
                            }
                            
                            {
                              !mobileDisplay
                                ?
                                enableHooter
                                  ? (
                                    <div className="inputMainContainer w40dot75rem mt30">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Enable/Disable Hooter</label>
                                        <div className="onlyforEnableCheckbox">
                                          <input
                                            className="checkbox_custom"
                                            type="checkbox"
                                            disabled={!isInterfaceEdit}
                                            {...register("IsHooterEnabled")}
                                            onChange={(e) => {
                                              setValue("IsHooterEnabled", Number(e.target.checked))
                                              setParentPanelIsEnablingHooter(e.target.checked);
                                            }}
                                            defaultValue={Number(interfaceDevice.IsHooterEnabled)}
                                          />
                                          <label className="mb-0"
                                            onClick={() => {
                                              if (!isInterfaceEdit) {
                                                return;
                                              }
                                              getValues("IsHooterEnabled")
                                              if (parentPanelIsEnablingHooter) {
                                                setValue("IsHooterEnabled", 0)
                                                setParentPanelIsEnablingHooter(false);
                                              } else {
                                                setValue("IsHooterEnabled", 1)
                                                setParentPanelIsEnablingHooter(true);
                                              }
                                            }}
                                          >
                                            Enable Hooter
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null
                                : null
                            }

                            <div className="BulkText" hidden>
                              <div className="SentenceText">

                              </div>

                          <div className="ButtonText">
                            <button
                              className="AlertViewButton"
                            //  style={{ visibility: "collapse" }}
                            >
                              <p>Upload CSV</p>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    {
                      interfaceDevice.InterfaceId != 0 &&
                      (
                        <button className="DataAccessEdit" style={{ width: "100px" }}
                          onClick={() => {
                            setSelectedInterface(interfaceObj);
                            setIsInterfaceEdit(true)
                            setParentIsEnablingInternalHooter(false)
                            setParentIsEnablingExternalHooter(false)
                            setParentPanelIsEnablingHooter(false)
                            clearInterfaceFields();
                          }}
                        >
                          <span className="ViewUpdate">Add New</span>
                        </button>
                      )
                    }
                    {
                      interfaceDevice.InterfaceId != 0 && !isInterfaceEdit &&
                      (
                        <button className="DataAccessEdit" style={{ width: "100px" }}
                          onClick={() => setIsInterfaceEdit(true)}
                        >
                          <span className="ViewUpdate">Edit</span>
                        </button>
                      )
                    }
                    {
                      interfaceDevice.InterfaceId == 0 &&
                      (
                        <button className="DataAccessEdit" style={{ width: "100px" }}
                          disabled={buttonDisable}
                          onClick={handleSubmit((e) => onInterfaceFormSubmit(e, interfaceDevice.InterfaceId, rtspValueEntered, playbackValueEntered))}
                        >
                          <span className="ViewUpdate">Save</span>
                        </button>
                      )
                    }
                    {
                      interfaceDevice.InterfaceId != 0 && isInterfaceEdit &&
                      (
                        <>
                          <button className="DataAccessEdit" style={{ width: "100px" }}
                            disabled={buttonDisable}
                            onClick={handleSubmit((e) => onInterfaceFormSubmit(e, interfaceDevice.InterfaceId, rtspValueEntered, playbackValueEntered))}
                          >
                            <span className="ViewUpdate">Save</span>
                          </button>
                          <button className="DataAccessEdit" style={{ width: "100px" }} onClick={(e) => onCancelInterface(e)} >
                            <span className="ViewUpdate">Cancel</span>
                          </button>
                        </>
                      )
                    }
                    {
                      interfaceDevice.InterfaceId != 0 && !isInterfaceEdit &&
                      (
                        <button className="DataAccessEdit" style={{ width: "100px" }}
                          disabled={buttonDisable}
                          onClick={(e) => onDeleteInterfaceChange(e, interfaceDevice.InterfaceId, interfaceDevice.InterfaceName)}>
                          <span className="ViewUpdate">Delete</span>
                        </button>
                      )
                    }
                  </div>
                </div>
              </div>
              :
              <div className="SiteMainContainer">
                <div className="SiteLeftContainer">
                  <div className="m-2 HeaderSiteList">
                    <input
                      id="Search_txt_device"
                      className="SearchViewInput1"
                      type="text"
                      onChange={(e) => {
                        setSearchTextDevice(e.target.value)
                        onSearchChange(e.target.value, "Device List", interfaceType)
                      }
                      }
                      placeholder="Search device"
                      //autoFocus
                      value={searchTextDevice}
                    />
                      {
                        isDarkTheme ?
                          <img
                            className="EyeIcon"
                            src={SearchIcon}
                            alt="search icon"
                          /> :
                          <img
                            className="EyeIcon"
                            src={SearchIconWhite}
                            alt="search icon" height="15"
                          />
                      }
                  </div>
                    <div className="StepperSiteList">
                      {
                        interfaceType === NVRDVR
                          ?
                          (
                            cameradeviceslist ? (
                              cameradeviceslist?.length > 0
                                ?
                                cameradeviceslist.map((item) => {
                                  return (
                                    <div
                                      className={selectedDevice?.DeviceId === item.DeviceId ? "OneList SelectedList" : "OneList"}
                                      key={item.DeviceId}
                                      onClick={(e) => {
                                        onDeviceSelection(item)
                                        getAssociateCCTVList(item)
                                        setIsChannelNumberEdited(false)
                                        clearCameraFields()
                                        setEditAssociate(false);
                                      }}
                                    >
                                      <p className="ListofText">
                                        {item.Name}
                                        <span className="SiteNameText"> - {item.DeviceId}</span>
                                      </p>
                                      <div>
                                      </div>
                                    </div>
                                  );
                                })
                                : (<div className="no-data-found">No Camera Found</div>)
                            )
                              : (!cameradeviceslist && (
                                <div className="no-data-found">No Camera Available</div>
                              ))
                          )
                          : interfaceType === ACS
                            ?
                            (
                              acsDevicesList ? (
                                acsDevicesList?.length > 0
                                  ?
                                  acsDevicesList.map((item) => {
                                    return (
                                      <div
                                        className={selectedDevice?.DeviceId === item.DeviceId ? "OneList SelectedList" : "OneList"}
                                        key={item.DeviceId}
                                        onClick={(e) => {
                                          onDeviceSelection(item)
                                          getAssociateACSList(item)
                                          setIsChannelNumberEdited(false)
                                          clearCameraFields()
                                          setEditAssociate(false);
                                        }}
                                      >
                                        <p className="ListofText">
                                          {item.Name}
                                          <span className="SiteNameText"> - {item.DeviceId}</span>
                                        </p>
                                        <div>
                                        </div>
                                      </div>
                                    );
                                  })
                                  : (<div className="no-data-found">No ACS Found</div>)
                              )
                                : (!acsDevicesList && (
                                  <div className="no-data-found">No ACS Available</div>
                                ))
                            )
                            : interfaceType === FAS
                              ?
                              (
                                fasDeviceList ? (
                                  fasDeviceList?.length > 0
                                    ?
                                    fasDeviceList.map((item) => {
                                      return (
                                        <div
                                          className={selectedDevice?.DeviceId === item.DeviceId ? "OneList SelectedList" : "OneList"}
                                          key={item.DeviceId}
                                          onClick={(e) => {
                                            onDeviceSelection(item)
                                            getAssociateACSList(item)
                                            setIsChannelNumberEdited(false)
                                            clearCameraFields()
                                            setEditAssociate(false);
                                          }}
                                        >
                                          <p className="ListofText">
                                            {item.Name}
                                            <span className="SiteNameText"> - {item.DeviceId}</span>
                                          </p>
                                          <div>
                                          </div>
                                        </div>
                                      );
                                    })
                                    : (<div className="no-data-found">No FAS Found</div>)
                                )
                                  : (!fasDeviceList && (
                                    <div className="no-data-found">No FAS Available</div>
                                  ))
                              )
                              : interfaceType === RTU
                                ?
                                (
                                  rtuDeviceList ? (
                                    rtuDeviceList?.length > 0
                                      ?
                                      rtuDeviceList.map((item) => {
                                        return (
                                          <div
                                            className={selectedDevice?.DeviceId === item.DeviceId ? "OneList SelectedList" : "OneList"}
                                            key={item.DeviceId}
                                            onClick={(e) => {
                                              onDeviceSelection(item)
                                              getAssociateACSList(item)
                                              setIsChannelNumberEdited(false)
                                              clearCameraFields()
                                              setEditAssociate(false);
                                            }}
                                          >
                                            <p className="ListofText">
                                              {item.Name}
                                              <span className="SiteNameText"> - {item.DeviceId}</span>
                                            </p>
                                            <div>
                                            </div>
                                          </div>
                                        );
                                      })
                                      : (<div className="no-data-found">No RTU Found</div>)
                                  )
                                    : (!fasDeviceList && (
                                      <div className="no-data-found">No RTU Available</div>
                                    ))
                                )
                                : interfaceType === MOBILE
                                  ?
                                  (
                                    acsDevicesList ? (
                                      acsDevicesList?.length > 0
                                        ?
                                        acsDevicesList.map((item) => {
                                          return (
                                            <div
                                              className={selectedDevice?.DeviceId === item.DeviceId ? "OneList SelectedList" : "OneList"}
                                              key={item.DeviceId}
                                              onClick={(e) => {
                                                onDeviceSelection(item)
                                                getAssociateACSList(item)
                                                setIsChannelNumberEdited(false)
                                                clearCameraFields()
                                                setEditAssociate(false);
                                              }}
                                            >
                                              <p className="ListofText">
                                                {item.Name}
                                                <span className="SiteNameText"> - {item.DeviceId}</span>
                                              </p>
                                              <div>
                                              </div>
                                            </div>
                                          );
                                        })
                                        : (<div className="no-data-found">No Mobile Found</div>)
                                    )
                                      : (!acsDevicesList && (
                                        <div className="no-data-found">No Mobile Available</div>
                                      ))
                                  )
                                  :
                                  (
                                    paneldeviceslist ? (
                                      paneldeviceslist?.length > 0
                                        ?
                                        paneldeviceslist.map((item) => {
                                          return (
                                            <div
                                              className={selectedDevice?.DeviceId === item.DeviceId ? "OneList SelectedList" : "OneList"}
                                              key={item.DeviceId}
                                              onClick={(e) => {
                                                if (selectedDevice?.DeviceId !== item.DeviceId) {
                                                  onDeviceSelection(item);
                                                }
                                              }}
                                            >
                                              <p className="ListofText">
                                                {item.Name}
                                                <span className="SiteNameText"> - {item.DeviceId}</span>
                                              </p>
                                              <div>
                                              </div>
                                            </div>
                                          );
                                        })
                                        : (
                                          <div className="no-data-found">No Panel Found</div>
                                        )
                                    )
                                      : (!paneldeviceslist && (
                                        <div className="no-data-found">No Panel Available</div>
                                      ))
                                  )
                      }
                    </div>
                </div>
                  <div className="SiteRightContainer">
                    {
                      interfaceType === NVRDVR
                        ?
                        <>
                          <h1 className="MainHeaderName">Camera Details</h1>
                          <div className="siteformContainer">
                            {
                              bulkUpload
                                ?
                                <CameraBulkUpload
                                  selectedCamHeaders={selectedCamHeaders}
                                  OnAddBulkDevicesClick={OnAddBulkDevicesClick}
                                  setSelectedCamHeaders={setSelectedCamHeaders}
                                  clearImportedCamHeaders={clearImportedCamHeaders}
                                  deviceBulkUploadResponse={deviceBulkUploadResponse}
                                  setImportedFileData={setImportedFileData}
                                  setDeviceBulkUploadResponse={setDeviceBulkUploadResponse}
                                  handleSingleUploadClick={handleSingleUploadClick}
                                  setBulkUpload={setBulkUpload}
                                  setIsSingleOrBulkSelection={setIsSingleOrBulkSelection}
                                  importedFileHeaders={importedFileHeaders}
                                  setImportedFileHeaders={setImportedFileHeaders}
                                />
                                :
                                <div className="site-form" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                  <div className="inputMainContainer w40dot75rem">
                                    <div className="inputTypeLabelContainer">
                                      <label className="formFieldLabels">Brand Name</label>
                                      <select
                                        {...register("CameraBrandId")}
                                        className="inputType ArrowSelectClass"
                                        disabled={true}
                                        placeholder="Select Brand Name"
                                        defaultValue={selectedDevice.cameraBrandId || selectedDevice.CameraBrandId}
                                        onChange={(e) => {
                                          setValue("CameraBrandId", e.target.value);
                                          handleOptionChange(e.target.value)
                                        }}
                                      >
                                        <option key="0" disabled={false} value="0">Select Brand Name*</option>
                                        {interfaceSubTypeData &&
                                          interfaceSubTypeData.map((val) => (
                                            <option
                                              value={val.InterfacesubtypeId}
                                              key={val.InterfacesubtypeId}
                                              id={val.InterfacesubtypeId}
                                            >
                                              {val.Interfacesubtypename}
                                            </option>
                                          ))}
                                        {/* {devicesmasterlist &&
                                        devicesmasterlist.cameraTypeMasterList &&
                                        devicesmasterlist.cameraTypeMasterList.map((val) => (
                                          <option value={val.brandId} key={val.brandId}>
                                            {val.brandName}
                                          </option>
                                        ))} */}
                                      </select>
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>IP Address</label>
                                      <input
                                        {...register("privateIPAddress")}
                                        className="inputType"
                                        disabled={true}
                                        placeholder="IP Address* e.g. 192.168.0.54"
                                        defaultValue={selectedDevice.privateIPAddress}
                                      />
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Communication Port Device</label>
                                      <input
                                        {...register("communicationPort")}
                                        className="inputType"
                                        //disabled={!isDeviceEdit}
                                        disabled={true}
                                        placeholder="Enter Communication Port* e.g. 8080"
                                        onKeyPress={(e) => {
                                          onNumberOnlyChange(e);
                                          setCommunicationPortError('')
                                        }}
                                        onChange={() => setCommunicationPortError('')}
                                        defaultValue={selectedDevice.communicationPort}
                                      />
                                      <p className="Error_P" style={{ float: "left" }}><span> {communicationPortError} </span></p>
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>HTTP Port</label>
                                      <input
                                        {...register("httpPort")}
                                        className="inputType"
                                        //disabled={!isDeviceEdit}
                                        disabled={true}
                                        placeholder="Enter HTTP Port* e.g. 443"
                                        onKeyPress={(e) => {
                                          onNumberOnlyChange(e);
                                          setHttpPotError('')
                                        }}
                                        onChange={() => setHttpPotError('')}
                                        defaultValue={selectedDevice.httpPort}
                                      />
                                      <p className="Error_P" style={{ float: "left" }}><span> {httpPortError} </span></p>
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>User Name</label>
                                      <input
                                        {...register("userName")}
                                        className="inputType"
                                        disabled={true}
                                        placeholder="User Name* e.g. Admin"
                                        defaultValue={selectedDevice.camUserName}
                                      />
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Password</label>
                                      <input
                                        {...register("password")}
                                        className="inputType"
                                        disabled={true}
                                        placeholder="Password* e.g. Abc@123"
                                        defaultValue={selectedDevice.camPassword}
                                      />
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>RTSP Port</label>
                                      <input
                                        {...register("port")}
                                        className="inputType"
                                        placeholder="RTSP Port* e.g. 554"
                                        disabled={true}
                                        onKeyPress={onNumberOnlyChange}
                                        defaultValue={selectedDevice.camPort}
                                      />
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Channel Number</label>
                                      <input
                                        {...register("channelNumber")}
                                        className="inputType"
                                        disabled={!isDeviceEdit}
                                        placeholder={channelNumberPlaceholder}
                                        onKeyPress={(e) => {
                                          setIsChannelNumberEdited(true)
                                          onNumberOnlyChange(e)
                                          setChannelNumberError('')
                                        }}
                                        onChange={() => { setChannelNumberError('') }}
                                        defaultValue={selectedDevice.channelNum}
                                      />
                                      <p className="Error_P" style={{ float: "left" }}><span>{channelNumberError}</span></p>
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Live Stream Type</label>
                                      <select
                                        {...register("liveStreamTypeNumber")}
                                        className="inputType ArrowSelectClass"
                                        disabled={!isDeviceEdit}
                                        placeholder="Stream type (Live)*"
                                        onChange={(e) => {
                                          setValue('liveStreamTypeNumber', e.target.value)
                                          setLiveStreamTypeError("");
                                        }}
                                      >
                                        <option value="">Select Live Stream Type</option>
                                        <option value="Main">Main</option>
                                        <option value="Sub">Sub</option>
                                        <option value="Ter">Ter</option>
                                      </select>

                                      <p className="Error_P" style={{ float: "left" }}><span>{liveStreamTypeError}</span></p>
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Playback Stream Type</label>
                                      <select
                                        {...register("playbackStreamTypeNumber")}
                                        className="inputType ArrowSelectClass"
                                        disabled={!isDeviceEdit}
                                        placeholder="Stream type (Playback)*"
                                        onChange={(e) => {
                                          setValue('playbackStreamTypeNumber', e.target.value)
                                          setPlaybackStreamTypeError("");
                                        }}
                                      >
                                        <option value="">Select Playback Stream Type</option>
                                        <option value="Main">Main</option>
                                        <option value="Sub">Sub</option>
                                        <option value="Ter">Ter</option>
                                      </select>
                                      <p className="Error_P" style={{ float: "left" }}><span>{playbackStreamTypeError}</span></p>
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>RTSP URL</label>
                                      <input
                                        {...register("rTSPURL")}
                                        className="inputType"
                                        disabled={true}
                                        placeholder="RTSP URL* e.g. rtsp://Admin:Abc@123@192.168.0.58:554/Streaming/Channels/1"
                                        defaultValue={selectedDevice.RTSPURL}
                                        onChange={() => {
                                          setRtspValueChanged(true)
                                          setrtspURLError('')
                                        }}
                                      />
                                      <p className="Error_P" style={{ float: "left" }}><span>{rtspURLError}</span></p>
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Device Name</label>
                                      <input
                                        {...register("cameraName")}
                                        className="inputType"
                                        disabled={!isDeviceEdit}
                                        placeholder="Enter Device Name* e.g. Lobby Camera"
                                        defaultValue={selectedDevice.CameraName}
                                        onKeyPress={(e) => {
                                          onSpecialChangeOnly(e);
                                          setDeviceNameError('')
                                        }}
                                        onChange={() => { setDeviceNameError('') }}
                                      />
                                      <p className="Error_P" style={{ float: "left" }}><span>{deviceNameError}</span></p>
                                    </div>
                                  </div>

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Branch Name</label>
                                      <select
                                        {...register("SiteID")}
                                        className="inputType ArrowSelectClass"
                                        placeholder="Branch*"
                                        disabled={true}
                                        defaultValue={selectedDevice.SiteID}
                                        onChange={(e) => setValue("SiteID", e.target.value)}
                                      >
                                        <option key="0" disabled={false} value="0">Select Branch*</option>
                                        {sites &&
                                          sites.map((site) => (
                                            <option value={site.SiteID} key={site.SiteID}>
                                              {site.SiteName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>

                                  {/* <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Entity Subtype</label>
                                        <select
                                          {...register("CCTVTypeID")}
                                          className="inputType ArrowSelectClass"
                                          placeholder="Entity Subtype*"
                                          disabled={true}
                                          defaultValue={selectedDevice.CCTVTypeID}
                                          onChange={(e) =>
                                            setValue("CCTVTypeID", e.target.value)

                                          }
                                        >
                                          <option key="0" disabled={false} value="0" id="0">Entity Subtype*</option>
                                          {cctvTypeData && cctvTypeData.map((entity) => (
                                            <option value={entity.EntityTypeID} key={entity.EntityTypeID}>
                                              {entity.EntityType}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div> */}

                                  <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Device Type</label>
                                      <select
                                        {...register("cameraDeviceId")}
                                        className="inputType ArrowSelectClass"
                                        placeholder="Device Type*"
                                        disabled={true}
                                        defaultValue={selectedDevice.cameraDeviceId}
                                        onChange={(e) =>
                                          setValue("cameraDeviceId", e.target.value)

                                        }
                                      >
                                        <option key="0" disabled={false} value="0" id="0">Device Type*</option>
                                        {deviceTypeData && deviceTypeData.map((item) => (
                                          <option value={item.DeviceTypeID} key={item.DeviceTypeID}>
                                            {item.DeviceType}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>

                                  {
                                    MULTI_TIME_ZONE
                                      ?
                                      <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                          <label className='formFieldLabels'>Timezone</label>
                                          <select
                                            {...register("TimeZoneIdDevice")}
                                            className="inputType ArrowSelectClass"
                                            placeholder="Select timezone*"
                                            disabled={true}
                                            defaultValue={selectedDevice.TimeZoneIdDevice}
                                            onChange={(e) =>
                                              setValue("TimeZoneIdDevice", e.target.value)
                                            }
                                          >
                                            <option key="0" disabled={false} value="0" id="0">Select timezone*</option>
                                            {timezone &&
                                              timezone.map((val) => (
                                                <option
                                                  value={val.TimeZoneId} key={val.TimeZoneId}
                                                  id={val.Abbreviation}>
                                                  {val.Abbreviation}-({val.Fullname})
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                      : null
                                  }

                                  <div className="inputMainContainer w40dot75rem mt30">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Enable Transcoding</label>
                                      <div className='mt-1 signTypeCheckboxLabels'>
                                        <div className="SiteTextBox SiteNameText mt-0">
                                          <div className="onlyforEnableCheckbox ml-0">
                                            <input
                                              className="checkbox_custom"
                                              type="checkbox"
                                              disabled={!isDeviceEdit}
                                              {...register("isTranscoded")}
                                              onChange={(e) => {
                                                setValue("isTranscoded", Number(e.target.checked))
                                                setParentIsEncoding(e.target.checked);
                                              }}
                                              defaultValue={Number(selectedDevice.isTranscoded)}
                                            />
                                            <label className="mb-0"

                                              onClick={() => {
                                                if (!isDeviceEdit) {
                                                  return;
                                                }
                                                getValues("isTranscoded")
                                                if (parentIsEncoding) {
                                                  setValue("isTranscoded", 0)
                                                  setParentIsEncoding(false);
                                                } else {
                                                  setValue("isTranscoded", 1)
                                                  setParentIsEncoding(true);
                                                }
                                              }}
                                            >
                                              Live Enable Transcoding to H.264 <sup>(Optional)</sup>
                                            </label>
                                          </div>
                                        </div>
                                        
                                        <div className="SiteTextBox SiteNameText mt-0">
                                          <div className="onlyforEnableCheckbox">
                                            <input
                                              className="checkbox_custom"
                                              type="checkbox"
                                              disabled={!isDeviceEdit}
                                              {...register("isPlaybackTranscoded")}
                                              onChange={(e) => {
                                                setValue("isPlaybackTranscoded", Number(e.target.checked))
                                                setParentIsPlaybackEncoding(e.target.checked);
                                              }}
                                              defaultValue={Number(selectedDevice.isPlaybackTranscoded)}
                                            />
                                            <label className="mb-0"
                                              onClick={() => {
                                                getValues("isPlaybackTranscoded")
                                                if (parentIsPlaybackEncoding) {
                                                  setValue("isPlaybackTranscoded", 0)
                                                  setParentIsPlaybackEncoding(false);
                                                } else {
                                                  setValue("isPlaybackTranscoded", 1)
                                                  setParentIsPlaybackEncoding(true);
                                                }
                                              }}
                                            >
                                              Playback Enable Transcoding to H.264 <sup>(Optional)</sup>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {(interfaceDevice.isTwoWayEnabled || interfaceDevice.IsTwoWayEnabled == "1") &&
                                    <div className="inputMainContainer w40dot75rem">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Enable Two Way Communication</label>
                                        <div className="onlyforEnableCheckbox">
                                          <input
                                            className="checkbox_custom"
                                            type="checkbox"
                                            disabled={!isDeviceEdit}
                                            {...register("isTwoWayEnabledDevice")}
                                            onChange={(e) => {
                                              setValue("isTwoWayEnabledDevice", Number(e.target.checked))
                                              setParentIsEnablingTwoWayDevice(e.target.checked);
                                            }}
                                            defaultValue={Number(selectedDevice.isTwoWayEnabled)}
                                          />
                                          <label className="mb-0"
                                            onClick={() => {
                                              if (!isDeviceEdit) {
                                                return;
                                              }
                                              getValues("isTwoWayEnabledDevice")
                                              if (parentIsEnablingTwoWayDevice) {
                                                setValue("isTwoWayEnabledDevice", 0)
                                                setParentIsEnablingTwoWayDevice(false);
                                              } else {
                                                setValue("isTwoWayEnabledDevice", 1)
                                                setParentIsEnablingTwoWayDevice(true);
                                              }
                                            }}
                                          >
                                            Enable Two Way Communication
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  <div className="inputMainContainer w40dot75rem">
                                    <div className="inputTypeLabelContainer">
                                      <label className='formFieldLabels'>Enable PTZ</label>
                                      <div className="onlyforEnableCheckbox">
                                        <input
                                          className="checkbox_custom"
                                          type="checkbox"
                                          disabled={!isDeviceEdit}
                                          {...register("isPTZ")}
                                          onChange={(e) => {
                                            setValue("isPTZ", Number(e.target.checked))
                                            setParentIsEnablingPTZ(e.target.checked)
                                            // setParentIsEnablingTwoWayDevice(e.target.checked);
                                          }}
                                          defaultValue={Number(selectedDevice.isPTZ)}
                                        />
                                        <label className="mb-0"
                                          onClick={() => {
                                            if (!isDeviceEdit) {
                                              return;
                                            }
                                            getValues("isPTZ")
                                            if (parentIsEnablingPTZ) {
                                              setValue("isPTZ", 0)
                                              setParentIsEnablingPTZ(false);
                                              // setParentIsEnablingTwoWayDevice(false);
                                            } else {
                                              setValue("isPTZ", 1)
                                              setParentIsEnablingPTZ(true);
                                              // setParentIsEnablingTwoWayDevice(true);
                                            }
                                          }}
                                        >
                                          Enable PTZ
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  {
                                    MULTI_TIME_ZONE
                                      ?
                                      <>
                                      <div className="inputMainContainer w40dot75rem">
                                        <div className="inputTypeLabelContainer">
                                          <label className='formFieldLabels'>Enable Playback in UTC</label>
                                          <div className="onlyforEnableCheckbox">
                                            <input
                                              className="checkbox_custom"
                                              type="checkbox"
                                              disabled={!isDeviceEdit}
                                              {...register("isPlaybackUTC")}
                                              onChange={(e) => {
                                                setValue("isPlaybackUTC", Number(e.target.checked))
                                                setParentIsEnablingUTCPlayback(e.target.checked);
                                              }}
                                              defaultValue={Number(selectedDevice.isPlaybackUTC)}
                                            />
                                            <label className="mb-0"
                                              onClick={() => {
                                                if (!isDeviceEdit) {
                                                  return;
                                                }
                                                getValues("isPlaybackUTC")
                                                if (parentIsEnablingUTCPlayback) {
                                                  setValue("isPlaybackUTC", 0)
                                                  setParentIsEnablingUTCPlayback(false);
                                                  // setParentIsEnablingTwoWayDevice(false);
                                                } else {
                                                  setValue("isPlaybackUTC", 1)
                                                  setParentIsEnablingUTCPlayback(true);
                                                  // setParentIsEnablingTwoWayDevice(true);
                                                }
                                              }}
                                            >
                                              Enable Playback in UTC
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="inputMainContainer w40dot75rem">
                                        <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Device stage</label>
                                        <select 
                                        {...register("deviceStageTypeId")}
                                        className="inputType ArrowSelectClass"
                                        disabled={!isDeviceEdit}
                                        placeholder="Device stage"
                                        onChange={(e) => {
                                          setValue('deviceStageTypeId', e.target.value)
                                          setDeviceStageError('')
                                        }}>
                                          <option key="0"  value="0" id="0">Select Device stage*</option>
                                            {deviceStage &&
                                             deviceStage.map((val) => (
                                              <option
                                                value={val.StageID} key={val.StageID}
                                                id={val.StageID}>
                                                {val.StageName}
                                              </option>
                                            ))}
                                        </select>
                                        <p className="Error_P" style={{ float: "left" }}><span>{deviceStageError}</span></p>
                                        </div>
                                      </div>
                                      <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>License Services</label>
                                        <div className='mt-1 signTypeCheckboxLabels'>
                                            <div className="SiteTextBox mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck1"
                                                        checked={camerasChecked}
                                                        disabled={!isDeviceEdit}
                                                        onChange={() => setCamerasChecked(!camerasChecked)}
                                                    />
                                                    <label className="" htmlFor="exampleCheck1">
                                                        CCTV
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="SiteTextBox mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck2"
                                                        checked={alertsChecked}
                                                        disabled={!isDeviceEdit}
                                                        onChange={() => setAlertChecked(!alertsChecked)}
                                                    />
                                                    <label className="" htmlFor="exampleCheck2">
                                                        Alerts
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="SiteTextBox mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck3"
                                                        checked={healthMonitoringChecked}
                                                        disabled={!isDeviceEdit}
                                                        onChange={() => setHealthMonitoringChecked(!healthMonitoringChecked)}
                                                    />
                                                    <label className="" htmlFor="exampleCheck3">
                                                        Health Monitoring
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="SiteTextBox mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck4"
                                                        checked={videoBackupChecked}
                                                        disabled={!isDeviceEdit}
                                                        onChange={() => setVideoBackupChecked(!videoBackupChecked)}
                                                    />
                                                    <label className="" htmlFor="exampleCheck4">
                                                        Video Backup
                                                    </label>
                                                </div>
                                            </div>
                                           
                                        </div>
                                    </div>
                                </div>
                                      </>
                                      : null
                                  }
                                  <div style={{ alignItems: "center" }}>
                                    {/* {
                                      selectedDevice.ParentCameraID == 0 && interfaceType == NVRDVR && !bulkUpload &&
                                      (
                                        <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => handleBulkUploadClick()}>
                                          <span className="ViewUpdate">Bulk upload</span>
                                        </button>
                                      )
                                    } */}
                                    {
                                      selectedDevice.ParentCameraID == 0 && interfaceType == NVRDVR && bulkUpload &&
                                      (
                                        <button className="DataAccessEdit" style={{ width: "100px" }}
                                          onClick={handleSubmit((e) => {
                                            OnAddBulkDevicesClick(e, importedFileHeaders);
                                          })}
                                        >
                                          <span className="ViewUpdate">Upload</span>
                                        </button>
                                      )
                                    }
                                    {
                                      selectedDevice.ParentCameraID != 0 && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === FAS || interfaceType === RTU) &&
                                      (
                                        <button className="DataAccessEdit" style={{ width: "100px" }}
                                          onClick={() => {
                                            let temp = interfaceDevice.InterfacesubtypeId;
                                            if (interfaceType === NVRDVR) {
                                              let v1 = interfaceSubTypeData?.filter(x => x.Interfacesubtypename.toLowerCase() == interfaceDevice.Interfacesubtypename.toLowerCase());
                                              if (v1 != undefined && v1.length > 0) {
                                                temp = v1[0].brandId;
                                              }
                                            } else {
                                              //let v1 = devicesmasterlist.panelTypeMasterList.filter(x => x.panelName.toLowerCase() == interfaceDevice.Interfacesubtypename.toLowerCase());
                                              let v1 = interfaceSubTypeData?.filter(
                                                (item) => item.Interfacesubtypename == interfaceDevice.Interfacesubtypename
                                              );
                                              if (v1 != undefined && v1.length > 0) {
                                                temp = v1[0].panelMasterID || v1[0].InterfacesubtypeId;
                                              }
                                            }
                                            let identifier = 0
                                            if (interfaceDevice?.Interfacetypename == "ACS") {
                                              identifier = acsDevicesList == null ? 10 : 11
                                            } else if (interfaceDevice?.Interfacetypename == "Fire Panel") {
                                              let tempDeviceTypeFRS = deviceType.find((item) => item.DeviceType == "Fire Panel" || item.DeviceType == "FRS")
                                              //identifier = tempDeviceTypeFRS?.DeviceTypeID
                                              identifier = 0
                                            } else if (interfaceDevice?.Interfacetypename == "RTU") {
                                              let tempDeviceTypeRTU = deviceType.find((item) => item.DeviceType == "RTU")
                                              //identifier = tempDeviceTypeRTU?.DeviceTypeID
                                              identifier = 0
                                            }
                                            let tempDeviceId = deviceType.find((item) => item.DeviceType == "Camera")
                                            let deviceObject = {
                                              "ParentCameraID": 0,
                                              "cameraName": '',
                                              "privateIPAddress": interfaceDevice.InterfaceIP,
                                              "SiteID": interfaceDevice.siteid||interfaceDevice.SiteId,
                                              "userName": interfaceDevice.UserName,
                                              "password": interfaceDevice.Password,
                                              "port": interfaceDevice.InterfacePort,
                                              "channelNumber": '',
                                              "liveStreamTypeNumber": '',
                                              "playbackStreamTypeNumber": '',
                                              "rTSPURL": '',
                                              "location": '',
                                              "PanelMasterId": interfaceType === NVRDVR ? 0 : temp,
                                              "CameraBrandId": temp,
                                              "communicationPort": interfaceDevice.Communicationport || interfaceDevice.communicationPortInterface,
                                              "httpPort": interfaceDevice.InternetProtocolPort || interfaceDevice.httpPortInterface,
                                              "isTranscoded": 0,
                                              "isPlaybackTranscoded": 0,
                                              "isTwoWayEnabledDevice": 0,
                                              "CCTVTypeID": interfaceDevice.EntityTypeID,
                                              "TimeZoneIdDevice": interfaceDevice.TimeZoneId||interfaceDevice.TimeZoneID,
                                              "identifierName": "",
                                              "cameraDeviceId": tempDeviceId?.DeviceTypeID || 6,
                                              "acsDeviceType": identifier,
                                              "deviceStageTypeId":0
                                            }
                                            setSelectedDevice(deviceObject);
                                            setVideoBackupChecked(false);
                                            setAlertChecked(false);
                                            setHealthMonitoringChecked(false);
                                            setCamerasChecked(false);
                                            setIsDeviceEdit(true)
                                            setAssociateCamSecVisibility(false);
                                            setParentIsEncoding(false);
                                            setParentIsPlaybackEncoding(false);
                                            setParentIsEnablingTwoWayDevice(false)
                                            setParentIsEnablingTwoWayInterface(false)
                                            setParentIsEnablingPlaybackTimeStampsToUTC(false)
                                            setParentIsEnablingPlaybackLongDateFormat(false)
                                            clearCameraFields()
                                          }
                                          }
                                        >
                                          <span className="ViewUpdate">Add New</span>
                                        </button>
                                      )
                                    }

                                    {
                                      selectedDevice.ParentCameraID != 0 && !isDeviceEdit && selectedDevice.panelMasterId != 0 && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === FAS || interfaceType === RTU) &&
                                      (
                                        <button className="DataAccessEdit" style={{ width: "100px" }}
                                          onClick={() => {
                                            setIsDeviceEdit(true);
                                          }}
                                        >
                                          <span className="ViewUpdate">Edit</span>
                                        </button>
                                      )
                                    }
                                    {
                                      selectedDevice.ParentCameraID == 0 && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === FAS || interfaceType === RTU) && !bulkUpload &&
                                      (
                                        <button className="DataAccessEdit" style={{ width: "100px" }}
                                          onClick={handleSubmit((e) => {
                                            if (interfaceType === NVRDVR) {
                                              OnSaveDevice(e, selectedDevice.ParentCameraID)
                                            } else {
                                              onSaveACS(e, selectedDevice.DeviceId)
                                              // Call Save Function of updating ACS device.
                                            }
                                          })}
                                        >
                                          <span className="ViewUpdate">Save</span>
                                        </button>
                                      )
                                    }
                                    {
                                      selectedDevice.ParentCameraID != 0 && isDeviceEdit && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === FAS || interfaceType === RTU) &&
                                      (
                                        <>
                                          <button className="DataAccessEdit" style={{ width: "100px" }}
                                            onClick={handleSubmit((e) => {
                                              if (interfaceType === NVRDVR) {
                                                OnSaveDevice(e, selectedDevice.ParentCameraID)
                                              } else {
                                                onSaveACS(e, selectedDevice.DeviceId)
                                                // Call Save Function of updating ACS device.
                                              }
                                            })}
                                          >
                                            <span className="ViewUpdate">Save</span>
                                          </button>
                                          <button className="DataAccessEdit" style={{ width: "100px" }} onClick={(e) => onCancelDevice(e)}>
                                            <span className="ViewUpdate">Cancel</span>
                                          </button>
                                        </>
                                      )
                                    }
                                    {
                                      selectedDevice.ParentCameraID != 0 && !isDeviceEdit && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === FAS || interfaceType === RTU) &&
                                      (
                                        <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => {
                                          interfaceType === NVRDVR
                                            ? checkForAlertsAndDelDevice(selectedDevice)
                                            : interfaceType === ACS
                                              ? checkForAlertsAndDelDevice(selectedDevice)
                                              : OnAddIDSPanel(null, selectedDevice.ParentCameraID, "deletePanel")
                                        }}>
                                          <span className="ViewUpdate">Delete</span>
                                        </button>
                                      )
                                    }
                                  </div>
                                  {
                                    selectedDevice.ParentCameraID != 0
                                      ?
                                      <>
                                        <div className="ACSCustomerFilterMainDiv w40dot75rem mt35">
                                          <div className="ACSTextBox mt-0">
                                            <p className="SiteNameText mb-0" style={{ fontSize: "1.2rem" }}>
                                              Associate Device
                                            </p>
                                            <div className='filterinnerboxdiv1'>
                                              <div>
                                                <div className="SelectionListWithSelectAll">
                                                  <input
                                                    className="SearchViewInput1"
                                                    style={{ width: "100%" }}
                                                    type="search"
                                                    placeholder="Search"
                                                    value={cameraSearch}
                                                    onChange={(e) => searchCCTVCameraHandler(e, "Camera")}
                                                  />
                                                  {/* {
                                                                            isDarkTheme ?
                                                                                <img src={SearchIcon} alt='search icon' style={{ cursor: 'pointer' }} /> :
                                                                                <img src={SearchIconWhite} height="15" alt='search icon' style={{ cursor: 'pointer' }} />
                                                                        } */}
                                                </div>
                                              </div>
                                              {/* {
                                                true > 0
                                                  ?
                                                  <div className='dataAccessListItem ACSCustomerFilter mt-2'
                                                    style={{ textAlign: "left", marginLeft: "5px" }}
                                                  >
                                                    <input type="checkbox"
                                                      checked={cameraSelectAll}
                                                      onChange={handleCameraSelectAll}
                                                      disabled={!editAssociate}
                                                    />
                                                    <p className="AllTextwithValue mb-1" style={{ fontWeight: "500" }}
                                                      onClick={() => {
                                                        if (editAssociate) {
                                                          handleCameraSelectAll()
                                                        }
                                                      }}
                                                      disabled={!editAssociate}
                                                    >
                                                      Select all <span>{cameraCount}</span>
                                                    </p>
                                                  </div>
                                                  : null
                                              } */}
                                              <div className='HgtFilterBoxList' style={{ textAlign: "left", marginLeft: "5px", height: "17vh" }}>
                                                {
                                                  cctvList.length > 0
                                                    ?
                                                    cctvList.map((item) => (
                                                      <div key={item.deviceId} className="dataAccessListItem">
                                                        <input type="checkbox" checked={item.isChecked} disabled={!editAssociate} onChange={(e) => cctvCheckHandler(e, item.deviceId)} />
                                                        <p className="AllTextwithValue" disabled={!editAssociate} onClick={(e) => {
                                                          if (editAssociate) {
                                                            cctvCheckHandler(e, item.deviceId)
                                                          }
                                                        }}>{item.cameraName}</p>
                                                      </div>
                                                    ))
                                                    :
                                                    <p className="AllTextwithValue" >No Cameras Found</p>
                                                }
                                                {/* <div className="dataAccessListItem">
                                                                                <input type="checkbox" />
                                                                                <p className="AllTextwithValue">Device1</p>
                                                                            </div>
                                                                            <div className="dataAccessListItem">
                                                                                <input type="checkbox" />
                                                                                <p className="AllTextwithValue">Device2</p>
                                                                            </div>
                                                                            <div className="dataAccessListItem">
                                                                                <input type="checkbox" />
                                                                                <p className="AllTextwithValue">Device3</p>
                                                                            </div>
                                                                            <div className="dataAccessListItem">
                                                                                <input type="checkbox" />
                                                                                <p className="AllTextwithValue">Device4</p>
                                                                            </div>
                                                                            <div className="dataAccessListItem">
                                                                                <input type="checkbox" />
                                                                                <p className="AllTextwithValue">Device5</p>
                                                                            </div>
                                                                            <div className="dataAccessListItem">
                                                                                <input type="checkbox" />
                                                                                <p className="AllTextwithValue">Device6</p>
                                                                            </div> */}
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div style={{ alignItems: "center" }}>
                                          {
                                            !editAssociate
                                              ?
                                              <button className="DataAccessEdit" style={{ width: "170px" }} onClick={() => setEditAssociate(true)}>
                                                <span className="ViewUpdate">Edit Associated Devices</span>
                                              </button>
                                              :
                                              <>
                                                <button className="DataAccessEdit" style={{ width: "180px" }} onClick={() => associatetCCTV(selectedDevice)}>
                                                  <span className="ViewUpdate">Save Associated Devices</span>
                                                </button>
                                                <button className="DataAccessEdit" style={{ width: "190px" }} onClick={cancelCCTVAssociation}>
                                                  <span className="ViewUpdate">Cancel Associated Devices</span>
                                                </button>
                                              </>
                                          }
                                        </div>
                                      </>
                                      :
                                      null
                                  }

                                </div>
                            }
                          </div>
                        </>
                        :
                        interfaceType === "ACS" || interfaceType === "RTU" || interfaceType === "Fire Panel"
                          ?
                          <>
                            <h1 className="MainHeaderName">{`${interfaceType}`} Details</h1>
                            {
                              bulkUpload
                                ?
                                <AcsBulkUpload
                                  selectedHeaders={selectedAcsHeaders}
                                  onPanelBulkUpload={onAcsBulkUpload}
                                  setSelectedHeaders={setSelectedAcsHeaders}
                                  clearImportedPanelHeaders={clearImportedAcsHeaders}
                                  setImportedFileData={setImportedFileData}
                                  panelBulkUploadResponse={acsBulkUploadResponse}
                                  setPanelBulkUploadResponse={setAcsBulkUploadResponse}
                                  panelBulkUploadError={acsBulkUploadError}
                                  setPanelBulkUploadError={setAcsBulkUploadError}
                                  setBulkUpload={setBulkUpload}
                                  setIsSingleOrBulkSelection={setIsSingleOrBulkSelection}
                                  importedPanelHeaders={importedAcsHeaders}
                                  setImportedPanelHeaders={setImportedAcsHeaders}
                                  onAcsBulkUpload={onAcsBulkUpload}
                                  interfaceType={interfaceType}
                                />
                                :
                                <div className="siteformContainer">
                                  <div className="site-form" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

                                    <div className="inputMainContainer w40dot75rem">
                                      <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">Brand Name</label>
                                        <select
                                          {...register("PanelMasterId")}
                                          className="inputType ArrowSelectClass"
                                          disabled={true}
                                          placeholder="Select Brand Name"
                                          defaultValue={selectedDevice.panelMasterId}
                                          onChange={(e) => {
                                            setValue("PanelMasterId", e.target.value);
                                          }}
                                        >
                                          <option key="0" disabled={false} value="0">Select Brand Name*</option>
                                          {interfaceSubTypeData &&
                                            interfaceSubTypeData.map((site) => (
                                              <option
                                                value={site.InterfacesubtypeId}
                                                key={site.InterfacesubtypeId}
                                                id={site.InterfacesubtypeId}>
                                                {site.Interfacesubtypename}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>IP Address</label>
                                        <input
                                          {...register("privateIPAddress")}
                                          className="inputType"
                                          disabled={true}
                                          placeholder="IP address* e.g. 192.168.0.54"
                                          defaultValue={selectedDevice.privateIPAddress}
                                        />
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Port</label>
                                        <input
                                          {...register("port")}
                                          className="inputType"
                                          disabled={true}
                                          placeholder="Enter Port* e.g. 443"
                                          onKeyPress={(e) => {
                                            onNumberOnlyChange(e);
                                          }}
                                          defaultValue={selectedDevice.camPort}
                                        />
                                        {/* <p className="Error_P" style={{ float: "left" }}><span> {httpPortError} </span></p> */}
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Interface Username</label>
                                        <input
                                          {...register("InterfaceUsername")}
                                          className="inputType"
                                          disabled={!isInterfaceEdit}
                                          placeholder="Enter Interface Username*"
                                          onChange={() => setInterfaceUserError('')}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}><span> {interfaceUserError} </span></p>
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Interface Password</label>
                                        <input
                                          {...register("InterfacePassword")}
                                          className="inputType"
                                          disabled={!isInterfaceEdit}
                                          placeholder="Enter Interface Password*"
                                          onChange={() => setInterfacePasswardError('')}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}><span> {interfacePasswardError} </span></p>
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Device Name</label>
                                        <input
                                          {...register("cameraName")}
                                          className="inputType"
                                          disabled={!isDeviceEdit}
                                          placeholder="Enter Device Name* e.g. Lobby Camera"
                                          defaultValue={selectedDevice.CameraName}
                                          onKeyPress={(e) => {
                                            onSpecialChangeOnly(e);
                                            setDeviceNameError('')
                                          }}
                                          onChange={() => { setDeviceNameError('') }}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}><span>{deviceNameError}</span></p>
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Device Type</label>
                                        <select
                                          {...register("acsDeviceType")}
                                          className="inputType ArrowSelectClass"
                                          placeholder="Device Type*"

                                          disabled={(interfaceType === RTU || interfaceType === FAS ) && isDeviceEdit ? false : true}
                                          defaultValue={selectedDevice.acsDeviceType}
                                          onChange={(e) => {
                                            setValue("acsDeviceType", e.target.value)
                                            setDeviceTypeError('')
                                          }
                                          }
                                        >
                                          <option key="0" disabled={false} value="0" id="0">Device Type*</option>
                                          {
                                            (selectedDevice.ParentDeviceID == null && selectedDevice.ParentCameraID != 0) && (interfaceType === FAS || interfaceType === RTU)
                                              ?
                                              deviceTypeDataForInterface && deviceTypeDataForInterface.map((item) => (
                                                <option value={item.DeviceTypeID} key={item.DeviceTypeID} id={item.DeviceTypeID}>
                                                  {item.DeviceType}
                                                </option>
                                              ))
                                              :
                                              deviceTypeData && deviceTypeData.map((item) => (
                                                <option value={item.DeviceTypeID} key={item.DeviceTypeID} id={item.DeviceTypeID}>
                                                  {item.DeviceType}
                                                </option>
                                              ))
                                          }



                                        </select>
                                        <p className="Error_P" style={{ float: "left" }}><span>{deviceTypeError}</span></p>
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Identifier Name</label>
                                        <input
                                          {...register("identifierName")}
                                          className="inputType"
                                          disabled={!isDeviceEdit}
                                          placeholder="Enter Identifier Name* e.g. Lobby Camera"
                                          defaultValue={selectedDevice.IdentifierName}
                                          onKeyPress={(e) => {
                                            onSpecialChangeOnly(e);
                                            setIdentifierError('')
                                          }}
                                          onChange={() => { setIdentifierError('') }}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}><span>{identifierError}</span></p>
                                      </div>
                                    </div>
                                    {
                                      selectedDevice?.ParentCameraID != 0 && selectedDevice?.ParentDeviceID == null 
                                      &&
                                      <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>License Module</label>
                                        <div className='mt-1 signTypeCheckboxLabels'>
                                            <div className="SiteTextBox mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck1"
                                                        checked={alertsChecked}
                                                        disabled={!isDeviceEdit}
                                                        onChange={() => setAlertChecked(!alertsChecked)}
                                                    />
                                                    <label className="" htmlFor="exampleCheck1">
                                                        Alerts
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="SiteTextBox mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck2"
                                                        checked={healthMonitoringChecked}
                                                        disabled={!isDeviceEdit}
                                                        onChange={() => setHealthMonitoringChecked(!healthMonitoringChecked)}
                                                    />
                                                    <label className="" htmlFor="exampleCheck2">
                                                        Health Monitoring
                                                    </label>
                                                </div>
                                            </div>
                                            
                                           
                                        </div>
                                    </div>
                                </div>
                                    }
                                    
                                    <div style={{ alignItems: "center" }}>
                                      {/* {
                                        // selectedDevice.ParentCameraID == 0 && interfaceType == ACS && interfaceType == RTU && interfaceType == FAS && interfaceType == MOBILE && bulkUpload &&
                                        selectedDevice.ParentCameraID == 0 && (interfaceType == ACS || interfaceType == RTU || interfaceType == FAS || interfaceType == MOBILE) && !bulkUpload &&
                                        (
                                          <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => handleBulkUploadClick()}>
                                            <span className="ViewUpdate">Bulk upload</span>
                                          </button>
                                        )
                                      } */}
                                      {
                                        selectedDevice.ParentCameraID == 0 && interfaceType == ACS && interfaceType == RTU && interfaceType == FAS && interfaceType == MOBILE && bulkUpload &&
                                        (
                                          <button lassName="DataAccessEdit" style={{ width: "100px" }}
                                            onClick={handleSubmit((e) => {
                                              OnAddBulkDevicesClick(e, importedFileHeaders);
                                            })}
                                          >
                                            <span className="ViewUpdate">Upload</span>
                                          </button>
                                        )
                                      }
                                      {
                                        selectedDevice.ParentCameraID != 0 && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType == RTU || interfaceType == FAS || interfaceType == MOBILE) &&
                                        (
                                          <button className="DataAccessEdit" style={{ width: "100px" }}
                                            onClick={() => {
                                              let temp = interfaceDevice.InterfacesubtypeId;
                                              if (interfaceType === NVRDVR) {
                                                let v1 = interfaceSubTypeData?.filter(x => x.Interfacesubtypename.toLowerCase() == interfaceDevice.Interfacesubtypename.toLowerCase());
                                                if (v1 != undefined && v1.length > 0) {
                                                  temp = v1[0].brandId;
                                                }
                                              } else {
                                                //let v1 = devicesmasterlist.panelTypeMasterList.filter(x => x.panelName.toLowerCase() == interfaceDevice.Interfacesubtypename.toLowerCase());
                                                let v1 = interfaceSubTypeData?.filter(
                                                  (item) => item.Interfacesubtypename == interfaceDevice.Interfacesubtypename
                                                );
                                                if (v1 != undefined && v1.length > 0) {
                                                  temp = v1[0].panelMasterID || v1[0].InterfacesubtypeId;
                                                }
                                              }
                                              let identifier = 0
                                              if (interfaceDevice?.Interfacetypename == "ACS") {
                                                let acsControllerId = deviceType.find((item) => item.DeviceType == "ACS Controller");
                                                let acsReaderId = deviceType.find((item) => item.DeviceType == "ACS Reader");                                          
                                                identifier = acsDevicesList == null ? acsControllerId.DeviceTypeID : acsReaderId.DeviceTypeID
                                              } else if (interfaceDevice?.Interfacetypename == "Fire Panel") {
                                                let tempDeviceTypeFRS = deviceType.find((item) => item.DeviceType == "Fire Panel" || item.DeviceType == "FRS")
                                                //identifier = tempDeviceTypeFRS?.DeviceTypeID
                                                identifier = 0
                                              } else if (interfaceDevice?.Interfacetypename == "RTU") {
                                                let tempDeviceTypeRTU = deviceType.find((item) => item.DeviceType == "RTU")
                                                //identifier = tempDeviceTypeRTU?.DeviceTypeID
                                                identifier = 0
                                              }
                                              let tempDeviceId = deviceType.find((item) => item.DeviceType == "Camera")
                                              let deviceObject = {
                                                "ParentCameraID": 0,
                                                "cameraName": '',
                                                "privateIPAddress": interfaceDevice.InterfaceIP,
                                                "SiteID": interfaceDevice.SiteId,
                                                "userName": interfaceDevice.UserName,
                                                "password": interfaceDevice.Password,
                                                "port": interfaceDevice.InterfacePort,
                                                "channelNumber": '',
                                                "liveStreamTypeNumber": '',
                                                "playbackStreamTypeNumber": '',
                                                "rTSPURL": '',
                                                "location": '',
                                                "PanelMasterId": interfaceType === NVRDVR ? 0 : temp,
                                                "CameraBrandId": temp,
                                                "communicationPort": interfaceDevice.Communicationport || interfaceDevice.communicationPortInterface,
                                                "httpPort": interfaceDevice.InternetProtocolPort || interfaceDevice.httpPortInterface,
                                                "isTranscoded": 0,
                                                "isPlaybackTranscoded": 0,
                                                "isTwoWayEnabledDevice": 0,
                                                "CCTVTypeID": interfaceDevice.EntityTypeID,
                                                "TimeZoneIdDevice": interfaceDevice.TimeZoneID,
                                                "identifierName": "",
                                                "cameraDeviceId": tempDeviceId?.DeviceTypeID || 6,
                                                "acsDeviceType": identifier,
                                                "deviceStageTypeId":0
                                              }
                                              setSelectedDevice(deviceObject);
                                              setVideoBackupChecked(false);
                                              setAlertChecked(false);
                                              setHealthMonitoringChecked(false);
                                              setCamerasChecked(false);
                                              setIsDeviceEdit(true)
                                              setAssociateCamSecVisibility(false);
                                              setParentIsEncoding(false);
                                              setParentIsPlaybackEncoding(false);
                                              setParentIsEnablingTwoWayDevice(false)
                                              setParentIsEnablingTwoWayInterface(false)
                                              setParentIsEnablingPlaybackTimeStampsToUTC(false)
                                              setParentIsEnablingPlaybackLongDateFormat(false)
                                              clearCameraFields()
                                            }
                                            }
                                          >
                                            <span className="ViewUpdate">Add New</span>
                                          </button>
                                        )
                                      }

                                      {
                                        selectedDevice.ParentCameraID != 0 && !isDeviceEdit && selectedDevice.panelMasterId != 0 && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === RTU || interfaceType === FAS) &&
                                        (
                                          <button className="DataAccessEdit" style={{ width: "100px" }}
                                            onClick={() => {
                                              setIsDeviceEdit(true);
                                            }}
                                          >
                                            <span className="ViewUpdate">Edit</span>
                                          </button>
                                        )
                                      }
                                      {
                                        selectedDevice.ParentCameraID == 0 && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === RTU || interfaceType === FAS) && !bulkUpload &&
                                        (
                                          <button className="DataAccessEdit" style={{ width: "100px" }}
                                            onClick={handleSubmit((e) => {
                                              if (interfaceType === NVRDVR) {
                                                OnSaveDevice(e, selectedDevice.ParentCameraID)
                                              } else {
                                                onSaveACS(e, selectedDevice.DeviceId)
                                                // Call Save Function of updating ACS device.
                                              }
                                            })}
                                          >
                                            <span className="ViewUpdate">Save</span>
                                          </button>
                                        )
                                      }
                                      {
                                        selectedDevice.ParentCameraID != 0 && isDeviceEdit && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === RTU || interfaceType === FAS) &&
                                        (
                                          <>
                                            <button className="DataAccessEdit" style={{ width: "100px" }}
                                              onClick={handleSubmit((e) => {
                                                if (interfaceType === NVRDVR) {
                                                  OnSaveDevice(e, selectedDevice.ParentCameraID)
                                                } else {
                                                  onSaveACS(e, selectedDevice.DeviceId)
                                                  // Call Save Function of updating ACS device.
                                                }
                                              })}
                                            >
                                              <span className="ViewUpdate">Save</span>
                                            </button>
                                            <button className="DataAccessEdit" style={{ width: "100px" }} onClick={(e) => onCancelDevice(e)}>
                                              <span className="ViewUpdate">Cancel</span>
                                            </button>
                                          </>
                                        )
                                      }
                                      {
                                        selectedDevice.ParentCameraID != 0 && !isDeviceEdit && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === RTU || interfaceType === FAS) &&
                                        (
                                          <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => {
                                            interfaceType === NVRDVR
                                              ? checkForAlertsAndDelDevice(selectedDevice)
                                              : interfaceType === ACS || interfaceType === RTU || interfaceType === FAS || interfaceType === MOBILE
                                                ? checkForAlertsAndDelDevice(selectedDevice)
                                                : OnAddIDSPanel(null, selectedDevice.ParentCameraID, "deletePanel")
                                          }}>
                                            <span className="ViewUpdate">Delete</span>
                                          </button>
                                        )
                                      }
                                    </div>

                                    {
                                      selectedDevice.ParentCameraID != 0
                                        ?
                                        <>
                                          <div className="ACSCustomerFilterMainDiv w40dot75rem mt35">
                                            <div className="ACSTextBox mt-0">
                                              <p className="SiteNameText mb-0" style={{ fontSize: "1.2rem" }}>
                                                Associate Device
                                              </p>
                                              <div className='filterinnerboxdiv1'>
                                                <div>
                                                  <div className="SelectionListWithSelectAll">
                                                    <input
                                                      className="SearchViewInput1"
                                                      style={{ width: "100%" }}
                                                      type="search"
                                                      placeholder="Search"
                                                      value={cameraSearch}
                                                      onChange={(e) => searchCameraHandler(e, "Camera")}
                                                    />
                                                    {/* {
                                                                                isDarkTheme ?
                                                                                    <img src={SearchIcon} alt='search icon' style={{ cursor: 'pointer' }} /> :
                                                                                    <img src={SearchIconWhite} height="15" alt='search icon' style={{ cursor: 'pointer' }} />
                                                                            } */}
                                                  </div>
                                                </div>
                                                {/* {
                                                    true > 0
                                                      ?
                                                      <div className='dataAccessListItem ACSCustomerFilter mt-2'
                                                        style={{ textAlign: "left", marginLeft: "5px" }}
                                                      >
                                                        <input type="checkbox"
                                                          checked={cameraSelectAll}
                                                          onChange={handleCameraSelectAll}
                                                          disabled={!editAssociate}
                                                        />
                                                        <p className="AllTextwithValue mb-1" style={{ fontWeight: "500" }}
                                                          onClick={() => {
                                                            if (editAssociate) {
                                                              handleCameraSelectAll()
                                                            }
                                                          }}
                                                          disabled={!editAssociate}
                                                        >
                                                          Select all <span>{cameraCount}</span>
                                                        </p>
                                                      </div>
                                                      : null
                                                  } */}
                                                <div className='HgtFilterBoxList' style={{ textAlign: "left", marginLeft: "5px", height: "17vh" }}>
                                                  {
                                                    acsList.length > 0
                                                      ?
                                                      acsList.map((item) => (
                                                        <div key={item.deviceId} className="dataAccessListItem">
                                                          <input type="checkbox" checked={item.isChecked} disabled={!editAssociate} onChange={(e) => customerCheckHandler(e, item.deviceId)} />
                                                          <p className="AllTextwithValue" disabled={!editAssociate} onClick={(e) => {
                                                            if (editAssociate) {
                                                              customerCheckHandler(e, item.deviceId)
                                                            }
                                                          }}>{item.cameraName}</p>
                                                        </div>
                                                      ))
                                                      :
                                                      <p className="AllTextwithValue" >No Cameras Found</p>
                                                  }
                                                  {/* <div className="dataAccessListItem">
                                                                                    <input type="checkbox" />
                                                                                    <p className="AllTextwithValue">Device1</p>
                                                                                </div>
                                                                                <div className="dataAccessListItem">
                                                                                    <input type="checkbox" />
                                                                                    <p className="AllTextwithValue">Device2</p>
                                                                                </div>
                                                                                <div className="dataAccessListItem">
                                                                                    <input type="checkbox" />
                                                                                    <p className="AllTextwithValue">Device3</p>
                                                                                </div>
                                                                                <div className="dataAccessListItem">
                                                                                    <input type="checkbox" />
                                                                                    <p className="AllTextwithValue">Device4</p>
                                                                                </div>
                                                                                <div className="dataAccessListItem">
                                                                                    <input type="checkbox" />
                                                                                    <p className="AllTextwithValue">Device5</p>
                                                                                </div>
                                                                                <div className="dataAccessListItem">
                                                                                    <input type="checkbox" />
                                                                                    <p className="AllTextwithValue">Device6</p>
                                                                                </div> */}
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div style={{ alignItems: "center" }}>
                                            {
                                              !editAssociate
                                                ?
                                                <button className="DataAccessEdit" style={{ width: "170px" }} onClick={() => setEditAssociate(true)}>
                                                  <span className="ViewUpdate">Edit Associated Devices</span>
                                                </button>
                                                :
                                                <>
                                                  <button className="DataAccessEdit" style={{ width: "180px" }} onClick={() => associatetoACS(selectedDevice)}>
                                                    <span className="ViewUpdate">Save Associated Devices</span>
                                                  </button>
                                                  <button className="DataAccessEdit" style={{ width: "190px" }} onClick={cancelACSAssociation}>
                                                    <span className="ViewUpdate">Cancel Associated Devices</span>
                                                  </button>
                                                </>
                                            }
                                          </div>
                                        </>
                                        :
                                        null
                                    }

                                  </div>
                                </div>
                            }

                          </>
                          :
                          interfaceType === MOBILE
                            ?
                            <>
                              <h1 className="MainHeaderName">Mobile Details</h1>
                              <div className="siteformContainer">
                                <form>
                                  <div className="site-form" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <div className="inputMainContainer w40dot75rem">
                                      <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">Brand Name</label>
                                        <select
                                          {...register("CameraBrandId")}
                                          className="inputType ArrowSelectClass"
                                          disabled={true}
                                          placeholder="Select Brand Name"
                                          defaultValue={selectedDevice.cameraBrandId || selectedDevice.CameraBrandId}
                                          onChange={(e) => {
                                            setValue("CameraBrandId", e.target.value);
                                            handleOptionChange(e.target.value)
                                          }}
                                        >
                                          <option key="0" disabled={false} value="0">Select Brand Name*</option>
                                          {interfaceSubTypeData &&
                                            interfaceSubTypeData.map((val) => (
                                              <option
                                                value={val.InterfacesubtypeId}
                                                key={val.InterfacesubtypeId}
                                                id={val.InterfacesubtypeId}
                                              >
                                                {val.Interfacesubtypename}
                                              </option>
                                            ))}
                                          {/* {devicesmasterlist &&
                                        devicesmasterlist.cameraTypeMasterList &&
                                        devicesmasterlist.cameraTypeMasterList.map((val) => (
                                          <option value={val.brandId} key={val.brandId}>
                                            {val.brandName}
                                          </option>
                                        ))} */}
                                        </select>
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Device Name</label>
                                        <input
                                          {...register("cameraName")}
                                          className="inputType"
                                          disabled={!isDeviceEdit}
                                          placeholder="Enter Device Name* e.g. Lobby Camera"
                                          defaultValue={selectedDevice.CameraName}
                                          onKeyPress={(e) => {
                                            onSpecialChangeOnly(e);
                                            setDeviceNameError('')
                                          }}
                                          onChange={() => { setDeviceNameError('') }}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}><span>{deviceNameError}</span></p>
                                      </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Branch Name</label>
                                        <select
                                          {...register("SiteID")}
                                          className="inputType ArrowSelectClass"
                                          placeholder="Branch*"
                                          disabled={true}
                                          defaultValue={selectedDevice.SiteID}
                                          onChange={(e) => setValue("SiteID", e.target.value)}
                                        >
                                          <option key="0" disabled={false} value="0">Select Branch*</option>
                                          {sites &&
                                            sites.map((site) => (
                                              <option value={site.SiteID} key={site.SiteID}>
                                                {site.SiteName}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="inputMainContainer w40dot75rem mt35">
                                      <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Identifier Name</label>
                                        <input
                                          {...register("identifierName")}
                                          className="inputType"
                                          disabled={!isDeviceEdit}
                                          placeholder="Enter Identifier Name* e.g. Lobby Camera"
                                          defaultValue={selectedDevice.IdentifierName}
                                          onKeyPress={(e) => {
                                            onSpecialChangeOnly(e);
                                            setIdentifierError('')
                                          }}
                                          onChange={() => { setIdentifierError('') }}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}><span>{identifierError}</span></p>
                                      </div>
                                    </div>
                                  </div>

                                </form>
                              </div>
                            </>

                            :
                            <>
                              <h1 className="MainHeaderName">Panel Details</h1>
                              <div className="siteformContainer">
                                {
                                  bulkUpload
                                    ? <PanelBulkUpload
                                      selectedHeaders={selectedHeaders}
                                      onPanelBulkUpload={onPanelBulkUpload}
                                      setSelectedHeaders={setSelectedHeaders}
                                      clearImportedPanelHeaders={clearImportedPanelHeaders}
                                      setImportedFileData={setImportedFileData}
                                      panelBulkUploadResponse={panelBulkUploadResponse}
                                      setPanelBulkUploadResponse={setPanelBulkUploadResponse}
                                      panelBulkUploadError={panelBulkUploadError}
                                      setPanelBulkUploadError={setPanelBulkUploadError}
                                      setBulkUpload={setBulkUpload}
                                      setIsSingleOrBulkSelection={setIsSingleOrBulkSelection}
                                      importedPanelHeaders={importedPanelHeaders}
                                      setImportedPanelHeaders={setImportedPanelHeaders}
                                    />
                                    :
                                    <>
                                      <form>
                                        <div className="site-form" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                          <div className="inputMainContainer w40dot75rem">
                                            <div className="inputTypeLabelContainer">
                                              <label className='formFieldLabels'>Brand Name</label>
                                              <select
                                                {...register("PanelMasterId")}
                                                // className="SiteNameTextBox"
                                                className="inputType ArrowSelectClass"
                                                placeholder="Select Brand Name"
                                                disabled
                                                defaultValue={selectedDevice.panelMasterId}
                                                onChange={(e) => setValue("PanelMasterId", e.target.value)}
                                              >
                                                <option key="0" disabled={false} value="">Brand Name*</option>
                                                {interfaceSubTypeData &&
                                                  interfaceSubTypeData.map((site) => (
                                                    <option value={site.InterfacesubtypeId}
                                                      key={site.InterfacesubtypeId}
                                                      id={site.InterfacesubtypeId}>
                                                      {site.Interfacesubtypename}
                                                    </option>
                                                  ))}
                                              </select>
                                            </div>
                                          </div>

                                          <div className="inputMainContainer w40dot75rem">
                                            <div className="inputTypeLabelContainer">
                                              <label className='formFieldLabels'>Panel Name</label>
                                              <input
                                                type="text"
                                                {...register("cameraName")}
                                                className="inputType"
                                                disabled={true}
                                                placeholder="Enter Panel name* e.g. Thane panel"
                                                defaultValue={selectedDevice.CameraName}
                                                onKeyPress={onSpecialChangeOnly}
                                              />
                                            </div>
                                          </div>

                                          <div className="inputMainContainer w40dot75rem">
                                            <div className="inputTypeLabelContainer">
                                              <label className='formFieldLabels'>IP Address</label>
                                              <input
                                                {...register("privateIPAddress")}
                                                className="inputType"
                                                disabled={true}
                                                placeholder="IP address* e.g. 192.168.0.54"
                                                defaultValue={selectedDevice.privateIPAddress}
                                              />
                                            </div>
                                          </div>

                                          <div className="inputMainContainer w40dot75rem">
                                            <div className="inputTypeLabelContainer">
                                              <label className='formFieldLabels'>Site</label>
                                              <select
                                                {...register("SiteID")}
                                                className="inputType ArrowSelectClass"
                                                placeholder="Site"
                                                disabled={true}
                                                defaultValue={selectedDevice.SiteID}
                                                onChange={(e) => setValue("SiteID", e.target.value)}
                                              >
                                                <option key="0" disabled={false} value="0">Branch Name*</option>
                                                {sites &&
                                                  sites.map((site) => (
                                                    <option value={site.SiteID} key={site.SiteID}>
                                                      {site.SiteName}
                                                    </option>
                                                  ))}
                                              </select>
                                            </div>
                                          </div>
                                        </div>

                                      </form>
                                     {
                                      associateCamSecVisibility && (
                                        <PanelLicense
                                        isDeviceEdit={isDeviceEdit}
                                        setIsDeviceEdit={setIsDeviceEdit}
                                        DeviceId={selectedDevice.DeviceId}
                                        alertsChecked={alertsChecked}
                                        healthMonitoringChecked={healthMonitoringChecked}
                                        setHealthMonitoringChecked={setHealthMonitoringChecked}
                                        setAlertChecked={setAlertChecked}
                                        />
                                      )
                                     }

                                     
                                      {associateCamSecVisibility && (
                                        <ConfigurePanelZones
                                          selectedDevice={selectedDevice}
                                          devicesmasterlist={devicesmasterlist}
                                          OnAddIDSPanel={OnAddIDSPanel}
                                          deleteZone={deleteZone}
                                          setselectedZone={setselectedZone}
                                          selectedZone={selectedZone}
                                          isDeviceEdit={isDeviceEdit}
                                          selectedInterface={interfaceDevice}
                                          panelDeviceTypeOptions={panelDeviceTypeOptions}
                                          getDataAfterInterface={getDataAfterInterface}
                                        />
                                      )}
                                      {associateCamSecVisibility && (
                                        <AssociateCameraOnSensor
                                          selectedDevice={selectedDevice}
                                          onSensorSelection={onSensorSelection}
                                          associatedDevices={associatedDevices}
                                          onAssociate={onAssociate}
                                          selectedSensor={selectedSensor}
                                          selectedItems={selectedItems}
                                          setSelectedItems={setSelectedItems}
                                          isDeviceEdit={isDeviceEdit}
                                        />
                                      )}
                                    </>
                                }
                              </div>
                            </>
                    }
                    {
                      interfaceType === ACS || interfaceType === NVRDVR || interfaceType === RTU || interfaceType === FAS
                        ? null

                        // <div style={{ textAlign: "center" }}>
                        // {
                        //   bulkUpload &&
                        //   (
                        //     <button className="DataAccessEdit" style={{ width: "100px" }}
                        //     onClick={handleSubmit((e) => {
                        //       onAcsBulkUpload(e, importedAcsHeaders);
                        //     })}
                        //   >
                        //     <span className="ViewUpdate">Upload</span>
                        //   </button>
                        //   )
                        // }
                        // </div>

                        :
                        <div style={{ textAlign: "center" }}>
                          {
                            selectedDevice.ParentCameraID != 0 && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === FAS || interfaceType === RTU || interfaceType === MOBILE) &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }}
                                onClick={() => {
                                  let temp = interfaceDevice.InterfacesubtypeId;
                                  if (interfaceType === NVRDVR) {
                                    let v1 = interfaceSubTypeData?.filter(x => x?.InterfacesubtypeId == interfaceDevice?.InterfacesubtypeId);
                                    if (v1 != undefined && v1.length > 0) {
                                      temp = v1[0].InterfacesubtypeId;
                                    }
                                  } else {
                                    //let v1 = devicesmasterlist.panelTypeMasterList.filter(x => x.panelName.toLowerCase() == interfaceDevice.Interfacesubtypename.toLowerCase());
                                    let v1 = interfaceSubTypeData?.filter(
                                      (item) => item.Interfacesubtypename == interfaceDevice.Interfacesubtypename
                                    );
                                    if (v1 != undefined && v1.length > 0) {
                                      temp = v1[0].panelMasterID;
                                    }
                                  }
                                  let tempDeviceId = deviceType.find((item) => item.DeviceType == "Camera")
                                  let deviceObject = {
                                    "ParentCameraID": 0,
                                    "cameraName": '',
                                    "privateIPAddress": interfaceDevice.InterfaceIP,
                                    "SiteID": interfaceDevice.SiteId || interfaceDevice.siteid,
                                    "userName": interfaceDevice.UserName,
                                    "password": interfaceDevice.Password,
                                    "port": interfaceDevice.InterfacePort,
                                    "channelNumber": '',
                                    "liveStreamTypeNumber": '',
                                    "playbackStreamTypeNumber": '',
                                    "rTSPURL": '',
                                    "location": '',
                                    "PanelMasterId": interfaceType === NVRDVR ? 0 : temp,
                                    "CameraBrandId": temp,
                                    "communicationPort": interfaceDevice.Communicationport || interfaceDevice.communicationPortInterface,
                                    "httpPort": interfaceDevice.InternetProtocolPort || interfaceDevice.httpPortInterface,
                                    "isTranscoded": 0,
                                    "isPlaybackTranscoded": 0,
                                    "isTwoWayEnabledDevice": 0,
                                    "CCTVTypeID": interfaceDevice.EntityTypeID,
                                    "TimeZoneIdDevice": interfaceDevice.TimeZoneID || interfaceDevice.TimeZoneId,
                                    "identifierName": "",
                                    "cameraDeviceId": tempDeviceId?.DeviceTypeID || 6,
                                    "deviceStageTypeId":0
                                  }
                                  setSelectedDevice(deviceObject);
                                  setVideoBackupChecked(false);
                                  setAlertChecked(false);
                                  setHealthMonitoringChecked(false);
                                  setCamerasChecked(false);
                                  setIsDeviceEdit(true)
                                  setAssociateCamSecVisibility(false);
                                  setParentIsEncoding(false);
                                  setParentIsPlaybackEncoding(false);
                                  setParentIsEnablingTwoWayDevice(false)
                                  setParentIsEnablingTwoWayInterface(false)
                                  setParentIsEnablingPlaybackTimeStampsToUTC(false)
                                  setParentIsEnablingPlaybackLongDateFormat(false)
                                  clearCameraFields()
                                }
                                }
                              >
                                <span className="ViewUpdate">Add New</span>
                              </button>
                            )
                          }
                          {/* rupesh gupta */}
                          {/* {
                            selectedDevice.ParentCameraID == 0 && interfaceType === NVRDVR && !bulkUpload &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => handleBulkUploadClick()}>
                                <span className="ViewUpdate">Bulk upload</span>
                              </button>
                            )
                          } */}
                          {
                            selectedDevice.ParentCameraID == 0 && interfaceType === NVRDVR && bulkUpload &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }}
                                onClick={handleSubmit((e) => {
                                  OnAddBulkDevicesClick(e, importedFileHeaders);
                                })}
                              >
                                <span className="ViewUpdate">Upload</span>
                              </button>
                            )
                          }
                          {/* {
                            interfaceType === PANEL && !bulkUpload &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => handleBulkUploadClick()}>
                                <span className="ViewUpdate">Bulk upload</span>
                              </button>
                            )
                          } */}
                          {
                            interfaceType === PANEL && bulkUpload &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }}
                                onClick={handleSubmit((e) => {
                                  onPanelBulkUpload(e, importedPanelHeaders);
                                })}
                              >
                                <span className="ViewUpdate">Upload</span>
                              </button>
                            )
                          }
                          {
                            selectedDevice.ParentCameraID != 0 && !isDeviceEdit && selectedDevice.panelMasterId != 0 && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === FAS || interfaceType === RTU || interfaceType === MOBILE) &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }}
                                onClick={() => {
                                  setIsDeviceEdit(true);
                                }}
                              >
                                <span className="ViewUpdate">Edit</span>
                              </button>
                            )
                          }

                          {
                            selectedDevice.ParentCameraID == 0 && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === FAS || interfaceType === RTU || interfaceType === MOBILE ) && !bulkUpload &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }}
                                onClick={handleSubmit((e) => {
                                  if (interfaceType === NVRDVR) {
                                    OnSaveDevice(e, selectedDevice.ParentCameraID)
                                  } else {
                                    // Call Function of saving ACS device
                                    onSaveACS(e, selectedDevice.DeviceId)
                                  }
                                }
                                )}
                                disabled={isSubmitting}
                              >
                                <span className="ViewUpdate">Save</span>
                              </button>
                            )
                          }
                          {
                            selectedDevice.ParentCameraID != 0 && isDeviceEdit && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === FAS || interfaceType === RTU || interfaceType === MOBILE) &&
                            (
                              <>
                                <button className="DataAccessEdit" style={{ width: "100px" }}
                                  onClick={handleSubmit((e) => {
                                    if (interfaceType === NVRDVR) {
                                      OnSaveDevice(e, selectedDevice.ParentCameraID)
                                    } else {
                                      onSaveACS(e, selectedDevice.DeviceId) //selectedDevice.ParentCameraID
                                      // Call Save Function of updating ACS device.
                                    }
                                  })}
                                  disabled={isSubmitting}
                                >
                                  <span className="ViewUpdate">Save</span>
                                </button>
                                <button className="DataAccessEdit" style={{ width: "100px" }} onClick={(e) => onCancelDevice(e)}>
                                  <span className="ViewUpdate">Cancel</span>
                                </button>
                              </>
                            )
                          }
                          {
                            selectedDevice.ParentCameraID != 0 && !isDeviceEdit && (interfaceType === NVRDVR || interfaceType === ACS || interfaceType === PANEL || interfaceType === FAS || interfaceType === RTU || interfaceType === MOBILE) &&
                            (
                              <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => {
                                interfaceType === NVRDVR
                                  ? checkForAlertsAndDelDevice(selectedDevice)
                                  : interfaceType === ACS || interfaceType === FAS || interfaceType === RTU
                                    ? checkForAlertsAndDelDevice(selectedDevice)
                                    : checkForAlertsAndDelDevice(selectedDevice)
                              }}>
                                <span className="ViewUpdate">Delete</span>
                              </button>
                            )
                          }
                        </div>
                    }

                  </div>
                  </div>
            }

            <Modal size="lg" show={show} onHide={() => setShow(false)} dialogClassName="modal-90w" backdrop="static" className="AddCustomerModal">
              <>
                <Modal.Header >
                  <Modal.Title id="example-custom-modal-styling-title">
                    Add Customer
                  </Modal.Title>
                  <img
                    src={RemoveIcon}
                    alt="Remove"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShow(false)
                      setAddCustomerError('')
                    }}
                  />
                </Modal.Header>

                <Modal.Body>
                  <div className="inputMainContainer w40dot75rem w-100">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>Customer Name</label>
                      <input style={{ width: "40vw" }}
                        type="text"
                        className="inputType"
                        placeholder="Add Customer"
                        {...register("AddCustomerName")}
                        onChange={(e) => setAddCustomerError('')}
                      />
                      <p className="Error_P" style={{ float: "left" }}><span>{addCustomerError}</span></p>
                    </div>
                  </div>
                  <div style={{textAlign: "center"}}> 
                  <button className="DataAccessEdit mt-3" style={{ width: "250px" }} onClick={addCustomer}>
                    <span className="ViewUpdate">Add</span>
                  </button>
                  </div>
                </Modal.Body>
              </>
            </Modal>
          </div>
        </div>
    </>
  );
});

export default AddSiteForm